import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

let lang = window.localStorage.getItem("languageCode") || 'zh_cn'

const messages = {
  zh_cn: {
    "flowLists": {
      "incomeTr": "收入",
      "flowNumber": "流水号",
      "flowListsTitle": "流水明细",
      "createTime": "日期",
      "ebalanceAmount": "余额",
      "detailTr": "详情",
      "expenditureTr": "支出",
      "remarkType": "摘要"
    },
    "contractManage": {
      "upTime": "上传时间",
      "download": "下载",
      "chainCode": "链码",
      "query": "查询",
      "function": "功能",
      "orderNum": "序号",
      "contName": "合同名称",
      "corrFinNum": "对应融资单号",
      "contTitle": "合同管理"
    },
    "frontPage": {
      "Error404": "路径不存在，请检查路径是否正确",
      "annualIncome": "年化收益",
      "z_currency": "Z币",
      "missSendEmailType": "缺失发送邮件类型",
      "back": "返回",
      "UploadFailure": "上传失败",
      "CurrencyDollar": "美元",
      "updateEmailSendCode": "修改邮箱验证码",
      "missEmailTemplate": "缺失邮件模板",
      "CurrencyHongKong": "香港美元",
      "missSubject": "缺失邮件标题",
      "noTime": "暂无",
      "missUserId": "缺失发送目标用户ID",
      "missFile": "文件缺失",
      "startTime": "开始时间",
      "accountTypeMiss": "用户类型不能为空",
      "NotFile": "文件格式不正确，请重新上传！",
      "login_timeout": "登录超时",
      "Error500": "系统异常,请联系管理员",
      "moneyArrivaNotice": "到账通知",
      "CurrencyJPY": "日元",
      "missUserType": "缺失用户类型",
      "selectTime": "请选择时间",
      "miss_field_version": "缺失版本号",
      "fileCodeCannotEmpty": "文件唯一标识不能为空",
      "uploadPersonNotNull": "上传人不能为空",
      "missEmail": "缺失邮箱",
      "l_currency": "法币",
      "missEmailParam": "缺失邮件参数",
      "miss_token": "缺失token",
      "notPicType": "不是图片类型",
      "youHaveNoPermission": "您没有下载该文件的权限",
      "fileIsNullOrDeleted": "文件不存在,或者已被删除",
      "drawSendCode": "提现验证码",
      "businessTypeCannotEmpty": "文件来源不能为空",
      "CurrencyRMB": "人民币",
      "checkFrontFileSafe": "当前上传图片未通过安全检测",
      "businessCodeCannotEmpty": "文件来源唯一标识不能为空",
      "noData": "暂无数据",
      "endTime": "截止时间",
      "pleaseChoose": "请选择",
      "time": "时间",
      "notEmpty": "不能为空",
      "CurrencySingapore": "新加坡",
      "status": "状态"
    },
    "bonusApply": {
      "200007": "分红基础数据异常",
      "bonusApplyInputPlaceHolder": "当前可分红余额",
      "200006": "申请金额大于可用分红余额",
      "200009": "批量用户账号的资金失败",
      "200008": "批量更新定期分红失败",
      "200003": "数据发生变更，请刷新页面",
      "200002": "您已禁止分红，请联系管理员",
      "200005": "转出金额不为空！",
      "200004": "数据异常，请联系系统管理员",
      "200010": "批量用户活期分红失败",
      "200012": "开始日期不能为空",
      "200011": "用户资金账号表数据异常",
      "bonusApplyInputLabel": "申请分红",
      "bonusApplyType1": "活期",
      "100013": "参数异常",
      "bonusApplyType2": "定期",
      "btn": "开始获得分红",
      "bonusApplyTitle": "分红申请",
      "bonusApplyInputErr2": "输入数字大于0小于当前可用分红且最多2位小数",
      "bonusApplyTip1": "*您还有一笔融资款将于",
      "200013": "结束日期不能为空",
      "bonusApplyInputErr1": "请输入金额",
      "bonusApplyTip2": "需还款",
      "200001": "未登录",
      "bonusApplySuccess": "申请分红成功"
    },
    "login": {
      "VerificationCodeMissing": "请输入验证码",
      "rongziwei": "融资申请为CIC向特定用户群体提供的基于区块链虚拟货币技术的大宗B2B快速贸易融资功能",
      "nameOrPwdError": "用户名或密码错误",
      "jiesheng": "节省传统贸易的信用证费用",
      "InvalidCaptchaKey": "失效的验证码key",
      "pleasePassword": "请输入密码",
      "bushouxianzhi": "不受时间和地理限制的转账",
      "login": "登录",
      "title": "让交易平滑至简",
      "myAcc": "我的账户",
      "pleaseUsername": "请输入账号",
      "logout": "退出登录",
      "myFinancing": "我的融资",
      "xinyong": "信用可拆分",
      "pleaseKaptcha": "请输入验证码",
      "nianlilv": "低至3.1%的年化融资利率",
      "validCodeError": "验证码错误",
      "validCodeExpired": "验证码已过期",
      "userNotExit": "用户不存在",
      "loginDisabled": "账户已被禁用",
      "fuwu": "若您有意向使用该项服务，请拨打服务热线",
      "coin": "币"
    },
    "cashApply": {
      "exMoney": "申请提现",
      "availableCredit": "可用余额",
      "select": "请选择",
      "bankCard": "提现银行卡",
      "sendCode": "发送验证码",
      "available": "请输入提取额 当前",
      "title": "Z币提现申请",
      "emCode": "请输入收到的邮箱安全验证码",
      "cashApply": "申请提现",
      "confCash": "确认提现",
      "tips": "* 平台不会收取任何费用，提现涉及的银行手续费将由银行收取，并在实际到账金中扣除。",
      "newBank": "+新增银行卡",
      "cashConf": "提现确认",
      "usable": "可用",
      "sentSuccess": "发送验证码成功，请进邮箱查看",
      "moneyValue": "币种",
      "sumCredit": "我的Z币总额",
      "useAmount": "Z币提取额",
      "coin": "Z币"
    },
    "bank": {
      "300016": "收款人名称最大长度100",
      "300005": "地区不为空",
      "300006": "银行全称不为空",
      "300017": "收款人账户最大长度100",
      "300003": "卡号重复，请重新输入",
      "300014": "swift代码最大长度100",
      "300015": "收款人名称最大长度200",
      "300004": "登录信息不为空",
      "300009": "收款人名称不为空",
      "300007": "swift代码不为空",
      "300018": "币种最大长度100",
      "300019": "登录人id不为空",
      "300008": "银行详细地址不为空",
      "300020": "主键id不为空",
      "300023": "用户id不为空",
      "300012": "国家code最大长度200",
      "300001": "请登录",
      "300013": "银行全称最大长度200",
      "300024": "数据发生变更，请刷新页面",
      "300002": "获取用户id失败",
      "300010": "收款人账户不为空",
      "300022": "卡号不为空",
      "300011": "币种不为空"
    },
    "chainDetails": {
      "add": "新增",
      "fileName": "文件名",
      "dataType": "数据类型",
      "clickToDownload": "点击下载",
      "update": "更新",
      "fileInfo": "文件信息",
      "remark": "备注",
      "title": "标题",
      "completeInfo": "完整信息",
      "chainDetails": "区块链详情",
      "summaryInfo": "摘要信息",
      "downloadLink": "下载地址",
      "dataOverview": "数据概况",
      "report": "举报",
      "reportDescription": "举报说明",
      "lastData": "下一数据",
      "platformName": "平台名称",
      "value": "内容",
      "fileType": "文件类型",
      "preData": "上一数据"
    },
    "bankList": {
      "cancel": "取消",
      "country": "地区",
      "proceedName": "收款人名称",
      "bankCreate": "创建银行卡",
      "bankFullName": "银行全称",
      "swiftCode": "SWIFT代码",
      "proceedAccount": "收款人账号",
      "title": "银行账号管理",
      "bankAdd": "新增账号",
      "confirm": "确定",
      "delConf": "确定删除此银行账号吗?",
      "detailedAddress": "银行详细地址",
      "supportCurrency": "支持币种"
    },
    "bonusLists": {
      "all": "全部",
      "serialNumberTr": "流水号",
      "originalMoneyTr": "分红本金",
      "annualIncomeTr": "分红收益率",
      "createTimeTr": "日期",
      "bonusListsTitle": "分红管理",
      "lastInterestDateTr": "分红结算日期",
      "statusTr": "状态",
      "detailTr": "详情",
      "bonusListsApplyBtn": "申请分红",
      "typeTr": "摘要",
      "dividend": "分红中",
      "turnToLive": "定转活",
      "issued": "已发放"
    },
    "extractCrashLists": {
      "hasBeenTransferredOut": "已转出",
      "all": "全部",
      "flowNumberTr": "流水号",
      "createTimeTr": "日期",
      "extractCrashListsTitle": "提现明细",
      "statusTr": "状态",
      "detailTr": "详情",
      "withdrawalBankTr": "提现银行",
      "serviceChargeTr": "手续费",
      "application": "申请中",
      "amountExtractionTr": "提现额",
      "turnOutAmountTr": "转出金额",
      "remarkTr": "摘要"
    },
    "financing": {
      "all": "全部",
      "andTranscationg": "关联交易",
      "financing_completed": "融资完成",
      "financingaplicationAmount": "融资申请金额",
      "aplicationTime": "申请时间",
      "application_status_repayment": "待还款",
      "view": "查询",
      "pleaseWrite": "请输入",
      "financingandOrderNum": "融资关联订单号",
      "draft": "草稿",
      "function": "功能",
      "financingaplicationNum": "融资申请号",
      "financing": "我的融资",
      "financingStatus": "融资状态",
      "details": "详情",
      "startTime": "开始时间",
      "noData": "暂无数据",
      "reimbursement": "还款",
      "endTime": "截止时间",
      "still_hospitality_confirmation": "还款待确认",
      "financingNumber": "融资流水号",
      "status": "状态",
      "coin": "币"
    },
    "flowListsType": {
      "1": "转出",
      "2": "融资还款转出",
      "3": "分红转入",
      "4": "分红转出",
      "5": "融资转入"
    },
    "resetpassword": {
      "newPasswordCannotSame": "新密码不能与原始密码相同",
      "PasswordFormatIncorrect": "密码格式不正确，请更改",
      "newPasswordNotFormatted": "新密码长度格式不正确，请更改",
      "originalPasswordIncorrectly": "原密码输入错误",
      "passwordIsInconsistent": "密码跟确认密码不一致"
    },
    "moneyChangeLog": {
      "100010": "开始日期不能为空",
      "100011": "结束日期不能为空",
      "100009": "数据发生变更，请刷新页面",
      "100001": "用户id不为空",
      "100012": "人员信息为空",
      "100002": "摘要类型所在表的主键id不为空",
      "100013": "参数异常",
      "100014": "数据异常",
      "100003": "摘要类型不为空",
      "100004": "金额类型不为空",
      "100005": "金额不为空",
      "100006": "请登录",
      "100007": "获取用户id失败",
      "100008": "无流水数据导出"
    },
    "bonusDetail": {
      "tqzq": "提取支取",
      "fh": "分红",
      "expectIncome": "预期收益",
      "bj": "本金",
      "type": "分红类型",
      "tips": "警告：若未到期提前解锁，将按照已理财时间计算活期利息！",
      "200004": "数据异常",
      "principal": "解锁本金",
      "bonusRegularDetailTime": "时间",
      "unlockSuccess": "解锁成功",
      "startAndEndTime": "分红方案起止日期",
      "bonusRegularDetailStatus": "计息类型",
      "tqSuccess": "提取成功",
      "lastInterestDate": "分红到账日期",
      "interest": "实际收益",
      "ljsy": "累计收益",
      "bonusRegularDetailOriginalMoney": "本金",
      "jshzce": "解锁后转出额",
      "serialNumber": "流水号",
      "bonusRegularDetailInterest": "分红",
      "jxr": "计息日",
      "bonusDetailTitle": "分红单",
      "tqTitle": "提取",
      "mrfhjsb": "每日分红结算表",
      "100009": "数据发生变更，请刷新页面",
      "bonusWay": "分红方案",
      "dqjbe": "当前基本额",
      "tqjsTitle": "提前解锁",
      "jsb": "结算表",
      "originalMoney": "分红基本额"
    },
    "nav": {
      "index": "我的账户"
    },
    "accountcenter": {
      "emailNotExist": "请先设置邮箱",
      "sendCodeMail": "发送验证码至当前邮箱",
      "safeMail": "安全邮箱",
      "chainData": "上链数据",
      "bankCard": "银行卡",
      "sendMailFrequently": "请勿频繁发送邮件，时效10分钟",
      "emailFormatError": "邮箱格式错误",
      "missCode": "缺失验证码",
      "back": "返回",
      "lastMailTime": "最近一次发送邮件时间",
      "sendEmailError": "发送邮件失败",
      "lastMailType": "最近一次发送邮件",
      "theEmailHasBeenUsed": "该邮箱已被使用",
      "manageBankCard": "管理银行卡",
      "cofirm": "请验证新邮箱",
      "accCenter": "账户中心",
      "getWeb": "查看网站",
      "myBankCard": "我的银行卡",
      "emailLengthError": "邮箱长度格式错误",
      "sendSuc": "发送成功",
      "safePhone": "安全手机",
      "editEmailError": "更新邮箱失败",
      "errorCodeTypeParam": "验证码类型参数错误",
      "missEmail": "缺失邮箱",
      "sendCOde": "发送验证码",
      "missEmailParam": "缺失邮箱参数",
      "accSafe": "账号安全",
      "codeInvalid": "验证码已失效",
      "blockChain": "区块链",
      "resetSuc": "修改成功",
      "trade": "交易",
      "myTradeAcc": "我的交易账户",
      "pleaseNewMail": "请输入新邮箱",
      "pleaseCode": "请输入验证码",
      "codeError": "验证码错误",
      "safe": "安全",
      "youHaveBoundTheEmail": "该邮箱您已绑定",
      "nextStep": "下一步",
      "verifyMail": "提交",
      "resetMail": "修改邮箱",
      "cic": "世界商品智能交易中心",
      "myWebAcc": "我的数字账户",
      "rongzi": "融资理财"
    },
    "financingDetails": {
      "seller": "卖方",
      "repaymentAmountLimit": "还款金额请输入大于0小于1000000000的数",
      "reason": "原因",
      "amountLessThanAvailable": "还款金额不能大于可用余额",
      "getFinancingDetailFail": "查询融资详情失败",
      "pleaseSelectAcountCard": "请选择还款账户",
      "lookrepaymentAmount": "还款金额",
      "hasComfimed": "已确认",
      "financingContractInfor": "融资合约合同信息",
      "legalMoney": "法币",
      "dueInfo": "还款信息",
      "regCode": "注册编码",
      "flowNumber": "融资申请流水号",
      "wrongAccount": "您没有查看该数据的权限",
      "financingMethod": "融资发放方式",
      "expectedRepaymentPeriod": "期望还款期限",
      "isLocked": "发放后是否锁定",
      "doNotInsertRepaymentByState": "当前融资数据有待确认或待修改的还款记录,不允许新增",
      "acountMustInput": "还款金额必填",
      "details": "详情",
      "reimbursement": "还款",
      "applicationAccount": "申请人账号",
      "comfirm": "确定",
      "repaymentAccountIdNotNull": "汇款账号不能为空",
      "systemComfim": "系统确认",
      "companyCode": "请输入公司注册码",
      "overdueAmount": "追加还款金额",
      "upLoadenclosureCode": "上传附件",
      "viewLook": "查看",
      "repaymentTypeNotNull": "还款方式不能为空",
      "authCodeStr": "认证类型",
      "dueTime": "还款时间",
      "salesOrder": "交易销售订单",
      "newdue": "新增还款",
      "buyer": "买方",
      "pleaseChoseBill": "请选择币种",
      "pleaseSelectPaymethod": "请选择还款方式",
      "financingStartTime": "融资开始日期",
      "orderAcount": "订单金额",
      "guaranteeType": "担保类型",
      "financingUse": "融资用途",
      "uploadAttachmentsNotEmpty": "附件不能为空",
      "payeeAccountCanuseNow": "当前可用还款额",
      "repaymentAccount": "融资还款账号",
      "countryName": "国家",
      "payeeAccount": "汇款账号",
      "coin": "币",
      "repaymentMethod": "还款方式",
      "addoverdueAmount": "追加金额",
      "no": "否",
      "financingaplayBook": "融资申请书",
      "currencyTypeNotNull": "币种不能为空",
      "pleaseSelectremittanceA": "请选择汇款账号",
      "currentAccountDoNotInsert": "当前登录人不可还款",
      "enclosureCode": "附件",
      "repaymentAmountNotNull": "还款金额不能为空",
      "orderNum": "订单号",
      "dorla": "美元",
      "doNotInsertRepayment": "融资单已完成,不可新增还款单",
      "grantAccount": "融资发放账号",
      "financingEndTime": "融资到期日期",
      "repaymentSource": "还款来源",
      "newBusinessLicense": "新营业执照",
      "additionalPaymentInfo": "追加还款信息",
      "aplicationFee": "利息",
      "applicationMoney": "申请金额",
      "close": "关闭",
      "LockAcountNow": "当前锁定Z币额",
      "certificateImage": "证书图片",
      "oldBusinessLicense": "旧营业执照",
      "dueMethods": "还款方式",
      "financingApplicationInfor": "融资合约申请信息",
      "yes": "是",
      "repaymentIdNotNull": "还款流水id不能为空",
      "waitToModify": "待修改",
      "additionalPayments": "追加还款额",
      "waitToComfim": "未确认",
      "billChoose": "币种选择",
      "modify": "修改",
      "financingMoney": "融资金额",
      "pleaseInputAmonut": "请输入金额",
      "createTime": "记录时间",
      "dueAmount": "还款额",
      "purchaseOrder": "交易采购订单",
      "pleaseUploadFile": "请上传文件",
      "10001": "金额输入不合法",
      "zCoin": "Z币",
      "addremark": "追加原因",
      "tradingContract": "交易合同",
      "fileUploadMaximumOf5": "文件最多上传5个",
      "account": "账户",
      "repaymentTime": "还款时间点",
      "return": "返回"
    },
    "home": {
      "accountTotalMoney": "账户总额",
      "safeMail": "安全验证邮箱",
      "getDicDataFailed": "字典表获取数据失败",
      "bonusShenqing": "分红申请",
      "accFlowLists": "账户流水",
      "cashRecord": "提现记录",
      "accountcenter": "账户中心",
      "bankAcc": "银行账户",
      "cashApply": "提现申请",
      "accInfo": "账户信息",
      "availableBalance": "可用余额",
      "manage": "管理",
      "lastLoginTime": "上次登录时间",
      "bonusSuoding": "分红锁定",
      "addAcc": "新增账号",
      "bonusShouyi": "分红收益",
      "contactNumber": "联系电话",
      "languageCannotNull": "语言不能为空",
      "lastRevenue": "最近一笔流水",
      "fax": "传真",
      "freezingQuota": "冻结额度",
      "contacts": "联系人",
      "bonusGuanli": "分红管理"
    },
    "extractCrashStatus": {
      "0": "全部",
      "1": "申请中",
      "2": "已转出"
    },
    "withdrawCash": {
      "400002": "请选择提现币种",
      "400013": "账户余额不足",
      "400003": "请填写提现金额",
      "400014": "验证码失效",
      "400011": "不具备提现操作权限",
      "400001": "请填写验证码",
      "400012": "参数错误",
      "400010": "尚未设置邮箱，请设置安全邮箱",
      "400008": "提现成功",
      "400009": "详情id不能为空",
      "400006": "邮件发送过于频繁，请稍后再试",
      "400017": "数据发生变更，请刷新页面",
      "400007": "验证码输入错误",
      "400004": "请选择提现银行卡",
      "400015": "提现失败",
      "400005": "暂无数据导出",
      "400016": "提现金额非法"
    },
    "btns": {
      "cancel": "取消",
      "tqjs": "提前解锁",
      "ensureUnlock": "确认解锁",
      "query": "查询",
      "detail": "详情",
      "ensureExtract": "确认提取",
      "downLoadData": "下载数据",
      "tq": "提取"
    },
    "depositStatus": {
      "0": "全部",
      "1": "分红中",
      "2": "已发放",
      "3": "定转活"
    },
    "extractCrashDetail": {
      "proceedName": "收款人名称",
      "remittanceDate": "汇款时间",
      "turnOutAmount": "汇款金额",
      "swiftCode": "提现SWIFT代码",
      "bankName": "银行全称",
      "proceedAccount": "收款人账号",
      "transferBankAccount": "汇款账号",
      "tips": "*若银行未到账请联系您提现账号银行客服进行查询，若有进一步疑问可拨打电话【+65 6379 1324 】",
      "amountExtraction": "申请提现",
      "flowNumber": "提现流水号",
      "serviceCharge": "手续费",
      "detailedAddress": "银行详细地址",
      "moneyLable": "提现币种",
      "transferBankName": "汇款银行",
      "fileList": "转出证明文件",
      "extractCrashDetailTitle": "提现详情"
    },
    "extractType": {
      "1": "银行提现"
    },
    "depositType": {
      "1": "活期",
      "2": "定期"
    },
    "chaincount": {
      "myHome": "我的账户",
      "all": "全部",
      "chainCount": "区块链统计",
      "serialNumber": "业务流水号",
      "financingApply": "融资申请",
      "bonusApply": "分红申请",
      "profitBonus": "收益分红",
      "handle": "处理中",
      "fail": "失败",
      "appendRepayment": "融资追加还款",
      "transferActivity": "传输活动",
      "success": "成功",
      "chainSum": "上链总数",
      "details": "详情",
      "state": "状态",
      "cash": "提现",
      "day": "天",
      "chainTime": "上链时间",
      "financingLoan": "融资放款",
      "repayment": "融资还款"
    }
  },
  en: {
    "flowLists": {
      "flowNumber": "Transaction ID",
      "incomeTr": "income",
      "flowListsTitle": "Flow detail",
      "createTime": "date",
      "ebalanceAmount": "Balance",
      "detailTr": "Details",
      "remarkType": "Description",
      "expenditureTr": "expenditure"
    },
    "contractManage": {
      "upTime": "Upload time",
      "download": "download",
      "chainCode": "Chain code",
      "function": "Features",
      "query": "Inquire",
      "orderNum": "Serial number",
      "contName": "contract title",
      "corrFinNum": "Corresponding financing number",
      "contTitle": "Contract management"
    },
    "frontPage": {
      "Error404": "The path does not exist, please check if the path is correct.",
      "annualIncome": "Annualized income",
      "z_currency": "Z coin",
      "missSendEmailType": "Missing send message type",
      "back": "Return",
      "UploadFailure": "upload failed",
      "CurrencyDollar": "Dollar",
      "updateEmailSendCode": "Modify the mailbox verification code",
      "missEmailTemplate": "Missing mail template",
      "CurrencyHongKong": "Hong Kong dollar",
      "missSubject": "Missing message header",
      "noTime": "No",
      "missUserId": "Missing send destination user id",
      "missFile": "Missing file",
      "startTime": "Starting time",
      "accountTypeMiss": "User type cannot be empty",
      "NotFile": "The file format is incorrect, please re-upload!",
      "login_timeout": "Login timeout",
      "Error500": "The system is abnormal. Please contact the administrator.",
      "moneyArrivaNotice": "Arrival notice",
      "CurrencyJPY": "JPY",
      "missUserType": "Missing user type",
      "selectTime": "Please select time",
      "miss_field_version": "Missing version number",
      "fileCodeCannotEmpty": "File unique identifier cannot be empty",
      "uploadPersonNotNull": "Uploader cannot be empty",
      "missEmail": "Missing mailbox",
      "l_currency": "Legal currency",
      "missEmailParam": "Missing mail parameters",
      "miss_token": "Loss token",
      "notPicType": "Not image type",
      "youHaveNoPermission": "You do not have permission to download the file",
      "fileIsNullOrDeleted": "The file does not exist or has been deleted",
      "drawSendCode": "Cashout verification code",
      "businessTypeCannotEmpty": "File source cannot be empty",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "Currently uploaded image failed security check",
      "businessCodeCannotEmpty": "File source unique identifier cannot be empty",
      "noData": "No data",
      "endTime": "deadline",
      "time": "Date Range",
      "pleaseChoose": "please choose",
      "notEmpty": "Can not be empty",
      "CurrencySingapore": "Singapore",
      "status": "Status"
    },
    "bonusApply": {
      "200007": "The dividend basic data is abnormal.",
      "bonusApplyInputPlaceHolder": "Available Amount for Fixed Rate Divident",
      "200006": "The application amount is greater than the available dividend balance",
      "200009": "Failed to fund a batch user account",
      "200008": "Batch update periodic dividends failed",
      "200003": "The data has changed, please refresh the page",
      "200002": "You have forbidden dividends, please contact the administrator",
      "200005": "The transfer amount is not empty!",
      "200004": "The data is abnormal, please contact the system administrator",
      "200010": "Batch user live dividends failed",
      "200012": "Start date cannot be empty",
      "200011": "User funds account table data is abnormal",
      "bonusApplyInputLabel": "Apply for dividends",
      "bonusApplyType1": "current",
      "100013": "Abnormal parameter",
      "bonusApplyType2": "Fixed Rate",
      "btn": "Start to Get Divident",
      "bonusApplyTitle": "Apply for Divident",
      "bonusApplyInputErr2": "Input number greater than 0 is less than the current available dividend and up to 2 decimal places",
      "bonusApplyTip1": "*You still have a financing payment will be",
      "200013": "End date cannot be empty",
      "bonusApplyInputErr1": "Please enter the amount",
      "bonusApplyTip2": "Repayment required",
      "200001": "Not logged in",
      "bonusApplySuccess": "Successful application for dividends"
    },
    "login": {
      "VerificationCodeMissing": "please enter verification code",
      "rongziwei": "The ZB-TONE Platform from ZALLCHAIN is rewiring trade finance through our innovative solution to bring buyers, suppliers and financiers together on a blockchain-led trade finance platform.  Join the ZB-TONE Platform today!",
      "nameOrPwdError": "wrong user name or password",
      "jiesheng": "Save the cost of traditional trade letters of credit",
      "InvalidCaptchaKey": "Expired verification key",
      "pleasePassword": "Please enter your password",
      "bushouxianzhi": "Transfers that are not subject to time and geographic restrictions",
      "login": "Login",
      "title": "Smooth the transaction to Jane",
      "myAcc": "My Account",
      "pleaseUsername": "Please input Username",
      "logout": "sign out",
      "myFinancing": "My Financing",
      "xinyong": "Credit detachable",
      "pleaseKaptcha": "please enter verification code",
      "nianlilv": "Annualized financing rate as low as 3.1%",
      "validCodeError": "Verification code error",
      "validCodeExpired": "Verification code has expired",
      "userNotExit": "User does not exist",
      "loginDisabled": "Account has been disabled",
      "fuwu": "If you would like to register to receive updates on our platform, or indicate interest to participate on ZB-TONE as an investor or an issuer, please contact us @. Our Client Services Team will get in touch with you.",
      "coin": "currency"
    },
    "cashApply": {
      "exMoney": "Withdraw Amount",
      "availableCredit": "Available Balance",
      "select": "please choose",
      "bankCard": "Bank Account",
      "sendCode": "Send the verification code",
      "available": "Please enter the withdrawal amount currently",
      "title": "z coin withdrawal application",
      "emCode": "Please enter the received email security verification code",
      "cashApply": "Withdraw Amount",
      "confCash": "Confirm withdrawal",
      "tips": "* The platform will not charge any fees, and the bank charges involved in the withdrawal will be collected by the bank and deducted from the actual account.",
      "newBank": "+Add a bank card",
      "cashConf": "Withdraw Confirmation",
      "usable": "Available",
      "sentSuccess": "Send verification code is successful, please go to the mailbox to view",
      "moneyValue": "Currency",
      "sumCredit": "My total amount of c coins",
      "useAmount": "Z currency withdrawal amount",
      "coin": "Z coin"
    },
    "bank": {
      "300005": "The area is not empty",
      "300016": "Payee name maximum length 100",
      "300017": "Payee account maximum length 100",
      "300006": "Bank full name is not empty",
      "300003": "The card number is repeated, please re-enter",
      "300014": "Swift code maximum length 100",
      "300015": "Payee name maximum length 200",
      "300004": "Login information is not empty",
      "300009": "Payee name is not empty",
      "300007": "Swift code is not empty",
      "300018": "Currency maximum length 100",
      "300019": "Login person id is not empty",
      "300008": "Bank detailed address is not empty",
      "300020": "Primary key id is not empty",
      "300023": "User id is not empty",
      "300012": "Country code maximum length 200",
      "300001": "please sign in",
      "300024": "The data has changed, please refresh the page",
      "300002": "Failed to get user id",
      "300013": "Bank full name maximum length 200",
      "300010": "Payee account is not empty",
      "300011": "Currency is not empty",
      "300022": "Card number is not empty"
    },
    "chainDetails": {
      "add": "Add",
      "fileName": "file name",
      "dataType": "type of data",
      "clickToDownload": "click to download",
      "fileInfo": "File information",
      "update": "Update",
      "remark": "Remarks",
      "title": "title",
      "completeInfo": "Complete information",
      "chainDetails": "Blockchain details",
      "downloadLink": "download link",
      "summaryInfo": "Summary information",
      "dataOverview": "Data overview",
      "report": "Report",
      "reportDescription": "Report description",
      "lastData": "Next data",
      "platformName": "Platform name",
      "value": "content",
      "fileType": "file type",
      "preData": "Previous data"
    },
    "bankList": {
      "cancel": "cancel",
      "proceedName": "Account Name",
      "country": "area",
      "bankFullName": "Bank Name",
      "bankCreate": "Create a bank card",
      "swiftCode": "Swift Code",
      "proceedAccount": "Account Number",
      "title": "Bank account management",
      "bankAdd": "Add account",
      "confirm": "determine",
      "delConf": "Are you sure you want to delete this bank account?",
      "detailedAddress": "Bank Address",
      "supportCurrency": "Support currency"
    },
    "bonusLists": {
      "all": "All",
      "originalMoneyTr": "Dividend principal",
      "annualIncomeTr": "Dividend yield",
      "serialNumberTr": "Transaction ID",
      "createTimeTr": "Date",
      "lastInterestDateTr": "Dividend settlement date",
      "bonusListsTitle": "Dividend management",
      "statusTr": "Status",
      "detailTr": "Detail",
      "bonusListsApplyBtn": "Apply for dividends",
      "typeTr": "Description",
      "dividend": "Dividend",
      "turnToLive": "Turn to live",
      "issued": "Issued"
    },
    "extractCrashLists": {
      "all": "All",
      "hasBeenTransferredOut": "Has been transferred out",
      "flowNumberTr": "Transaction ID",
      "createTimeTr": "Date",
      "extractCrashListsTitle": "Cash withdrawal details",
      "statusTr": "Status",
      "detailTr": "Detail",
      "withdrawalBankTr": "Bank Account",
      "serviceChargeTr": "Processing Fee",
      "application": "Application",
      "amountExtractionTr": "Withdraw Amount",
      "turnOutAmountTr": "Transfer amount",
      "remarkTr": "Description"
    },
    "financing": {
      "all": "All",
      "andTranscationg": "Related party transaction",
      "financing_completed": "Financing completed",
      "financingaplicationAmount": "Financing application amount",
      "aplicationTime": "application time",
      "application_status_repayment": "Repayment",
      "view": "Search",
      "pleaseWrite": "please enter",
      "financingandOrderNum": "Financing associated order number",
      "draft": "draft",
      "function": "Features",
      "financingaplicationNum": "Financing application number",
      "financing": "My financing",
      "startTime": "Start",
      "noData": "No data",
      "financingStatus": "Financing status",
      "details": "Detail",
      "endTime": "deadline",
      "reimbursement": "Repayment",
      "still_hospitality_confirmation": "Still hospitality confirmation",
      "financingNumber": "Financing serial number",
      "status": "Status",
      "coin": "ZB"
    },
    "flowListsType": {
      "1": "Transfer out",
      "2": "Financing repayment",
      "3": "Dividend transfer",
      "4": "Dividend transfer",
      "5": "Financing transfer"
    },
    "resetpassword": {
      "newPasswordCannotSame": "The new password cannot be the same as the original password",
      "PasswordFormatIncorrect": "The password format is incorrect, please change",
      "newPasswordNotFormatted": "The new password length is not formatted correctly, please change",
      "originalPasswordIncorrectly": "The original password was entered incorrectly.",
      "passwordIsInconsistent": "The password is inconsistent with the confirmation password"
    },
    "moneyChangeLog": {
      "100010": "Start date cannot be empty",
      "100011": "End date cannot be empty",
      "100009": "The data has changed, please refresh the page",
      "100001": "User id is not empty",
      "100012": "Personnel information is empty",
      "100002": "The primary key id of the table where the summary type is located is not empty.",
      "100013": "Abnormal parameter",
      "100003": "Summary type is not empty",
      "100014": "Abnormal data",
      "100004": "The amount type is not empty",
      "100005": "The amount is not empty",
      "100006": "please sign in",
      "100007": "Failed to get user id",
      "100008": "No flow data export"
    },
    "bonusDetail": {
      "fh": "Dividend Amount",
      "tqzq": "Extraction withdrawal",
      "expectIncome": "Return at Maturity",
      "bj": "Principle Amount",
      "type": "Investment Type",
      "tips": "Warning: if you do not unlock the account before the due date, the current interest will be calculated according to the financial management time!",
      "200004": "Abnormal data",
      "principal": "Invested Amount",
      "bonusRegularDetailTime": "Date Range",
      "unlockSuccess": "Unlocked successfully",
      "tqSuccess": "Successful extraction",
      "bonusRegularDetailStatus": "Interest type",
      "startAndEndTime": "Investment Tenor",
      "lastInterestDate": "Due Date",
      "interest": "Actual Return",
      "ljsy": "Accumulated Profit",
      "bonusRegularDetailOriginalMoney": "Principle Amount",
      "jshzce": "Withdraw Amount",
      "serialNumber": "Transaction ID",
      "bonusRegularDetailInterest": "Dividend Amount",
      "jxr": "Cut-off Date",
      "bonusDetailTitle": "Dividend Details",
      "tqTitle": "Withdraw",
      "mrfhjsb": "Daily Dividend Calculation",
      "100009": "The data has changed, please refresh the page",
      "bonusWay": "Dividend Investment Package",
      "dqjbe": "Invested Principle",
      "tqjsTitle": "Discounting",
      "jsb": "Settlement statement",
      "originalMoney": "Dividend Invested Principle"
    },
    "nav": {
      "index": "My Account"
    },
    "accountcenter": {
      "emailNotExist": "Please set the mailbox first",
      "sendCodeMail": "Send verification code to the current mailbox",
      "safeMail": "Secure e-mail",
      "chainData": "Winding data",
      "bankCard": "Bank card",
      "sendMailFrequently": "Do not send mail frequently, it takes 10 minutes",
      "missCode": "Missing verification code",
      "emailFormatError": "Incorrect mailbox format",
      "back": "Return",
      "lastMailTime": "Last email time",
      "sendEmailError": "Failed to send mail",
      "lastMailType": "Last mailed",
      "theEmailHasBeenUsed": "The mailbox has been used",
      "manageBankCard": "Manage bank card",
      "cofirm": "Please verify the new mailbox",
      "accCenter": "Account center",
      "getWeb": "View website",
      "myBankCard": "My bank card",
      "emailLengthError": "Mailbox length format error",
      "sendSuc": "Sent successfully",
      "safePhone": "Secure phone",
      "editEmailError": "Update mailbox failed",
      "errorCodeTypeParam": "Verifier code type parameter error",
      "missEmail": "Missing mailbox",
      "sendCOde": "Send the verification code",
      "missEmailParam": "Missing mailbox parameters",
      "accSafe": "Account security",
      "codeInvalid": "Verification code has expired",
      "blockChain": "Blockchain Address",
      "resetSuc": "Successfully modified",
      "trade": "transaction",
      "myTradeAcc": "My trading account",
      "pleaseNewMail": "Please enter a new email address",
      "pleaseCode": "please enter verification code",
      "codeError": "Verification code error",
      "safe": "Safety",
      "youHaveBoundTheEmail": "The mailbox you have bound",
      "nextStep": "Next step",
      "verifyMail": "submit",
      "resetMail": "Modify mailbox",
      "cic": "Commodities Intelligence Centre",
      "myWebAcc": "My digital account",
      "rongzi": "Financing"
    },
    "financingDetails": {
      "seller": "Seller",
      "repaymentAmountLimit": "Please enter a number greater than 0 and less than 1000000000 for the repayment amount.",
      "reason": "the reason",
      "amountLessThanAvailable": "The repayment amount cannot be greater than the available balance",
      "getFinancingDetailFail": "Failed to query financing details",
      "pleaseSelectAcountCard": "Please select a repayment account",
      "lookrepaymentAmount": "Repayment Amount",
      "hasComfimed": "confirmed",
      "financingContractInfor": "Financing contract information",
      "legalMoney": "Legal currency",
      "dueInfo": "Repayment information",
      "regCode": "Registration code",
      "flowNumber": "Financing application serial number",
      "wrongAccount": "You do not have permission to view this data",
      "financingMethod": "Financing method",
      "expectedRepaymentPeriod": "Expected repayment period",
      "isLocked": "Whether to lock after release",
      "doNotInsertRepaymentByState": "Repayment history of current financing data to be confirmed or to be modified, not allowed to be added",
      "acountMustInput": "Repayment amount is required",
      "details": "Detail",
      "applicationAccount": "Applicant account",
      "reimbursement": "Repayment",
      "comfirm": "determine",
      "repaymentAccountIdNotNull": "Remittance account cannot be empty",
      "systemComfim": "System confirmation",
      "companyCode": "Please enter the company registration code",
      "overdueAmount": "Additional repayment amount",
      "upLoadenclosureCode": "Upload Attachment",
      "viewLook": "View",
      "repaymentTypeNotNull": "Repayment method cannot be empty",
      "authCodeStr": "Authentication type",
      "dueTime": "Repayment time",
      "salesOrder": "Transaction sales order",
      "buyer": "buyer",
      "newdue": "New repayment",
      "pleaseChoseBill": "Please select a currency",
      "pleaseSelectPaymethod": "Please choose the repayment method",
      "financingStartTime": "Start",
      "orderAcount": "order amount",
      "guaranteeType": "Type of guarantee",
      "financingUse": "Financing use",
      "uploadAttachmentsNotEmpty": "Attachment cannot be empty",
      "payeeAccountCanuseNow": "Current available repayment amount",
      "repaymentAccount": "Financing repayment account",
      "countryName": "country",
      "payeeAccount": "Remittance Account",
      "coin": "currency",
      "addoverdueAmount": "Additional amount",
      "repaymentMethod": "Repayment",
      "no": "no",
      "financingaplayBook": "Financing application",
      "currencyTypeNotNull": "Currency cannot be empty",
      "pleaseSelectremittanceA": "Please select a remittance account",
      "currentAccountDoNotInsert": "Current registrant cannot repay",
      "enclosureCode": "annex",
      "repaymentAmountNotNull": "Repayment amount cannot be empty",
      "orderNum": "order number",
      "dorla": "Dollar",
      "doNotInsertRepayment": "The financing order has been completed and the repayment order cannot be added.",
      "grantAccount": "Financing issuing account",
      "financingEndTime": "Financing due date",
      "repaymentSource": "ASD",
      "newBusinessLicense": "New business license",
      "additionalPaymentInfo": "Additional repayment information",
      "aplicationFee": "interest",
      "applicationMoney": "Application Amount",
      "close": "shut down",
      "LockAcountNow": "Currently locked z currency",
      "certificateImage": "Certificate picture",
      "oldBusinessLicense": "Old business license",
      "dueMethods": "Repayment",
      "financingApplicationInfor": "Financing contract application information",
      "yes": "Yes",
      "repaymentIdNotNull": "Repayment flow id cannot be empty",
      "waitToModify": "To be modified",
      "additionalPayments": "Additional repayment amount",
      "waitToComfim": "unconfirmed",
      "billChoose": "Currency selection",
      "modify": "modify",
      "pleaseInputAmonut": "Please enter the amount",
      "financingMoney": "Financing Amount",
      "createTime": "Date",
      "dueAmount": "Repayment amount",
      "purchaseOrder": "Transaction purchase order",
      "pleaseUploadFile": "Please upload a file",
      "10001": "Amount input is illegal",
      "zCoin": "ZB",
      "addremark": "Additional cause",
      "tradingContract": "Transaction contract",
      "repaymentTime": "Repayment time",
      "fileUploadMaximumOf5": "Upload up to 5 files",
      "return": "return",
      "account": "Account"
    },
    "home": {
      "accountTotalMoney": "Total Amount",
      "safeMail": "E-mail",
      "getDicDataFailed": "Failed to get data from dictionary table",
      "bonusShenqing": "Apply for Divident",
      "accFlowLists": "Account flow",
      "cashRecord": "Withdrawals record",
      "bankAcc": "Bank Account",
      "accInfo": "account information",
      "cashApply": "Withdrawal application",
      "accountcenter": "My Account",
      "availableBalance": "Available Amount",
      "manage": "management",
      "lastLoginTime": "Last Login Time",
      "bonusSuoding": "Dividend Lock",
      "addAcc": "Add account",
      "contactNumber": "Contact Number",
      "bonusShouyi": "Dividend Income",
      "languageCannotNull": "Language cannot be empty",
      "lastRevenue": "The latest water",
      "fax": "Fax",
      "freezingQuota": "Freezed Capital",
      "contacts": "Contact Name",
      "bonusGuanli": "Dividend Manage"
    },
    "extractCrashStatus": {
      "0": "All",
      "1": "Application",
      "2": "Has been transferred out"
    },
    "withdrawCash": {
      "400002": "Please select the cash withdrawal currency",
      "400013": "Insufficient account balance",
      "400003": "Please fill in the amount of cash",
      "400014": "Verification code invalidation",
      "400011": "Does not have cash withdrawal rights",
      "400001": "Please fill in the verification code",
      "400012": "Parameter error",
      "400010": "Have not set up a mailbox, please set up a secure mailbox",
      "400008": "Cash withdrawal success",
      "400009": "Details id cannot be empty",
      "400017": "The data has changed, please refresh the page",
      "400006": "Mail is sent too frequently, please try again later",
      "400007": "incorrect verification code",
      "400015": "Cash withdrawal failure",
      "400004": "Please choose cash card",
      "400016": "Illegal cash withdrawal",
      "400005": "No data export yet"
    },
    "btns": {
      "cancel": "Cancel",
      "tqjs": "Discounting",
      "ensureUnlock": "Confirm unlock",
      "query": "Search",
      "detail": "Detail",
      "downLoadData": "Download to Excel",
      "ensureExtract": "Confirm Withdraw",
      "tq": "Withdraw"
    },
    "depositStatus": {
      "0": "All",
      "1": "Dividend",
      "2": "Issued",
      "3": "Turn to live"
    },
    "extractCrashDetail": {
      "proceedName": "Account Name",
      "remittanceDate": "Remittance time",
      "turnOutAmount": "Remittance amount",
      "swiftCode": "Bank SWIFT Code",
      "bankName": "Bank full name",
      "proceedAccount": "Account Number",
      "transferBankAccount": "Remittance Account",
      "tips": "*If the bank has not arrived, please contact your bank account customer service for enquiry. If you have further questions, please call [+65 6379 1324]",
      "amountExtraction": "Withdraw Amount",
      "flowNumber": "Cash flow number",
      "serviceCharge": "Processing Fee",
      "detailedAddress": "Bank Address",
      "moneyLable": "Currency",
      "transferBankName": "Bank Name",
      "fileList": "Supporting Documents",
      "extractCrashDetailTitle": "Cash withdrawal details"
    },
    "extractType": {
      "1": "Bank withdrawal"
    },
    "depositType": {
      "1": "current",
      "2": "Regularly"
    },
    "chaincount": {
      "all": "All",
      "myHome": "my account",
      "serialNumber": "Business flow number",
      "chainCount": "Blockchain statistics",
      "financingApply": "Financing application",
      "bonusApply": "Dividend application",
      "profitBonus": "Income dividend",
      "handle": "Processing",
      "fail": "failure",
      "appendRepayment": "Financing additional repayment",
      "transferActivity": "Transmission activity",
      "success": "success",
      "chainSum": "Total number of windings",
      "details": "Details",
      "state": "status",
      "day": "day",
      "cash": "withdraw",
      "chainTime": "Winding time",
      "financingLoan": "Financing lending",
      "repayment": "Financing repayment"
    }
  },
  ja: {
    "flowLists": {
      "flowNumber": "ランニングウォーター番号",
      "incomeTr": "収入",
      "flowListsTitle": "フローの詳細",
      "createTime": "日付",
      "ebalanceAmount": "残高",
      "detailTr": "詳細",
      "remarkType": "要約",
      "expenditureTr": "支出"
    },
    "frontPage": {
      "Error404": "パスが存在しない場合は、パスが正しいかどうかを確認してください。",
      "annualIncome": "年収",
      "z_currency": "Zコイン",
      "missSendEmailType": "送信メッセージタイプがありません",
      "back": "戻る",
      "UploadFailure": "アップロードに失敗しました",
      "CurrencyDollar": "ドル",
      "updateEmailSendCode": "メールボックス認証コードを変更する",
      "missEmailTemplate": "メールテンプレートがありません",
      "CurrencyHongKong": "香港ドル",
      "missSubject": "メッセージヘッダーがありません",
      "noTime": "いいえ",
      "missUserId": "送信先のユーザーIDがありません",
      "missFile": "ファイルがありません",
      "startTime": "開始時間",
      "accountTypeMiss": "ユーザータイプは空にできません",
      "NotFile": "ファイル形式が間違っています。再アップロードしてください！",
      "login_timeout": "ログインタイムアウト",
      "Error500": "システムが異常です。管理者に連絡してください。",
      "moneyArrivaNotice": "到着通知",
      "CurrencyJPY": "日本円",
      "missUserType": "ユーザータイプがありません",
      "selectTime": "時間を選択してください",
      "miss_field_version": "バージョン番号がありません",
      "fileCodeCannotEmpty": "ファイル固有の識別子は空であってはなりません",
      "uploadPersonNotNull": "アップローダは空にできません",
      "missEmail": "メールボックスがありません",
      "l_currency": "法的通貨",
      "missEmailParam": "メールパラメータがありません",
      "miss_token": "缺失token",
      "notPicType": "画像タイプではない",
      "youHaveNoPermission": "ファイルをダウンロードする権限がありません",
      "fileIsNullOrDeleted": "ファイルが存在しないか、削除されています",
      "drawSendCode": "キャッシュアウトの確認コード",
      "businessTypeCannotEmpty": "ファイルソースを空にすることはできません",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "現在アップロードされている画像がセキュリティチェックに失敗しました",
      "businessCodeCannotEmpty": "ファイルソース固有の識別子は空であってはなりません",
      "noData": "データはまだありません",
      "endTime": "締め切り",
      "time": "時間",
      "pleaseChoose": "選択してください",
      "notEmpty": "空ではありません",
      "CurrencySingapore": "シンガポール",
      "status": "州"
    },
    "bonusApply": {
      "200007": "配当基本データが異常です。",
      "bonusApplyInputPlaceHolder": "現在の再頒布可能残高",
      "200006": "適用額は、利用可能な配当残高よりも大きい",
      "200009": "バッチユーザーアカウントの資金調達に失敗しました",
      "200008": "定期的な配当の更新が失敗しました",
      "200003": "データが変更されました。ページを更新してください",
      "200002": "あなたは配当を禁止しました。管理者に連絡してください",
      "200005": "振込み額は空ではありません！",
      "200004": "データが異常です。システム管理者に連絡してください。",
      "200010": "バッチユーザーのライブ配当は失敗しました",
      "200012": "開始日は空白にすることはできません",
      "200011": "ユーザーの資金口座テーブルのデータが異常です",
      "bonusApplyInputLabel": "配当を申し込む",
      "bonusApplyType1": "現在の期間",
      "100013": "異常なパラメータ",
      "bonusApplyType2": "定期",
      "btn": "配当を開始する",
      "bonusApplyTitle": "配当適用",
      "bonusApplyInputErr2": "0より大きい入力番号は、現在の利用可能な配当よりも少なく、小数点以下2桁までです",
      "bonusApplyTip1": "*あなたはまだ融資支払いがあります",
      "200013": "終了日は空欄にできません",
      "bonusApplyInputErr1": "金額を入力してください",
      "bonusApplyTip2": "返済が必要",
      "200001": "ログインしていません",
      "bonusApplySuccess": "配当の申し込みが成功した"
    },
    "login": {
      "VerificationCodeMissing": "確認コードを入力してください",
      "rongziwei": "ファイナンシングアプリケーションは、特定のユーザグループに提供されるブロックチェーン仮想通貨技術に基づく、大規模なB2Bファーストトレードファイナンス機能です。",
      "nameOrPwdError": "ユーザー名またはパスワードが間違っています",
      "jiesheng": "伝統的な商業信用状の費用を節約する",
      "InvalidCaptchaKey": "期限切れの検証キー",
      "pleasePassword": "パスワードを入力してください",
      "bushouxianzhi": "時間と地理的制限を受けない転送",
      "login": "ログイン",
      "title": "トランザクションをJaneにスムーズにする",
      "myAcc": "私のアカウント",
      "pleaseUsername": "アカウント番号を入力してください",
      "logout": "ログアウト",
      "myFinancing": "私の資金調達",
      "xinyong": "クレジットデタッチ可能",
      "pleaseKaptcha": "確認コードを入力してください",
      "nianlilv": "年間の資金調達率は3.1％",
      "validCodeError": "確認コードエラー",
      "validCodeExpired": "確認コードが有効期限切れです",
      "userNotExit": "ユーザーは存在しません",
      "loginDisabled": "アカウントが無効になっています",
      "fuwu": "このサービスの利用に興味がある場合は、サービスのホットラインにお電話ください。",
      "coin": "コイン"
    },
    "cashApply": {
      "exMoney": "引き出しを申請する",
      "availableCredit": "利用可能な残高",
      "select": "選択してください",
      "bankCard": "銀行カードの引き出し",
      "sendCode": "確認コードを送信する",
      "available": "現在の出金額を入力してください",
      "title": "zコイン引き出し申請",
      "emCode": "受信したメールのセキュリティ認証コードを入力してください",
      "cashApply": "引き出しを申請する",
      "confCash": "引き出しを確認する",
      "tips": "*プラットフォームは手数料を徴収せず、引き出しに伴う銀行手数料は銀行が回収し、実際の口座から差し引かれます。",
      "newBank": "+銀行カードを追加する",
      "cashConf": "現金引き出し確認",
      "usable": "利用可能",
      "sentSuccess": "送信確認コードが成功しました。表示するメールボックスに移動してください",
      "moneyValue": "通貨",
      "sumCredit": "私の総コイン額",
      "useAmount": "Z通貨払い戻し額",
      "coin": "Zコイン"
    },
    "bank": {
      "300005": "エリアは空ではありません",
      "300016": "受取人の名前の最大長100",
      "300017": "受取人アカウントの最大長100",
      "300006": "銀行のフルネームは空ではありません",
      "300003": "カード番号を繰り返し、再入力してください",
      "300014": "スウィフトコードの最大長100",
      "300015": "受取人の名前の最大長200",
      "300004": "ログイン情報は空ではありません",
      "300009": "受取人の名前が空ではありません",
      "300007": "スウィフトコードは空ではありません",
      "300018": "通貨の最大長100",
      "300019": "ログインユーザーIDは空ではありません",
      "300008": "銀行の詳細アドレスは空ではありません",
      "300020": "主キーIDは空ではありません",
      "300023": "ユーザーIDは空ではありません",
      "300012": "国コードの最大長200",
      "300001": "ログインしてください",
      "300024": "データが変更されました。ページを更新してください",
      "300002": "ユーザーIDを取得できませんでした",
      "300013": "銀行名の最大長200",
      "300010": "受取人の口座は空ではありません",
      "300011": "通貨は空ではありません",
      "300022": "カード番号は空ではありません"
    },
    "chainDetails": {
      "add": "追加",
      "fileName": "ファイル名",
      "dataType": "データ型",
      "clickToDownload": "クリックしてダウンロードする",
      "fileInfo": "ファイル情報",
      "update": "更新",
      "remark": "備考",
      "title": "タイトル",
      "completeInfo": "完全な情報",
      "chainDetails": "ブロックチェーンの詳細",
      "downloadLink": "アドレスをダウンロード",
      "summaryInfo": "要約情報",
      "dataOverview": "データの概要",
      "report": "レポート",
      "reportDescription": "レポートの説明",
      "lastData": "次のデータ",
      "platformName": "プラットフォーム名",
      "value": "コンテンツ",
      "fileType": "ファイルの種類",
      "preData": "以前のデータ"
    },
    "bankList": {
      "cancel": "キャンセル",
      "proceedName": "受取人の名前",
      "country": "エリア",
      "bankFullName": "銀行のフルネーム",
      "bankCreate": "銀行カードを作成する",
      "swiftCode": "スウィフトコード",
      "proceedAccount": "受取人口座",
      "title": "銀行口座管理",
      "bankAdd": "アカウントを追加",
      "confirm": "決定する",
      "delConf": "この銀行口座を削除してもよろしいですか？",
      "detailedAddress": "銀行詳細アドレス",
      "supportCurrency": "サポート通貨"
    },
    "bonusLists": {
      "all": "すべて",
      "originalMoneyTr": "配当元本",
      "annualIncomeTr": "配当利回り",
      "serialNumberTr": "ランニングウォーター番号",
      "createTimeTr": "日付",
      "lastInterestDateTr": "配当決済日",
      "bonusListsTitle": "配当管理",
      "statusTr": "州",
      "detailTr": "詳細",
      "bonusListsApplyBtn": "配当を申し込む",
      "typeTr": "要約",
      "dividend": "配当",
      "turnToLive": "生きるために回る",
      "issued": "発行された"
    },
    "extractCrashLists": {
      "all": "すべて",
      "hasBeenTransferredOut": "転送された",
      "flowNumberTr": "ランニングウォーター番号",
      "createTimeTr": "日付",
      "extractCrashListsTitle": "現金引き出しの詳細",
      "statusTr": "州",
      "detailTr": "詳細",
      "withdrawalBankTr": "現金引き出し銀行",
      "serviceChargeTr": "手数料",
      "application": "アプリケーション",
      "amountExtractionTr": "引き出し金額",
      "turnOutAmountTr": "振込額",
      "remarkTr": "要約"
    },
    "financing": {
      "all": "すべて",
      "andTranscationg": "関連当事者取引",
      "financing_completed": "ファイナンス完了",
      "financingaplicationAmount": "融資額",
      "aplicationTime": "適用時間",
      "application_status_repayment": "返済",
      "view": "クエリ",
      "pleaseWrite": "入力してください",
      "financingandOrderNum": "関連する注文番号の資金調達",
      "draft": "下書き",
      "function": "機能",
      "financingaplicationNum": "融資申請番号",
      "financing": "私の資金調達",
      "startTime": "開始時間",
      "noData": "データはまだありません",
      "financingStatus": "資金調達状況",
      "details": "詳細",
      "endTime": "締め切り",
      "reimbursement": "返済",
      "still_hospitality_confirmation": "まだおもてなしの確認",
      "financingNumber": "シリアル番号の資金調達",
      "status": "州",
      "coin": "コイン"
    },
    "flowListsType": {
      "1": "転送する",
      "2": "返済資金調達",
      "3": "配当金の譲渡",
      "4": "配当金の譲渡",
      "5": "ファイナンス転送"
    },
    "resetpassword": {
      "newPasswordCannotSame": "新しいパスワードと元のパスワードを同じにすることはできません",
      "PasswordFormatIncorrect": "パスワードの形式が正しくない、変更してください",
      "newPasswordNotFormatted": "新しいパスワードの長さが正しく設定されていません。変更してください",
      "originalPasswordIncorrectly": "元のパスワードが誤って入力されました。",
      "passwordIsInconsistent": "パスワードは確認パスワードと一致しません"
    },
    "moneyChangeLog": {
      "100010": "開始日は空白にすることはできません",
      "100011": "終了日は空欄にできません",
      "100009": "データが変更されました。ページを更新してください",
      "100001": "ユーザーIDは空ではありません",
      "100012": "人員情報が空です",
      "100002": "サマリー・タイプがある表の主キーIDは空ではありません。",
      "100013": "異常なパラメータ",
      "100003": "要約タイプは空ではありません",
      "100014": "異常データ",
      "100004": "金額タイプは空ではありません",
      "100005": "金額は空ではありません",
      "100006": "ログインしてください",
      "100007": "ユーザーIDを取得できませんでした",
      "100008": "フローデータのエクスポートなし"
    },
    "bonusDetail": {
      "fh": "配当",
      "tqzq": "抽出引き出し",
      "expectIncome": "期待リターン",
      "bj": "プリンシパル",
      "type": "配当金",
      "tips": "警告：ロック解除があらかじめ期限切れになっていない場合は、金利に応じて金利が計算されます！",
      "200004": "異常データ",
      "principal": "プリンシパルのロックを解除する",
      "bonusRegularDetailTime": "時間",
      "unlockSuccess": "ロックが解除されました",
      "tqSuccess": "成功した抽出",
      "bonusRegularDetailStatus": "インタレストタイプ",
      "startAndEndTime": "配当計画の開始日と終了日",
      "lastInterestDate": "配当支払日",
      "interest": "実際の収入",
      "ljsy": "累積収入",
      "bonusRegularDetailOriginalMoney": "プリンシパル",
      "jshzce": "ロック解除後の金額",
      "serialNumber": "ランニングウォーター番号",
      "bonusRegularDetailInterest": "配当",
      "jxr": "有利子の日",
      "bonusDetailTitle": "配当金リスト",
      "tqTitle": "抽出",
      "mrfhjsb": "毎日の配当金明細",
      "100009": "データが変更されました。ページを更新してください",
      "bonusWay": "配当方式",
      "dqjbe": "現在の基本額",
      "tqjsTitle": "事前にロック解除する",
      "jsb": "和解声明",
      "originalMoney": "基本配当"
    },
    "nav": {
      "index": "私のアカウント"
    },
    "accountcenter": {
      "emailNotExist": "最初にメールボックスを設定してください",
      "sendCodeMail": "現在のメールボックスに確認コードを送信する",
      "safeMail": "安全なメールボックス",
      "chainData": "巻くデータ",
      "bankCard": "銀行カード",
      "sendMailFrequently": "メールを頻繁に送信しないでください。10分かかります",
      "missCode": "確認コードがありません",
      "emailFormatError": "不適切なメールボックス形式",
      "back": "戻る",
      "lastMailTime": "最後のメール時刻",
      "sendEmailError": "メールの送信に失敗しました",
      "lastMailType": "最後に郵送された",
      "theEmailHasBeenUsed": "メールボックスが使用されました",
      "manageBankCard": "銀行カードの管理",
      "cofirm": "新しいメールボックスを確認してください",
      "accCenter": "アカウントセンター",
      "getWeb": "ウェブサイトを表示",
      "myBankCard": "私の銀行カード",
      "emailLengthError": "メールボックスの長さのフォーマットエラー",
      "sendSuc": "正常に送信されました",
      "safePhone": "安全な電話",
      "editEmailError": "メールボックスの更新に失敗",
      "errorCodeTypeParam": "検証コードタイプパラメータエラー",
      "missEmail": "メールボックスがありません",
      "sendCOde": "確認コードを送信する",
      "missEmailParam": "メールボックスのパラメータがありません",
      "accSafe": "アカウントのセキュリティ",
      "codeInvalid": "確認コードが有効期限切れです",
      "blockChain": "ブロックチェーン",
      "resetSuc": "変更に成功しました",
      "trade": "取引",
      "myTradeAcc": "私の取引口座",
      "pleaseNewMail": "新しいメールアドレスを入力してください",
      "pleaseCode": "確認コードを入力してください",
      "codeError": "確認コードエラー",
      "safe": "安全性",
      "youHaveBoundTheEmail": "バインドしたメールボックス",
      "nextStep": "次のステップ",
      "verifyMail": "提出する",
      "resetMail": "メールボックスの変更",
      "cic": "コモディティズ・インテリジェンス・センター",
      "myWebAcc": "私のデジタルアカウント",
      "rongzi": "ファイナンス"
    },
    "financingDetails": {
      "seller": "売り手",
      "repaymentAmountLimit": "返済額は、0より大きく1000000000未満の数値を入力してください。",
      "reason": "理由",
      "amountLessThanAvailable": "返済額は利用可能な残高より大きくすることはできません",
      "getFinancingDetailFail": "ファイナンスの詳細を照会できませんでした",
      "pleaseSelectAcountCard": "返済口座を選択してください",
      "lookrepaymentAmount": "返済額",
      "hasComfimed": "確認済み",
      "financingContractInfor": "融資契約情報",
      "legalMoney": "法的通貨",
      "dueInfo": "返済情報",
      "regCode": "登録コード",
      "flowNumber": "ファイナンシングアプリケーションのシリアル番号",
      "wrongAccount": "このデータを表示する権限がありません",
      "financingMethod": "ファイナンス方法",
      "expectedRepaymentPeriod": "期待される返済期間",
      "isLocked": "リリース後にロックするかどうか",
      "doNotInsertRepaymentByState": "現行の資金調達データの遡及履歴が確認または変更され、追加が許可されていない",
      "acountMustInput": "返済額が必要です",
      "details": "詳細",
      "applicationAccount": "応募者の口座",
      "reimbursement": "返済",
      "comfirm": "決定する",
      "repaymentAccountIdNotNull": "送金口座は空にできません",
      "systemComfim": "システム確認",
      "companyCode": "会社の登録コードを入力してください",
      "overdueAmount": "追加返済額",
      "upLoadenclosureCode": "添付ファイルをアップロードする",
      "viewLook": "ビュー",
      "repaymentTypeNotNull": "返済方法を空にすることはできません",
      "authCodeStr": "認証タイプ",
      "dueTime": "返済時期",
      "salesOrder": "取引受注",
      "buyer": "買い手",
      "newdue": "新しい返済",
      "pleaseChoseBill": "通貨を選択してください",
      "pleaseSelectPaymethod": "返済方法を選択してください",
      "financingStartTime": "ファイナンスの開始日",
      "orderAcount": "注文金額",
      "guaranteeType": "保証の種類",
      "financingUse": "ファイナンスの使用",
      "uploadAttachmentsNotEmpty": "添付ファイルを空にすることはできません",
      "payeeAccountCanuseNow": "現在利用可能な返済額",
      "repaymentAccount": "返済勘定の資金調達",
      "countryName": "国",
      "payeeAccount": "送金口座",
      "coin": "コイン",
      "addoverdueAmount": "追加金額",
      "repaymentMethod": "返済方法",
      "no": "いいえ",
      "financingaplayBook": "ファイナンスアプリケーション",
      "currencyTypeNotNull": "通貨は空白にできません",
      "pleaseSelectremittanceA": "送金口座を選択してください",
      "currentAccountDoNotInsert": "現在の登録者は返済できません",
      "enclosureCode": "アタッチメント",
      "repaymentAmountNotNull": "返済額は空欄にはできません",
      "orderNum": "注文番号",
      "dorla": "ドル",
      "doNotInsertRepayment": "融資注文が完了し、返済注文を追加することはできません。",
      "grantAccount": "融資発行口座",
      "financingEndTime": "資金調達期限",
      "repaymentSource": "返済元",
      "newBusinessLicense": "新しいビジネスライセンス",
      "additionalPaymentInfo": "追加返済情報",
      "aplicationFee": "インタレスト",
      "applicationMoney": "申込金額",
      "close": "閉じる",
      "LockAcountNow": "現在ロックされているz通貨",
      "certificateImage": "証明写真",
      "oldBusinessLicense": "古いビジネスライセンス",
      "dueMethods": "返済方法",
      "financingApplicationInfor": "ファイナンス契約アプリケーション情報",
      "yes": "はい",
      "repaymentIdNotNull": "返済フローIDは空にできません",
      "waitToModify": "変更する",
      "additionalPayments": "追加返済額",
      "waitToComfim": "未確認",
      "billChoose": "通貨の選択",
      "modify": "変更",
      "pleaseInputAmonut": "金額を入力してください",
      "financingMoney": "資金調達額",
      "createTime": "録音時間",
      "dueAmount": "返済額",
      "purchaseOrder": "取引注文",
      "pleaseUploadFile": "ファイルをアップロードしてください",
      "10001": "金額入力が不正です",
      "zCoin": "Zコイン",
      "addremark": "追加原因",
      "tradingContract": "取引契約",
      "repaymentTime": "返済時期",
      "fileUploadMaximumOf5": "最大5つのファイルをアップロード",
      "return": "戻る",
      "account": "アカウント"
    },
    "home": {
      "accountTotalMoney": "合計アカウント",
      "safeMail": "セキュリティ検証メールボックス",
      "getDicDataFailed": "辞書テーブルからデータを取得できませんでした",
      "bonusShenqing": "配当適用",
      "accFlowLists": "アカウントフロー",
      "cashRecord": "引退記録",
      "bankAcc": "銀行口座",
      "accInfo": "アカウント情報",
      "cashApply": "出金申請",
      "accountcenter": "アカウントセンター",
      "availableBalance": "利用可能な残高",
      "manage": "マネジメント",
      "lastLoginTime": "最終ログイン時刻",
      "bonusSuoding": "配当金",
      "addAcc": "アカウントを追加",
      "contactNumber": "連絡先",
      "bonusShouyi": "配当収入",
      "languageCannotNull": "言語は空ではありません",
      "lastRevenue": "最新の水",
      "fax": "ファックス",
      "freezingQuota": "フリーズクォータ",
      "contacts": "連絡先",
      "bonusGuanli": "配当管理"
    },
    "extractCrashStatus": {
      "0": "すべて",
      "1": "アプリケーション",
      "2": "転送された"
    },
    "withdrawCash": {
      "400002": "現金引き出し通貨を選択してください",
      "400013": "アカウント残高不足",
      "400003": "現金で記入してください",
      "400014": "確認コードの無効化",
      "400011": "現金引き出し権を持っていない",
      "400001": "確認コードを入力してください",
      "400012": "パラメータエラー",
      "400010": "メールボックスを設定していない場合は、安全なメールボックスを設定してください",
      "400008": "現金引き出しの成功",
      "400009": "詳細のIDは空にできません",
      "400017": "データが変更されました。ページを更新してください",
      "400006": "メールが頻繁に送信されました。後でやり直してください",
      "400007": "確認コード入力エラー",
      "400015": "現金引き出し不良",
      "400004": "キャッシュカードを選択してください",
      "400016": "違法な現金引き出し",
      "400005": "データのエクスポートはまだありません"
    },
    "btns": {
      "cancel": "キャンセル",
      "tqjs": "事前にロック解除する",
      "ensureUnlock": "ロック解除の確認",
      "query": "クエリ",
      "detail": "詳細",
      "downLoadData": "データをダウンロードする",
      "ensureExtract": "抽出を確認する",
      "tq": "抽出"
    },
    "depositStatus": {
      "0": "すべて",
      "1": "配当",
      "2": "発行された",
      "3": "生きるために回る"
    },
    "extractCrashDetail": {
      "proceedName": "受取人の名前",
      "remittanceDate": "送金時間",
      "turnOutAmount": "送金額",
      "swiftCode": "SWIFTコードのキャッシュアウト",
      "bankName": "銀行のフルネーム",
      "proceedAccount": "受取人口座",
      "transferBankAccount": "送金口座",
      "tips": "*銀行が到着していない場合は、銀行口座のカスタマーサービスにお問い合わせください。ご不明な点がございましたら、[+ 65 6379 1324]までお電話ください。",
      "amountExtraction": "引き出しを申請する",
      "flowNumber": "キャッシュフロー番号",
      "serviceCharge": "手数料",
      "detailedAddress": "銀行詳細アドレス",
      "moneyLable": "現金引き出し通貨",
      "transferBankName": "送金銀行",
      "fileList": "譲渡証明書",
      "extractCrashDetailTitle": "現金引き出しの詳細"
    },
    "extractType": {
      "1": "銀行の引き出し"
    },
    "depositType": {
      "1": "現在の期間",
      "2": "定期"
    },
    "chaincount": {
      "all": "すべて",
      "myHome": "私のアカウント",
      "serialNumber": "ビジネスフロー番号",
      "chainCount": "ブロックチェーン統計",
      "financingApply": "ファイナンスアプリケーション",
      "bonusApply": "配当適用",
      "profitBonus": "所得配当",
      "handle": "処理",
      "fail": "失敗",
      "appendRepayment": "追加返済の資金調達",
      "transferActivity": "伝送活動",
      "success": "成功",
      "chainSum": "総巻き数",
      "details": "詳細",
      "state": "州",
      "day": "日",
      "cash": "引退",
      "chainTime": "巻取時間",
      "financingLoan": "融資融資",
      "repayment": "返済資金調達"
    }
  },
  in: {
    "flowLists": {
      "flowNumber": "Menjalankan nomor air",
      "incomeTr": "Penghasilan",
      "flowListsTitle": "Detail alir",
      "createTime": "Date",
      "ebalanceAmount": "Balance",
      "detailTr": "Detail",
      "remarkType": "Ringkasan",
      "expenditureTr": "Pengeluaran"
    },
    "frontPage": {
      "Error404": "Jalur tiada, silakan memeriksa kebenaran jalur",
      "annualIncome": "Penghasilan tahunan",
      "z_currency": "z koin",
      "missSendEmailType": "Jenis pesan pengiriman tidak ada",
      "back": "Kembali",
      "UploadFailure": "Pengunggahan gagal",
      "CurrencyDollar": "dolar",
      "updateEmailSendCode": "Ubah kode verifikasi kotak surat",
      "missEmailTemplate": "Template surat tidak ada",
      "CurrencyHongKong": "dollar Hongkong",
      "missSubject": "Judul pesan tidak ada",
      "noTime": "Tidak",
      "missUserId": "Tidak ada, kirim id pengguna tujuan",
      "missFile": "File tidak ada",
      "startTime": "Waktu mulai",
      "accountTypeMiss": "Jenis pengguna tidak boleh kosong",
      "NotFile": "Format file salah, unggah ulang!",
      "login_timeout": "Melewati waktu ketika login",
      "Error500": "Sistem tidak normal, silakan hubungi administrator",
      "moneyArrivaNotice": "Pemberitahuan kedatangan",
      "CurrencyJPY": "Yen",
      "missUserType": "Jenis pengguna tidak ada",
      "selectTime": "Silakan pilih waktu",
      "miss_field_version": "Kehilangan nomor versi",
      "fileCodeCannotEmpty": "Pengenal unik file tidak boleh kosong",
      "uploadPersonNotNull": "Pengunggah tidak boleh kosong",
      "missEmail": "Kotak surat tidak ada",
      "l_currency": "Mata uang legal",
      "missEmailParam": "Parameter email tidak ada",
      "miss_token": "Kehilangan token",
      "notPicType": "Bukan tipe gambar",
      "youHaveNoPermission": "Anda tidak memiliki izin untuk mengunduh file",
      "fileIsNullOrDeleted": "File tidak ada atau telah dihapus",
      "drawSendCode": "Kode verifikasi cashout",
      "businessTypeCannotEmpty": "Sumber file tidak boleh kosong",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "Gambar yang diunggah gagal memeriksa keamanan",
      "businessCodeCannotEmpty": "Pengidentifikasi unik sumber file tidak boleh kosong",
      "noData": "Belum ada data",
      "endTime": "Tenggat waktu",
      "time": "Waktu",
      "pleaseChoose": "Silakan pilih",
      "notEmpty": "Tidak boleh kosong",
      "CurrencySingapore": "singapore",
      "status": "Negara"
    },
    "bonusApply": {
      "200007": "Data dasar dividen tidak normal.",
      "bonusApplyInputPlaceHolder": "Saldo redistributable saat ini",
      "200006": "Jumlah aplikasi lebih besar dari saldo dividen yang tersedia",
      "200009": "Gagal mendanai akun pengguna kumpulan",
      "200008": "Pembaruan bets periodik gagal",
      "200003": "Data telah berubah, silakan refresh halaman",
      "200002": "Anda telah mengharamkan dividen, silakan hubungi administrator",
      "200005": "Jumlah transfer tidak kosong!",
      "200004": "Datanya tidak normal, silakan hubungi administrator sistem",
      "200010": "Batch pengguna dividen langsung gagal",
      "200012": "Tanggal mulai tidak boleh kosong",
      "200011": "Data tabel akun dana pengguna tidak normal",
      "bonusApplyInputLabel": "Terapkan untuk dividen",
      "bonusApplyType1": "Periode saat ini",
      "100013": "Parameter tidak normal",
      "bonusApplyType2": "Secara teratur",
      "btn": "Mulai dapatkan dividen",
      "bonusApplyTitle": "Aplikasi Dividen",
      "bonusApplyInputErr2": "Jumlah input lebih besar dari 0 kurang dari dividen yang tersedia saat ini dan hingga 2 tempat desimal",
      "bonusApplyTip1": "* Anda masih memiliki pembayaran pembiayaan",
      "200013": "Tanggal akhir tidak boleh kosong",
      "bonusApplyInputErr1": "Harap masukkan jumlahnya",
      "bonusApplyTip2": "Pembayaran diperlukan",
      "200001": "Belum masuk",
      "bonusApplySuccess": "Aplikasi sukses untuk dividen"
    },
    "login": {
      "VerificationCodeMissing": "Silakan masukkan kode verifikasi",
      "rongziwei": "Aplikasi pembiayaan adalah fungsi pembiayaan perdagangan cepat b2b besar berdasarkan teknologi mata uang virtual blockchain yang disediakan oleh cic untuk kelompok pengguna tertentu.",
      "nameOrPwdError": "Nama pengguna atau sandi salah",
      "jiesheng": "Hemat biaya surat kredit perdagangan tradisional",
      "InvalidCaptchaKey": "key kode verifikasi yang kedaluwarsa",
      "pleasePassword": "Silakan masukkan kata sandi Anda",
      "bushouxianzhi": "Transfer yang tidak tunduk pada batasan waktu dan geografis",
      "login": "Login",
      "title": "Menghaluskan transaksi ke Jane",
      "myAcc": "Akun saya",
      "pleaseUsername": "Harap masukkan nomor akun",
      "logout": "Logout",
      "myFinancing": "Pembiayaan saya",
      "xinyong": "Kredit dapat dilepas",
      "pleaseKaptcha": "Silakan masukkan kode verifikasi",
      "nianlilv": "Tingkat pembiayaan tahunan serendah 3,1%",
      "validCodeError": "Kode verifikasi salah",
      "validCodeExpired": "Kode verifikasi telah kedaluwarsa",
      "userNotExit": "Pengguna tidak ada",
      "loginDisabled": "Akun telah dinonaktifkan",
      "fuwu": "Jika Anda tertarik menggunakan layanan ini, silakan hubungi hotline layanan.",
      "coin": "Coin"
    },
    "cashApply": {
      "exMoney": "Ajukan permohonan penarikan",
      "availableCredit": "Saldo yang tersedia",
      "select": "Silakan pilih",
      "bankCard": "Penarikan kartu bank",
      "sendCode": "Kirim kode verifikasi",
      "available": "Harap masukkan jumlah penarikan saat ini",
      "title": "z aplikasi penarikan koin",
      "emCode": "Harap masukkan kode verifikasi keamanan email yang diterima",
      "cashApply": "Ajukan permohonan penarikan",
      "confCash": "Konfirmasi penarikan",
      "tips": "* Platform tidak akan membebankan biaya apa pun, dan biaya bank yang terlibat dalam penarikan akan dikumpulkan oleh bank dan dikurangkan dari akun yang sebenarnya.",
      "newBank": "+ Tambahkan kartu bank",
      "cashConf": "Konfirmasi penarikan uang tunai",
      "usable": "Tersedia",
      "sentSuccess": "Kirim kode verifikasi berhasil, silakan pergi ke kotak surat untuk melihat",
      "moneyValue": "Mata uang",
      "sumCredit": "Jumlah total koin c saya",
      "useAmount": "Z jumlah penarikan mata uang",
      "coin": "Koin Z"
    },
    "bank": {
      "300005": "Area ini tidak kosong",
      "300016": "Nama penerima maksimum maksimal 100",
      "300017": "Panjang maksimum akun penerima pembayaran 100",
      "300006": "Nama lengkap bank tidak kosong",
      "300003": "Nomor kartu diulang, silakan masukkan kembali",
      "300014": "Kode swift maksimal panjangnya 100",
      "300015": "Nama penerima pembayaran maksimum panjang 200",
      "300004": "Informasi login tidak kosong",
      "300009": "Nama penerima pembayaran tidak kosong",
      "300007": "Kode swift tidak kosong",
      "300018": "Mata uang maksimum panjang 100",
      "300019": "ID orang masuk tidak kosong",
      "300008": "Alamat lengkap bank tidak kosong",
      "300020": "ID kunci utama tidak kosong",
      "300023": "ID pengguna tidak kosong",
      "300012": "Kode negara maksimum panjang 200",
      "300001": "Silakan masuk",
      "300024": "Data telah berubah, silakan refresh halaman",
      "300002": "Gagal mendapatkan id pengguna",
      "300013": "Nama lengkap bank maksimal panjang 200",
      "300010": "Akun penerima pembayaran tidak kosong",
      "300011": "Mata uang tidak kosong",
      "300022": "Nomor kartu tidak kosong"
    },
    "chainDetails": {
      "add": "Tambahkan",
      "fileName": "Nama file",
      "dataType": "Tipe data",
      "clickToDownload": "Klik untuk mengunduh",
      "fileInfo": "Informasi file",
      "update": "Perbarui",
      "remark": "Keterangan",
      "title": "Judul",
      "completeInfo": "Informasi lengkap",
      "chainDetails": "Detail Blockchain",
      "downloadLink": "Unduh alamat",
      "summaryInfo": "Informasi ringkasan",
      "dataOverview": "Gambaran data",
      "report": "Laporkan",
      "reportDescription": "Deskripsi laporan",
      "lastData": "Data selanjutnya",
      "platformName": "Nama platform",
      "value": "Konten",
      "fileType": "Jenis file",
      "preData": "Data sebelumnya"
    },
    "bankList": {
      "cancel": "Batalkan",
      "proceedName": "Nama penerima pembayaran",
      "country": "Area",
      "bankFullName": "Nama lengkap bank",
      "bankCreate": "Buat kartu bank",
      "swiftCode": "Kode swift",
      "proceedAccount": "Akun penerima pembayaran",
      "title": "Manajemen akun bank",
      "bankAdd": "Tambahkan akun",
      "confirm": "Tentukan",
      "delConf": "Anda yakin ingin menghapus rekening bank ini?",
      "detailedAddress": "Alamat rinci bank",
      "supportCurrency": "Mendukung mata uang"
    },
    "bonusLists": {
      "all": "Semua",
      "originalMoneyTr": "Prinsip dividen",
      "annualIncomeTr": "Dividen hasil",
      "serialNumberTr": "Menjalankan nomor air",
      "createTimeTr": "Date",
      "lastInterestDateTr": "Tanggal penyelesaian deviden",
      "bonusListsTitle": "Manajemen dividen",
      "statusTr": "Negara",
      "detailTr": "Detail",
      "bonusListsApplyBtn": "Terapkan untuk dividen",
      "typeTr": "Ringkasan",
      "dividend": "Dividen",
      "turnToLive": "Hidupkan kembali",
      "issued": "Dikeluarkan"
    },
    "extractCrashLists": {
      "all": "Semua",
      "hasBeenTransferredOut": "Telah dialihkan",
      "flowNumberTr": "Menjalankan nomor air",
      "createTimeTr": "Date",
      "extractCrashListsTitle": "Detail penarikan uang tunai",
      "statusTr": "Negara",
      "detailTr": "Detail",
      "withdrawalBankTr": "Bank penarikan uang tunai",
      "serviceChargeTr": "Biaya penanganan",
      "application": "Aplikasi",
      "amountExtractionTr": "Jumlah Penarikan",
      "turnOutAmountTr": "Jumlah transfer",
      "remarkTr": "Ringkasan"
    },
    "financing": {
      "all": "Semua",
      "andTranscationg": "Transaksi dengan pihak terkait",
      "financing_completed": "Pembiayaan selesai",
      "financingaplicationAmount": "Membiayai jumlah aplikasi",
      "aplicationTime": "Waktu aplikasi",
      "application_status_repayment": "Pembayaran kembali",
      "view": "Query",
      "pleaseWrite": "Silakan masuk",
      "financingandOrderNum": "Membiayai nomor pesanan terkait",
      "draft": "Draf",
      "function": "Fungsi",
      "financingaplicationNum": "Nomor aplikasi pembiayaan",
      "financing": "Pembiayaan saya",
      "startTime": "Waktu mulai",
      "noData": "Belum ada data",
      "financingStatus": "Status pembiayaan",
      "details": "Detail",
      "endTime": "Tenggat waktu",
      "reimbursement": "Pembayaran kembali",
      "still_hospitality_confirmation": "Masih konfirmasi keramahan",
      "financingNumber": "Pembiayaan nomor seri",
      "status": "Negara",
      "coin": "Coin"
    },
    "flowListsType": {
      "1": "Transfer keluar",
      "2": "Pembayaran pembiayaan",
      "3": "Dividen transfer",
      "4": "Dividen transfer",
      "5": "Transfer pembiayaan"
    },
    "resetpassword": {
      "newPasswordCannotSame": "Kata sandi baru tidak boleh sama dengan kata sandi asli",
      "PasswordFormatIncorrect": "Format kata sandi salah, silakan ubah",
      "newPasswordNotFormatted": "Panjang kata sandi baru tidak diformat dengan benar, silakan ubah",
      "originalPasswordIncorrectly": "Kata sandi asli dimasukkan salah.",
      "passwordIsInconsistent": "Kata sandi tidak konsisten dengan kata sandi konfirmasi"
    },
    "moneyChangeLog": {
      "100010": "Tanggal mulai tidak boleh kosong",
      "100011": "Tanggal akhir tidak boleh kosong",
      "100009": "Data telah berubah, silakan refresh halaman",
      "100001": "ID pengguna tidak kosong",
      "100012": "Informasi personil kosong",
      "100002": "ID kunci utama dari tabel tempat jenis ringkasan berada tidak kosong.",
      "100013": "Parameter tidak normal",
      "100003": "Jenis ringkasan tidak kosong",
      "100014": "Data tidak normal",
      "100004": "Tipe besarnya tidak kosong",
      "100005": "Jumlahnya tidak kosong",
      "100006": "Silakan masuk",
      "100007": "Gagal mendapatkan id pengguna",
      "100008": "Tidak ada ekspor data alur"
    },
    "bonusDetail": {
      "fh": "Dividen",
      "tqzq": "Penarikan ekstraksi",
      "expectIncome": "Pengembalian yang diharapkan",
      "bj": "Kepala Sekolah",
      "type": "Jenis dividen",
      "tips": "Peringatan: Jika buka kunci tidak kedaluwarsa sebelumnya, bunga akan dihitung sesuai dengan waktu keuangan!",
      "200004": "Data tidak normal",
      "principal": "Buka kunci kepala sekolah",
      "bonusRegularDetailTime": "Waktu",
      "unlockSuccess": "Berhasil dibuka",
      "tqSuccess": "Ekstraksi yang sukses",
      "bonusRegularDetailStatus": "Jenis minat",
      "startAndEndTime": "Tanggal mulai dan berakhirnya rencana dividen",
      "lastInterestDate": "Tanggal pembayaran dividen",
      "interest": "Penghasilan aktual",
      "ljsy": "Penghasilan kumulatif",
      "bonusRegularDetailOriginalMoney": "Kepala Sekolah",
      "jshzce": "Transfer jumlah setelah membuka kunci",
      "serialNumber": "Menjalankan nomor air",
      "bonusRegularDetailInterest": "Dividen",
      "jxr": "Hari menarik",
      "bonusDetailTitle": "Daftar dividen",
      "tqTitle": "Ekstraksi",
      "mrfhjsb": "Pernyataan dividen harian",
      "100009": "Data telah berubah, silakan refresh halaman",
      "bonusWay": "Skema dividen",
      "dqjbe": "Jumlah dasar saat ini",
      "tqjsTitle": "Buka kunci sebelumnya",
      "jsb": "Pernyataan penyelesaian",
      "originalMoney": "Dividen dasar"
    },
    "nav": {
      "index": "Akun saya"
    },
    "accountcenter": {
      "emailNotExist": "Silakan mengatur kotak surat terlebih dahulu",
      "sendCodeMail": "Kirim kode verifikasi ke kotak surat saat ini",
      "safeMail": "Kotak surat aman",
      "chainData": "Berliku data",
      "bankCard": "Kartu bank",
      "sendMailFrequently": "Jangan mengirim surat secara rutin, butuh 10 menit",
      "missCode": "Kode verifikasi tidak ada",
      "emailFormatError": "Format kotak surat salah",
      "back": "Kembali",
      "lastMailTime": "Waktu email terakhir",
      "sendEmailError": "Gagal mengirim email",
      "lastMailType": "Diposkan oleh yang terakhir",
      "theEmailHasBeenUsed": "Kotak surat telah digunakan",
      "manageBankCard": "Kelola kartu bank",
      "cofirm": "Harap verifikasi kotak pesan baru",
      "accCenter": "Pusat akun",
      "getWeb": "Lihat situs web",
      "myBankCard": "Kartu bank saya",
      "emailLengthError": "Kesalahan format kotak surat",
      "sendSuc": "Berhasil dikirim",
      "safePhone": "Telepon aman",
      "editEmailError": "Perbarui kotak surat gagal",
      "errorCodeTypeParam": "Kesalahan parameter jenis kode verifikasi",
      "missEmail": "Kotak surat tidak ada",
      "sendCOde": "Kirim kode verifikasi",
      "missEmailParam": "Parameter kotak surat tidak ada",
      "accSafe": "Keamanan akun",
      "codeInvalid": "Kode verifikasi telah kedaluwarsa",
      "blockChain": "Blockchain",
      "resetSuc": "Berhasil dimodifikasi",
      "trade": "Transaksi",
      "myTradeAcc": "Akun perdagangan saya",
      "pleaseNewMail": "Harap masukkan alamat email baru",
      "pleaseCode": "Silakan masukkan kode verifikasi",
      "codeError": "Kesalahan kode verifikasi",
      "safe": "Keamanan",
      "youHaveBoundTheEmail": "Kotak surat yang Anda ikat",
      "nextStep": "Langkah selanjutnya",
      "verifyMail": "Kirim",
      "resetMail": "Ubah kotak surat",
      "cic": "Pusat Intelijen Komoditas",
      "myWebAcc": "Akun digital saya",
      "rongzi": "Pembiayaan"
    },
    "financingDetails": {
      "seller": "Penjual",
      "repaymentAmountLimit": "Harap masukkan angka yang lebih besar dari 0 dan kurang dari 1000000000 untuk jumlah pembayaran kembali.",
      "reason": "Alasan",
      "amountLessThanAvailable": "Jumlah pembayaran tidak boleh lebih besar dari saldo yang tersedia",
      "getFinancingDetailFail": "Gagal menanyakan detail pembiayaan",
      "pleaseSelectAcountCard": "Silakan pilih akun pembayaran",
      "lookrepaymentAmount": "Jumlah pembayaran kembali",
      "hasComfimed": "Dikonfirmasi",
      "financingContractInfor": "Informasi kontrak pembiayaan",
      "legalMoney": "Mata uang legal",
      "dueInfo": "Informasi pembayaran kembali",
      "regCode": "Kode registrasi",
      "flowNumber": "Membiayai nomor seri aplikasi",
      "wrongAccount": "Anda tidak memiliki izin untuk melihat data ini",
      "financingMethod": "Metode pembiayaan",
      "expectedRepaymentPeriod": "Periode pembayaran yang diharapkan",
      "isLocked": "Apakah akan mengunci setelah rilis",
      "doNotInsertRepaymentByState": "Riwayat pembayaran kembali data pembiayaan saat ini untuk dikonfirmasi atau dimodifikasi, tidak diizinkan untuk ditambahkan",
      "acountMustInput": "Jumlah pembayaran diperlukan",
      "details": "Detail",
      "applicationAccount": "Akun pemohon",
      "reimbursement": "Pembayaran kembali",
      "comfirm": "Tentukan",
      "repaymentAccountIdNotNull": "Akun pengiriman uang tidak boleh kosong",
      "systemComfim": "Konfirmasi sistem",
      "companyCode": "Silakan masukkan kode registrasi perusahaan",
      "overdueAmount": "Jumlah pembayaran tambahan",
      "upLoadenclosureCode": "Unggah lampiran",
      "viewLook": "Lihat",
      "repaymentTypeNotNull": "Metode pembayaran tidak boleh kosong",
      "authCodeStr": "Jenis otentikasi",
      "dueTime": "Waktu pembayaran",
      "salesOrder": "Pesanan penjualan transaksi",
      "buyer": "Pembeli",
      "newdue": "Pembayaran baru",
      "pleaseChoseBill": "Silakan pilih mata uang",
      "pleaseSelectPaymethod": "Silakan pilih metode pembayaran",
      "financingStartTime": "Tanggal mulai pembiayaan",
      "orderAcount": "Jumlah pesanan",
      "guaranteeType": "Jenis jaminan",
      "financingUse": "Penggunaan pembiayaan",
      "uploadAttachmentsNotEmpty": "Lampiran tidak boleh kosong",
      "payeeAccountCanuseNow": "Jumlah pembayaran saat ini tersedia",
      "repaymentAccount": "Akun pembayaran pembiayaan",
      "countryName": "Negara",
      "payeeAccount": "Akun pengiriman uang",
      "coin": "Coin",
      "addoverdueAmount": "Jumlah tambahan",
      "repaymentMethod": "Metode pembayaran kembali",
      "no": "Tidak",
      "financingaplayBook": "Aplikasi pembiayaan",
      "currencyTypeNotNull": "Mata uang tidak boleh kosong",
      "pleaseSelectremittanceA": "Silakan pilih akun pengiriman uang",
      "currentAccountDoNotInsert": "Pendaftar saat ini tidak dapat membayar kembali",
      "enclosureCode": "Lampiran",
      "repaymentAmountNotNull": "Jumlah pembayaran tidak boleh kosong",
      "orderNum": "Nomor pesanan",
      "dorla": "Dollar",
      "doNotInsertRepayment": "Urutan pembiayaan telah selesai dan pesanan pembayaran tidak dapat ditambahkan.",
      "grantAccount": "Akun penerbitan pembiayaan",
      "financingEndTime": "Tanggal jatuh tempo pembiayaan",
      "repaymentSource": "Sumber pembayaran kembali",
      "newBusinessLicense": "Lisensi bisnis baru",
      "additionalPaymentInfo": "Informasi pembayaran tambahan",
      "aplicationFee": "Bunga",
      "applicationMoney": "Jumlah aplikasi",
      "close": "Tutup",
      "LockAcountNow": "Saat ini mengunci mata uang z",
      "certificateImage": "Gambar sertifikat",
      "oldBusinessLicense": "Izin usaha lama",
      "dueMethods": "Metode pembayaran kembali",
      "financingApplicationInfor": "Informasi aplikasi kontrak pembiayaan",
      "yes": "Ya",
      "repaymentIdNotNull": "ID alur pembayaran tidak boleh kosong",
      "waitToModify": "Untuk dimodifikasi",
      "additionalPayments": "Jumlah pembayaran tambahan",
      "waitToComfim": "Belum dikonfirmasi",
      "billChoose": "Pilihan mata uang",
      "modify": "Ubah",
      "pleaseInputAmonut": "Harap masukkan jumlahnya",
      "financingMoney": "Jumlah pembiayaan",
      "createTime": "Waktu perekaman",
      "dueAmount": "Jumlah pembayaran kembali",
      "purchaseOrder": "Pesanan pembelian transaksi",
      "pleaseUploadFile": "Harap unggah file",
      "10001": "Jumlah input adalah ilegal",
      "zCoin": "z koin",
      "addremark": "Penyebab tambahan",
      "tradingContract": "Kontrak transaksi",
      "repaymentTime": "Waktu pembayaran",
      "fileUploadMaximumOf5": "Unggah hingga 5 file",
      "return": "Kembali",
      "account": "Akun"
    },
    "home": {
      "accountTotalMoney": "Total akun",
      "safeMail": "Kotak surat verifikasi keamanan",
      "getDicDataFailed": "Gagal mendapatkan data dari tabel kamus",
      "bonusShenqing": "Aplikasi Dividen",
      "accFlowLists": "Aliran akun",
      "cashRecord": "Penarikan catatan",
      "bankAcc": "Rekening bank",
      "accInfo": "Informasi akun",
      "cashApply": "Aplikasi penarikan",
      "accountcenter": "Pusat akun",
      "availableBalance": "Saldo yang tersedia",
      "manage": "Manajemen",
      "lastLoginTime": "Waktu masuk terakhir",
      "bonusSuoding": "Kunci dividen",
      "addAcc": "Tambahkan akun",
      "contactNumber": "Nomor kontak",
      "bonusShouyi": "Pendapatan dividen",
      "languageCannotNull": "Bahasa tidak boleh kosong",
      "lastRevenue": "Air terbaru",
      "fax": "Faks",
      "freezingQuota": "Bekukan kuota",
      "contacts": "Kontak",
      "bonusGuanli": "Manajemen dividen"
    },
    "extractCrashStatus": {
      "0": "Semua",
      "1": "Aplikasi",
      "2": "Telah dialihkan"
    },
    "withdrawCash": {
      "400002": "Silakan pilih mata uang penarikan uang tunai",
      "400013": "Saldo akun tidak mencukupi",
      "400003": "Silakan isi jumlah uang tunai",
      "400014": "Verifikasi kode verifikasi",
      "400011": "Tidak memiliki hak penarikan uang tunai",
      "400001": "Silakan isi kode verifikasi",
      "400012": "Kesalahan parameter",
      "400010": "Belum mengatur kotak pesan, silakan mengatur kotak pesan aman",
      "400008": "Penarikan uang tunai sukses",
      "400009": "ID detail tidak boleh kosong",
      "400017": "Data telah berubah, silakan refresh halaman",
      "400006": "Email dikirim terlalu sering, silakan coba lagi nanti",
      "400007": "Kesalahan masukan kode verifikasi",
      "400015": "Kegagalan penarikan tunai",
      "400004": "Silakan pilih kartu tunai",
      "400016": "Penarikan uang ilegal",
      "400005": "Belum ada ekspor data"
    },
    "btns": {
      "cancel": "Batalkan",
      "tqjs": "Buka kunci sebelumnya",
      "ensureUnlock": "Konfirmasikan pembukaan kunci",
      "query": "Query",
      "detail": "Detail",
      "downLoadData": "Unduh data",
      "ensureExtract": "Konfirmasikan ekstraksi",
      "tq": "Ekstraksi"
    },
    "depositStatus": {
      "0": "Semua",
      "1": "Dividen",
      "2": "Dikeluarkan",
      "3": "Hidupkan kembali"
    },
    "extractCrashDetail": {
      "proceedName": "Nama penerima pembayaran",
      "remittanceDate": "Waktu pengiriman",
      "turnOutAmount": "Jumlah remitansi",
      "swiftCode": "Hentikan kode SWIFT",
      "bankName": "Nama lengkap bank",
      "proceedAccount": "Akun penerima pembayaran",
      "transferBankAccount": "Akun pengiriman uang",
      "tips": "* Jika bank belum tiba, silakan hubungi layanan pelanggan akun bank Anda untuk pertanyaan. Jika Anda memiliki pertanyaan lebih lanjut, hubungi [+65 6379 1324]",
      "amountExtraction": "Ajukan permohonan penarikan",
      "flowNumber": "Nomor arus kas",
      "serviceCharge": "Biaya penanganan",
      "detailedAddress": "Alamat rinci bank",
      "moneyLable": "Mata uang penarikan uang tunai",
      "transferBankName": "Bank pengiriman uang",
      "fileList": "Mentransfer sertifikat",
      "extractCrashDetailTitle": "Detail penarikan uang tunai"
    },
    "extractType": {
      "1": "Penarikan bank"
    },
    "depositType": {
      "1": "Periode saat ini",
      "2": "Secara teratur"
    },
    "chaincount": {
      "all": "Semua",
      "myHome": "Akun saya",
      "serialNumber": "Nomor aliran bisnis",
      "chainCount": "Statistik Blockchain",
      "financingApply": "Aplikasi pembiayaan",
      "bonusApply": "Aplikasi Dividen",
      "profitBonus": "Penghasilan dividen",
      "handle": "Sedang diproses",
      "fail": "Kegagalan",
      "appendRepayment": "Membiayai pembayaran tambahan",
      "transferActivity": "Aktivitas transmisi",
      "success": "Sukses",
      "chainSum": "Jumlah total gulungan",
      "details": "Detail",
      "state": "Negara",
      "day": "Hari",
      "cash": "Penarikan",
      "chainTime": "Waktu berliku",
      "financingLoan": "Pembiayaan pembiayaan",
      "repayment": "Pembayaran pembiayaan"
    }
  },
  ms: {
    "login": {
      "login": "Masuk",
      "title": "Pakar perdagangan b2b global",
      "myAcc": "Akaun saya",
      "logout": "Log keluar",
      "myFinancing": "Pembiayaan saya",
    },
  },
  nl: {
    "flowLists": {
      "flowNumber": "Lopend waternummer",
      "incomeTr": "inkomsten",
      "flowListsTitle": "Stroom detail",
      "createTime": "datum",
      "ebalanceAmount": "balans",
      "detailTr": "detail",
      "remarkType": "overzicht",
      "expenditureTr": "uitgaven"
    },
    "frontPage": {
      "Error404": "Het pad bestaat niet. Controleer of het pad correct is.",
      "annualIncome": "Jaarlijkse inkomsten",
      "z_currency": "z-munt",
      "missSendEmailType": "Ontbrekend verzendberichttype",
      "back": "terugkeer",
      "UploadFailure": "Upload mislukt",
      "CurrencyDollar": "dollar",
      "updateEmailSendCode": "Wijzig de postbusverificatiecode",
      "missEmailTemplate": "Ontbrekende e-mailsjabloon",
      "CurrencyHongKong": "Hong Kong dollar",
      "missSubject": "Ontbrekende berichtkop",
      "noTime": "geen",
      "missUserId": "Ontbrekende gebruikersnaam voor verzendbestemming",
      "missFile": "Ontbrekend bestand",
      "startTime": "Starttijd",
      "accountTypeMiss": "Gebruikerstype mag niet leeg zijn",
      "NotFile": "Het bestandsformaat is niet correct, upload het opnieuw!",
      "login_timeout": "Inloggen time-out",
      "Error500": "Systeemuitzondering. Neem contact op met de beheerder.",
      "moneyArrivaNotice": "Aankondiging van aankomst",
      "CurrencyJPY": "Japanse Yen",
      "missUserType": "Ontbrekend gebruikerstype",
      "selectTime": "Selecteer alstublieft tijd",
      "miss_field_version": "Ontbrekend versienummer",
      "fileCodeCannotEmpty": "Bestands unieke ID mag niet leeg zijn",
      "uploadPersonNotNull": "Uploader kan niet leeg zijn",
      "missEmail": "Ontbrekende mailbox",
      "l_currency": "Juridische valuta",
      "missEmailParam": "Ontbrekende e-mailparameters",
      "miss_token": "Token ontbreekt",
      "notPicType": "Geen afbeeldingstype",
      "youHaveNoPermission": "U hebt geen toestemming om het bestand te downloaden",
      "fileIsNullOrDeleted": "Het bestand bestaat niet of is verwijderd",
      "drawSendCode": "Verificatiecode voor uitbetalen",
      "businessTypeCannotEmpty": "Bestandsbron mag niet leeg zijn",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "Momenteel geüploade afbeelding mislukte beveiligingscontrole",
      "businessCodeCannotEmpty": "De unieke id van de bestandsbron mag niet leeg zijn",
      "noData": "Nog geen gegevens",
      "endTime": "termijn",
      "time": "tijd",
      "pleaseChoose": "Kies alstublieft",
      "notEmpty": "Mag niet leeg zijn",
      "CurrencySingapore": "Singapore",
      "status": "staat"
    },
    "bonusApply": {
      "200007": "De basisgegevens van het dividend zijn abnormaal.",
      "bonusApplyInputPlaceHolder": "Huidig ​​herdistribueerbaar saldo",
      "200006": "Het aanvraagbedrag is groter dan het beschikbare dividend",
      "200009": "Kan een batchgebruikersaccount niet financieren",
      "200008": "Batch-update periodieke dividenden mislukt",
      "200003": "De gegevens zijn gewijzigd, vernieuw de pagina",
      "200002": "Je hebt dividenden verboden, neem contact op met de beheerder",
      "200005": "Het overboekingsbedrag is niet leeg!",
      "200004": "De gegevens zijn abnormaal, neem contact op met de systeembeheerder",
      "200010": "Batch gebruiker live dividenden mislukt",
      "200012": "Startdatum kan niet leeg zijn",
      "200011": "De tabelgegevens van gebruikersaccounts zijn abnormaal",
      "bonusApplyInputLabel": "Dividenden aanvragen",
      "bonusApplyType1": "Huidige periode",
      "100013": "Abnormale parameter",
      "bonusApplyType2": "regelmatig",
      "btn": "Begin met dividenden",
      "bonusApplyTitle": "Dividend applicatie",
      "bonusApplyInputErr2": "Het invoernummer groter dan 0 is kleiner dan het huidige beschikbare dividend en maximaal 2 decimalen",
      "bonusApplyTip1": "* U moet nog steeds een financiering betalen",
      "200013": "Einddatum kan niet leeg zijn",
      "bonusApplyInputErr1": "Voer het bedrag in",
      "bonusApplyTip2": "Terugbetaling vereist",
      "200001": "Niet ingelogd",
      "bonusApplySuccess": "Succesvolle aanvraag voor dividenden"
    },
    "login": {
      "VerificationCodeMissing": "Voer de verificatiecode in",
      "rongziwei": "Financieringsaanvraag is een grote b2b snelle handelsfinancieringsfunctie op basis van blockchain virtuele valutatechnologie die door cic wordt aangeboden aan specifieke gebruikersgroepen.",
      "nameOrPwdError": "Fout bij gebruikersnaam of wachtwoord",
      "jiesheng": "Bespaar de kosten van traditionele handelsbrieven",
      "InvalidCaptchaKey": "Verstreken verificatie code sleutel",
      "pleasePassword": "Voer uw wachtwoord in",
      "bushouxianzhi": "Overboekingen die niet onderhevig zijn aan tijd en geografische beperkingen",
      "login": "inloggen",
      "title": "Maak de transactie glad voor Jane",
      "myAcc": "Mijn account",
      "pleaseUsername": "Voer een accountnummer in",
      "logout": "Afmelden",
      "myFinancing": "Mijn financiering",
      "xinyong": "Credit afneembaar",
      "pleaseKaptcha": "Voer de verificatiecode in",
      "nianlilv": "Jaarlijkse financieringstabel zo laag als 3,1%",
      "validCodeError": "Verificatie code fout",
      "validCodeExpired": "Verificatiecode is verlopen",
      "userNotExit": "Gebruiker bestaat niet",
      "loginDisabled": "Account is uitgeschakeld",
      "fuwu": "Als u geïnteresseerd bent in het gebruik van deze service, belt u dan met de servicehotline.",
      "coin": "valuta"
    },
    "cashApply": {
      "exMoney": "Aanvraag intrekken",
      "availableCredit": "Beschikbare balans",
      "select": "Kies alstublieft",
      "bankCard": "Intrekking van bankkaart",
      "sendCode": "Verzend verificatiecode",
      "available": "Voer het opnamebedrag momenteel in",
      "title": "z munten opname applicatie",
      "emCode": "Voer de ontvangen e-mailbeveiligingsverificatiecode in",
      "cashApply": "Aanvraag intrekken",
      "confCash": "Bevestig de opname",
      "tips": "* Het platform brengt geen kosten in rekening en de bankkosten voor de opname worden door de bank geïnd en van de daadwerkelijke rekening afgeschreven.",
      "newBank": "+ Voeg een bankkaart toe",
      "cashConf": "Bevestiging van geldopname",
      "usable": "beschikbaar",
      "sentSuccess": "Verzend de verificatiecode is succesvol, ga naar de mailbox om te bekijken",
      "moneyValue": "valuta",
      "sumCredit": "Mijn totale aantal c-munten",
      "useAmount": "Z-valuta opnamebedrag",
      "coin": "Z-munt"
    },
    "bank": {
      "300005": "Het gebied is niet leeg",
      "300016": "Naam begunstigde maximale lengte 100",
      "300017": "Maximale lengte van de begunstigde account 100",
      "300006": "De volledige naam van de bank is niet leeg",
      "300003": "Het kaartnummer wordt herhaald, voer het opnieuw in",
      "300014": "Swift code maximale lengte 100",
      "300015": "Naam begunstigde maximale lengte 200",
      "300004": "Aanmeldingsgegevens zijn niet leeg",
      "300009": "Naam begunstigde is niet leeg",
      "300007": "Swift-code is niet leeg",
      "300018": "Valuta maximale lengte 100",
      "300019": "Loginpersoon-ID is niet leeg",
      "300008": "Het gedetailleerde adres van de bank is niet leeg",
      "300020": "Primaire sleutel-ID is niet leeg",
      "300023": "Gebruikers-ID is niet leeg",
      "300012": "Landcode maximale lengte 200",
      "300001": "Log alstublieft in",
      "300024": "De gegevens zijn gewijzigd, vernieuw de pagina",
      "300002": "Kan gebruikers-ID niet ophalen",
      "300013": "Bank volledige naam maximale lengte 200",
      "300010": "Payee-account is niet leeg",
      "300011": "Valuta is niet leeg",
      "300022": "Kaartnummer is niet leeg"
    },
    "chainDetails": {
      "add": "nieuw",
      "fileName": "Bestandsnaam",
      "dataType": "Gegevenstype",
      "clickToDownload": "Klik om te downloaden",
      "fileInfo": "Bestandsinformatie",
      "update": "bijwerken",
      "remark": "opmerking",
      "title": "opschrift",
      "completeInfo": "Volledige informatie",
      "chainDetails": "Blockchain-details",
      "downloadLink": "Download adres",
      "summaryInfo": "Samenvatting informatie",
      "dataOverview": "Gegevensoverzicht",
      "report": "verslag",
      "reportDescription": "Beschrijving van het rapport",
      "lastData": "Volgende gegevens",
      "platformName": "Platform naam",
      "value": "inhoud",
      "fileType": "Bestandstype",
      "preData": "Vorige gegevens"
    },
    "bankList": {
      "cancel": "geannuleerd",
      "proceedName": "Naam begunstigde",
      "country": "regio",
      "bankFullName": "Bank volledige naam",
      "bankCreate": "Maak een bankkaart",
      "swiftCode": "Swift-code",
      "proceedAccount": "Payee-account",
      "title": "Beheer van bankrekeningen",
      "bankAdd": "Account toevoegen",
      "confirm": "bepalen",
      "delConf": "Weet je zeker dat je deze bankrekening wilt verwijderen?",
      "detailedAddress": "Bank gedetailleerd adres",
      "supportCurrency": "Ondersteuning valuta"
    },
    "bonusLists": {
      "all": "compleet",
      "originalMoneyTr": "Dividend hoofdsom",
      "annualIncomeTr": "Dividend rendement",
      "serialNumberTr": "Lopend waternummer",
      "createTimeTr": "datum",
      "lastInterestDateTr": "Dividend-afwikkelingsdatum",
      "bonusListsTitle": "Dividend management",
      "statusTr": "staat",
      "detailTr": "detail",
      "bonusListsApplyBtn": "Dividenden aanvragen",
      "typeTr": "overzicht",
      "dividend": "in dividenden",
      "turnToLive": "Draai om te leven",
      "issued": "uitgegeven"
    },
    "extractCrashLists": {
      "all": "compleet",
      "hasBeenTransferredOut": "Is overgedragen",
      "flowNumberTr": "Lopend waternummer",
      "createTimeTr": "datum",
      "extractCrashListsTitle": "Contante opname details",
      "statusTr": "staat",
      "detailTr": "detail",
      "withdrawalBankTr": "Geldopname bank",
      "serviceChargeTr": "Verwerkingskosten",
      "application": "toepassing",
      "amountExtractionTr": "Opname bedrag",
      "turnOutAmountTr": "Overboeking bedrag",
      "remarkTr": "overzicht"
    },
    "financing": {
      "all": "compleet",
      "andTranscationg": "Transactie met verbonden partijen",
      "financing_completed": "Financiering afgerond",
      "financingaplicationAmount": "Financieringsaanvraagbedrag",
      "aplicationTime": "Toepassingstijd",
      "application_status_repayment": "afwachting van de terugbetaling",
      "view": "onderzoek",
      "pleaseWrite": "Voer alstublieft in",
      "financingandOrderNum": "Het bijbehorende ordernummer financieren",
      "draft": "ontwerp",
      "function": "functie",
      "financingaplicationNum": "Aanvraagnummer van de financiering",
      "financing": "Mijn financiering",
      "startTime": "Starttijd",
      "noData": "Nog geen gegevens",
      "financingStatus": "Financieringsstatus",
      "details": "detail",
      "endTime": "termijn",
      "reimbursement": "terugbetaling",
      "still_hospitality_confirmation": "Nog steeds bevestiging van de gastvrijheid",
      "financingNumber": "Het serienummer van de financiering",
      "status": "staat",
      "coin": "valuta"
    },
    "flowListsType": {
      "1": "Overdracht",
      "2": "Financiering van de terugbetaling",
      "3": "Dividend overdracht",
      "4": "Dividend overdracht",
      "5": "Financiering overdracht"
    },
    "resetpassword": {
      "newPasswordCannotSame": "Het nieuwe wachtwoord kan niet hetzelfde zijn als het originele wachtwoord",
      "PasswordFormatIncorrect": "Het wachtwoordformaat is niet correct, verander alstublieft",
      "newPasswordNotFormatted": "De nieuwe wachtwoordlengte is niet correct geformatteerd, gelieve te veranderen",
      "originalPasswordIncorrectly": "Het originele wachtwoord is verkeerd ingevoerd.",
      "passwordIsInconsistent": "Het wachtwoord is niet consistent met het bevestigingswachtwoord"
    },
    "moneyChangeLog": {
      "100010": "Startdatum kan niet leeg zijn",
      "100011": "Einddatum kan niet leeg zijn",
      "100009": "De gegevens zijn gewijzigd, vernieuw de pagina",
      "100001": "Gebruikers-ID is niet leeg",
      "100012": "Personeelsinformatie is leeg",
      "100002": "De primaire sleutel-id van de tabel waarin het resumetype is gelokaliseerd, is niet leeg.",
      "100013": "Abnormale parameter",
      "100003": "Samenvattingstype is niet leeg",
      "100014": "Abnormale gegevens",
      "100004": "Het hoeveelheidtype is niet leeg",
      "100005": "Het bedrag is niet leeg",
      "100006": "Log alstublieft in",
      "100007": "Kan gebruikers-ID niet ophalen",
      "100008": "Geen stroomgegevens exporteren"
    },
    "bonusDetail": {
      "fh": "dividend",
      "tqzq": "Extractie opname",
      "expectIncome": "Verwacht rendement",
      "bj": "principaal",
      "type": "Dividend type",
      "tips": "Waarschuwing: als de ontgrendeling niet vooraf is verlopen, wordt de rente berekend volgens de financiële tijd!",
      "200004": "Abnormale gegevens",
      "principal": "Ontgrendel de principal",
      "bonusRegularDetailTime": "tijd",
      "unlockSuccess": "Ontgrendeld met succes",
      "tqSuccess": "Succesvolle extractie",
      "bonusRegularDetailStatus": "Interesse type",
      "startAndEndTime": "Start- en einddatum van het dividendplan",
      "lastInterestDate": "Dividendbetalingsdatum",
      "interest": "Werkelijk inkomen",
      "ljsy": "Cumulatief inkomen",
      "bonusRegularDetailOriginalMoney": "principaal",
      "jshzce": "Waarde overdragen na ontgrendeling",
      "serialNumber": "Lopend waternummer",
      "bonusRegularDetailInterest": "dividend",
      "jxr": "Rentedragende dag",
      "bonusDetailTitle": "Dividendlijst",
      "tqTitle": "extract",
      "mrfhjsb": "Dagelijks dividendoverzicht",
      "100009": "De gegevens zijn gewijzigd, vernieuw de pagina",
      "bonusWay": "Dividend schema",
      "dqjbe": "Huidig ​​basisbedrag",
      "tqjsTitle": "Ontgrendel van tevoren",
      "jsb": "Afrekening verklaring",
      "originalMoney": "Basisdividend"
    },
    "nav": {
      "index": "Mijn account"
    },
    "accountcenter": {
      "emailNotExist": "Stel eerst de mailbox in",
      "sendCodeMail": "Verzend verificatiecode naar de huidige mailbox",
      "safeMail": "Beveiligde mailbox",
      "chainData": "Windende gegevens",
      "bankCard": "Betaalpas",
      "sendMailFrequently": "Stuur geen e-mail vaak, het duurt 10 minuten",
      "missCode": "Ontbrekende verificatiecode",
      "emailFormatError": "Onjuiste mailbox-indeling",
      "back": "terugkeer",
      "lastMailTime": "Laatste e-mailtijd",
      "sendEmailError": "Verzenden van e-mail mislukt",
      "lastMailType": "Laatst gemaild",
      "theEmailHasBeenUsed": "De mailbox is gebruikt",
      "manageBankCard": "Beheer bankkaart",
      "cofirm": "Controleer de nieuwe mailbox",
      "accCenter": "Accountcentrum",
      "getWeb": "Bekijk website",
      "myBankCard": "Mijn bankkaart",
      "emailLengthError": "Mailboxlengte formaat fout",
      "sendSuc": "Verzonden",
      "safePhone": "Veilige telefoon",
      "editEmailError": "Update mailbox mislukt",
      "errorCodeTypeParam": "Parameterfout verificatietypetype",
      "missEmail": "Ontbrekende mailbox",
      "sendCOde": "Verzend verificatiecode",
      "missEmailParam": "Ontbrekende mailbox-parameters",
      "accSafe": "Accountbeveiliging",
      "codeInvalid": "Verificatiecode is verlopen",
      "blockChain": "Block keten",
      "resetSuc": "Met succes gewijzigd",
      "trade": "transactie",
      "myTradeAcc": "Mijn handelsaccount",
      "pleaseNewMail": "Voer een nieuw e-mailadres in",
      "pleaseCode": "Voer de verificatiecode in",
      "codeError": "Verificatie code fout",
      "safe": "veiligheid",
      "youHaveBoundTheEmail": "De mailbox die je hebt ingebonden",
      "nextStep": "Volgende stap",
      "verifyMail": "voorleggen",
      "resetMail": "Wijzig mailbox",
      "cic": "Wereld koopwaar Intelligentie Handelscentrum",
      "myWebAcc": "Mijn digitale account",
      "rongzi": "financiering Money"
    },
    "financingDetails": {
      "seller": "verkoper",
      "repaymentAmountLimit": "Voer een getal groter dan 0 in en minder dan 1000000000 voor het terugbetalingsbedrag.",
      "reason": "reden",
      "amountLessThanAvailable": "Het terugbetalingsbedrag kan niet groter zijn dan het beschikbare saldo",
      "getFinancingDetailFail": "Kan financieringsgegevens niet opvragen",
      "pleaseSelectAcountCard": "Selecteer een afbetalingsrekening",
      "lookrepaymentAmount": "Terugbetalingsbedrag",
      "hasComfimed": "bevestigd",
      "financingContractInfor": "Informatie over het contract financieren",
      "legalMoney": "Juridische valuta",
      "dueInfo": "Terugbetalingsinformatie",
      "regCode": "Registratie code",
      "flowNumber": "Het serienummer van de aanvraag van de aanvraag",
      "wrongAccount": "U bent niet gemachtigd om deze gegevens te bekijken",
      "financingMethod": "Financieringsmethode",
      "expectedRepaymentPeriod": "Verwachte aflossingsperiode",
      "isLocked": "Of het slot na de release wordt vergrendeld",
      "doNotInsertRepaymentByState": "Terugbetalingshistorie van huidige financieringsgegevens die moeten worden bevestigd of gewijzigd, mogen niet worden toegevoegd",
      "acountMustInput": "Terugbetalingsbedrag is vereist",
      "details": "detail",
      "applicationAccount": "Account van de aanvrager",
      "reimbursement": "terugbetaling",
      "comfirm": "bepalen",
      "repaymentAccountIdNotNull": "Overschrijvingsaccount kan niet leeg zijn",
      "systemComfim": "Systeem bevestiging",
      "companyCode": "Voer de bedrijfsregistratiecode in",
      "overdueAmount": "Extra terugbetalingsbedrag",
      "upLoadenclosureCode": "Upload bijlage",
      "viewLook": "uitzicht",
      "repaymentTypeNotNull": "Terugbetalingsmethode mag niet leeg zijn",
      "authCodeStr": "Verificatietype",
      "dueTime": "Terugbetaling tijd",
      "salesOrder": "Transactie verkooporder",
      "buyer": "koper",
      "newdue": "Nieuwe terugbetaling",
      "pleaseChoseBill": "Selecteer een valuta",
      "pleaseSelectPaymethod": "Kies de betalingsmethode",
      "financingStartTime": "Startdatum van de financiering",
      "orderAcount": "Bestelbedrag",
      "guaranteeType": "Soort garantie",
      "financingUse": "Financiering gebruik",
      "uploadAttachmentsNotEmpty": "Bijlage mag niet leeg zijn",
      "payeeAccountCanuseNow": "Huidig ​​beschikbaar terugbetalingsbedrag",
      "repaymentAccount": "Financiering van de aflossingsrekening",
      "countryName": "land",
      "payeeAccount": "Overschrijvingsrekening",
      "coin": "valuta",
      "addoverdueAmount": "Extra bedrag",
      "repaymentMethod": "Terugbetalingsmethode",
      "no": "geen",
      "financingaplayBook": "Financieringsaanvraag",
      "currencyTypeNotNull": "Valuta kan niet leeg zijn",
      "pleaseSelectremittanceA": "Selecteer een overboekingsaccount",
      "currentAccountDoNotInsert": "Huidige registrant kan niet terugbetalen",
      "enclosureCode": "medeplichtig",
      "repaymentAmountNotNull": "Het bedrag van de terugbetaling mag niet leeg zijn",
      "orderNum": "Bestelnummer",
      "dorla": "US dollar",
      "doNotInsertRepayment": "De financieringsorder is voltooid en de terugbetalingsorder kan niet worden toegevoegd.",
      "grantAccount": "Financiering uitgevende account",
      "financingEndTime": "Financiering vervaldatum",
      "repaymentSource": "Terugbetalingsbron",
      "newBusinessLicense": "Nieuwe zakelijke licentie",
      "additionalPaymentInfo": "Aanvullende informatie over terugbetaling",
      "aplicationFee": "rente",
      "applicationMoney": "Toepassing hoeveelheid",
      "close": "dicht",
      "LockAcountNow": "Momenteel geblokkeerde z-valuta",
      "certificateImage": "Certificaatafbeelding",
      "oldBusinessLicense": "Oude zakelijke licentie",
      "dueMethods": "Terugbetalingsmethode",
      "financingApplicationInfor": "Informatie over de aanvraag van de financieringsovereenkomst",
      "yes": "Het is",
      "repaymentIdNotNull": "ID van de terugbetalingsstroom mag niet leeg zijn",
      "waitToModify": "Moet worden gewijzigd",
      "additionalPayments": "Extra terugbetalingsbedrag",
      "waitToComfim": "niet bevestigd",
      "billChoose": "Valutaselectie",
      "modify": "wijziging",
      "pleaseInputAmonut": "Voer het bedrag in",
      "financingMoney": "Financieringsbedrag",
      "createTime": "Opnametijd",
      "dueAmount": "Terugbetalingsbedrag",
      "purchaseOrder": "Transactie inkooporder",
      "pleaseUploadFile": "Upload een bestand",
      "10001": "Hoeveelheid invoer is illegaal",
      "zCoin": "z-munt",
      "addremark": "Aanvullende oorzaak",
      "tradingContract": "Transactiecontract",
      "repaymentTime": "Terugbetaling tijd",
      "fileUploadMaximumOf5": "Upload maximaal 5 bestanden",
      "return": "terugkeer",
      "account": "rekening"
    },
    "home": {
      "accountTotalMoney": "Totaal account",
      "safeMail": "Beveiligingsverificatiepostvak",
      "getDicDataFailed": "Het ophalen van gegevens uit de woordenboektabel is mislukt",
      "bonusShenqing": "Dividend applicatie",
      "accFlowLists": "Accountstroom",
      "cashRecord": "Opname record",
      "bankAcc": "Bankrekening",
      "accInfo": "Account informatie",
      "cashApply": "Opname aanvraag",
      "accountcenter": "Accountcentrum",
      "availableBalance": "Beschikbare balans",
      "manage": "beheer",
      "lastLoginTime": "Laatste inlogtijd",
      "bonusSuoding": "Dividend lock",
      "addAcc": "Account toevoegen",
      "contactNumber": "Contact nummer",
      "bonusShouyi": "Dividend inkomen",
      "languageCannotNull": "Taal kan niet leeg zijn",
      "lastRevenue": "Het nieuwste water",
      "fax": "fax",
      "freezingQuota": "Free quota",
      "contacts": "contact",
      "bonusGuanli": "Dividend management"
    },
    "extractCrashStatus": {
      "0": "compleet",
      "1": "toepassing",
      "2": "Is overgedragen"
    },
    "withdrawCash": {
      "400002": "Selecteer de valuta voor contant opnemen",
      "400013": "Onvoldoende rekeningsaldo",
      "400003": "Vul alstublieft het bedrag in",
      "400014": "Verificatie code ongeldig",
      "400011": "Heeft geen recht op geldopname",
      "400001": "Vul de verificatiecode in",
      "400012": "Parameterfout",
      "400010": "Heeft u geen mailbox ingesteld, stel dan een beveiligde mailbox in",
      "400008": "Geldopname succes",
      "400009": "Details-ID mag niet leeg zijn",
      "400017": "De gegevens zijn gewijzigd, vernieuw de pagina",
      "400006": "E-mail wordt te vaak verzonden, probeer het later opnieuw",
      "400007": "Verificatiecode invoerfout",
      "400015": "Mislukken van geldopname",
      "400004": "Kies een betaalpas",
      "400016": "Illegale geldopname",
      "400005": "Nog geen gegevens geëxporteerd"
    },
    "btns": {
      "cancel": "geannuleerd",
      "tqjs": "Ontgrendel van tevoren",
      "ensureUnlock": "Bevestig ontgrendelen",
      "query": "onderzoek",
      "detail": "detail",
      "downLoadData": "Gegevens downloaden",
      "ensureExtract": "Bevestig extractie",
      "tq": "extract"
    },
    "depositStatus": {
      "0": "compleet",
      "1": "in dividenden",
      "2": "uitgegeven",
      "3": "Draai om te leven"
    },
    "extractCrashDetail": {
      "proceedName": "Naam begunstigde",
      "remittanceDate": "Overschrijvingstijd",
      "turnOutAmount": "Afdrachtbedrag",
      "swiftCode": "SWIFT-code uitbetalen",
      "bankName": "Bank volledige naam",
      "proceedAccount": "Payee-account",
      "transferBankAccount": "Overschrijvingsrekening",
      "tips": "* Als de bank nog niet is gearriveerd, neem dan contact op met de klantenservice van uw bankrekening. Als u nog vragen heeft, kunt u bellen met [+65 6379 1324]",
      "amountExtraction": "Aanvraag intrekken",
      "flowNumber": "Cash flow nummer",
      "serviceCharge": "Verwerkingskosten",
      "detailedAddress": "Bank gedetailleerd adres",
      "moneyLable": "Cash opname valuta",
      "transferBankName": "Overschrijving bank",
      "fileList": "Certificaat overdragen",
      "extractCrashDetailTitle": "Contante opname details"
    },
    "extractType": {
      "1": "Bank opname"
    },
    "depositType": {
      "1": "Huidige periode",
      "2": "regelmatig"
    },
    "chaincount": {
      "all": "compleet",
      "myHome": "Mijn account",
      "serialNumber": "Bedrijfsstroomnummer",
      "chainCount": "Blockchain-statistieken",
      "financingApply": "Financieringsaanvraag",
      "bonusApply": "Dividend applicatie",
      "profitBonus": "Inkomend dividend",
      "handle": "Processing",
      "fail": "mislukking",
      "appendRepayment": "Financiering van extra terugbetaling",
      "transferActivity": "Overdracht activiteit",
      "success": "succes",
      "chainSum": "Totaal aantal wikkelingen",
      "details": "detail",
      "state": "staat",
      "day": "dag",
      "cash": "terugtrekken",
      "chainTime": "Kronkelende tijd",
      "financingLoan": "Financiering van leningen",
      "repayment": "Financiering van de terugbetaling"
    }
  },
  es: {
    "flowLists": {
      "flowNumber": "Numero de agua corriente",
      "incomeTr": "Ingresos",
      "flowListsTitle": "Detalle de flujo",
      "createTime": "Fecha",
      "ebalanceAmount": "Balance",
      "detailTr": "Detalle",
      "remarkType": "Resumen",
      "expenditureTr": "Gastos"
    },
    "frontPage": {
      "Error404": "La ruta no existe, comprueba si la ruta es correcta.",
      "annualIncome": "Ingreso anualizado",
      "z_currency": "z moneda",
      "missSendEmailType": "Falta el tipo de mensaje de envío",
      "back": "Regreso",
      "UploadFailure": "Carga fallida",
      "CurrencyDollar": "dólar",
      "updateEmailSendCode": "Modificar el código de verificación del buzón.",
      "missEmailTemplate": "Falta la plantilla de correo",
      "CurrencyHongKong": "Dolar de Hong Kong",
      "missSubject": "Falta el encabezado del mensaje",
      "noTime": "No",
      "missUserId": "Falta el ID de usuario de destino de envío",
      "missFile": "Archivo faltante",
      "startTime": "Hora de inicio",
      "accountTypeMiss": "El tipo de usuario no puede estar vacío",
      "NotFile": "El formato del archivo es incorrecto, por favor vuelva a subir!",
      "login_timeout": "Inicio de Sesión Finalizado",
      "Error500": "El sistema está anormal. Contacta con el administrador.",
      "moneyArrivaNotice": "Aviso de llegada",
      "CurrencyJPY": "Guay",
      "missUserType": "Falta el tipo de usuario",
      "selectTime": "Por favor seleccione tiempo",
      "miss_field_version": "Número de versión perdido",
      "fileCodeCannotEmpty": "El identificador único del archivo no puede estar vacío",
      "uploadPersonNotNull": "El cargador no puede estar vacío",
      "missEmail": "Buzón perdido",
      "l_currency": "Moneda legal",
      "missEmailParam": "Parámetros de correo faltantes",
      "miss_token": "Falta token",
      "notPicType": "No tipo de imagen",
      "youHaveNoPermission": "No tienes permiso para descargar el archivo.",
      "fileIsNullOrDeleted": "El archivo no existe o ha sido eliminado",
      "drawSendCode": "Código de verificación de retiro",
      "businessTypeCannotEmpty": "La fuente del archivo no puede estar vacía",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "La imagen cargada actualmente falló el control de seguridad",
      "businessCodeCannotEmpty": "El identificador único de la fuente del archivo no puede estar vacío",
      "noData": "Aún no hay datos",
      "endTime": "Fecha límite",
      "time": "Tiempo",
      "pleaseChoose": "Por favor elija",
      "notEmpty": "No puede estar vacio",
      "CurrencySingapore": "Singapur",
      "status": "Estado"
    },
    "bonusApply": {
      "200007": "Los datos básicos del dividendo son anormales.",
      "bonusApplyInputPlaceHolder": "Saldo redistribuible actual.",
      "200006": "El monto de la solicitud es mayor que el saldo de dividendos disponible",
      "200009": "Error al financiar una cuenta de usuario por lotes",
      "200008": "Los dividendos periódicos de la actualización por lotes fallaron",
      "200003": "Los datos han cambiado, por favor actualice la página.",
      "200002": "Usted ha prohibido dividendos, por favor contacte al administrador.",
      "200005": "El importe de la transferencia no está vacío!",
      "200004": "Los datos son anormales, por favor contacte al administrador del sistema.",
      "200010": "Los dividendos en vivo del usuario por lotes fallaron",
      "200012": "La fecha de inicio no puede estar vacía",
      "200011": "Los datos de la tabla de cuentas de los fondos del usuario son anormales",
      "bonusApplyInputLabel": "Solicitar dividendos",
      "bonusApplyType1": "Periodo actual",
      "100013": "Parámetro anormal",
      "bonusApplyType2": "Regularmente",
      "btn": "Empezar a obtener dividendos",
      "bonusApplyTitle": "Aplicacion de dividendos",
      "bonusApplyInputErr2": "El número de entrada mayor que 0 es menor que el dividendo disponible actual y hasta 2 decimales",
      "bonusApplyTip1": "* Usted todavía tiene un pago de financiación será",
      "200013": "La fecha de finalización no puede estar vacía",
      "bonusApplyInputErr1": "Por favor ingrese la cantidad",
      "bonusApplyTip2": "Reembolso requerido",
      "200001": "No ha iniciado sesión",
      "bonusApplySuccess": "Aplicación exitosa de dividendos."
    },
    "login": {
      "VerificationCodeMissing": "Por favor ingrese el código de verificación",
      "rongziwei": "La aplicación de financiamiento es una gran función de financiamiento de comercio rápido b2b basada en la tecnología de moneda virtual blockchain que proporciona cic a grupos de usuarios específicos.",
      "nameOrPwdError": "El nombre de usuario o contrase?a es incorrecto",
      "jiesheng": "Ahorre el costo de las cartas de crédito comerciales tradicionales.",
      "InvalidCaptchaKey": "Key Código de verificación inválida",
      "pleasePassword": "Por favor ingrese su contraseña",
      "bushouxianzhi": "Transferencias que no están sujetas a restricciones horarias y geográficas.",
      "login": "Iniciar sesión",
      "title": "Allanar la transacción a Jane",
      "myAcc": "Mi cuenta",
      "pleaseUsername": "Por favor ingrese un número de cuenta",
      "logout": "Cerrar sesión",
      "myFinancing": "Mi financiacion",
      "xinyong": "Crédito desmontable",
      "pleaseKaptcha": "Por favor ingrese el código de verificación",
      "nianlilv": "Tasa de financiación anualizada tan baja como 3.1%.",
      "validCodeError": "El código de verificación es erróneo",
      "validCodeExpired": "El código de verificación ha caducado.",
      "userNotExit": "El usuario no existe",
      "loginDisabled": "La cuenta ha sido deshabilitada",
      "fuwu": "Si está interesado en utilizar este servicio, llame a la línea directa de servicio.",
      "coin": "Moneda"
    },
    "cashApply": {
      "exMoney": "Solicitar la retirada",
      "availableCredit": "Saldo disponible",
      "select": "Por favor elija",
      "bankCard": "Retirada de tarjeta bancaria.",
      "sendCode": "Enviar código de verificación",
      "available": "Por favor ingrese el monto de retiro actualmente",
      "title": "solicitud de retiro de moneda z",
      "emCode": "Por favor ingrese el código de verificación de seguridad del correo electrónico recibido",
      "cashApply": "Solicitar la retirada",
      "confCash": "Confirmar el retiro",
      "tips": "* La plataforma no cobrará ninguna tarifa, y los cargos bancarios relacionados con el retiro serán cobrados por el banco y se deducirán de la cuenta real.",
      "newBank": "+ Añadir una tarjeta bancaria",
      "cashConf": "Confirmación de retiro de efectivo",
      "usable": "Disponible",
      "sentSuccess": "Enviar código de verificación es exitoso, por favor vaya al buzón de correo para ver",
      "moneyValue": "Moneda",
      "sumCredit": "Mi cantidad total de c monedas",
      "useAmount": "Z cantidad de retiro de moneda",
      "coin": "Moneda Z"
    },
    "bank": {
      "300005": "El area no esta vacia",
      "300016": "Longitud máxima del nombre del beneficiario 100",
      "300017": "Longitud máxima de la cuenta del beneficiario 100",
      "300006": "El nombre completo del banco no está vacío",
      "300003": "El número de tarjeta se repite, por favor vuelva a ingresar",
      "300014": "Longitud máxima del código Swift 100",
      "300015": "Longitud máxima del nombre del beneficiario 200",
      "300004": "La información de inicio de sesión no está vacía",
      "300009": "El nombre del beneficiario no está vacío",
      "300007": "El código Swift no está vacío",
      "300018": "Moneda de longitud máxima 100",
      "300019": "El ID de la persona de inicio de sesión no está vacío",
      "300008": "Dirección detallada del banco no está vacía",
      "300020": "La identificación de la clave principal no está vacía",
      "300023": "El ID de usuario no está vacío",
      "300012": "Código de país longitud máxima 200",
      "300001": "Por favor inicie sesión",
      "300024": "Los datos han cambiado, por favor actualice la página.",
      "300002": "Error al obtener la identificación del usuario",
      "300013": "Nombre completo del banco longitud máxima 200",
      "300010": "La cuenta del beneficiario no está vacía",
      "300011": "La moneda no está vacía",
      "300022": "El número de tarjeta no está vacío"
    },
    "chainDetails": {
      "add": "Añadir",
      "fileName": "Nombre de archivo",
      "dataType": "Tipo de datos",
      "clickToDownload": "Haga clic para descargar",
      "fileInfo": "Información del archivo",
      "update": "Actualizar",
      "remark": "Observaciones",
      "title": "Título",
      "completeInfo": "Información completa",
      "chainDetails": "Detalles de blockchain",
      "downloadLink": "Descargar direccion",
      "summaryInfo": "Información resumida",
      "dataOverview": "Resumen de datos",
      "report": "Informe",
      "reportDescription": "Descripción del informe",
      "lastData": "Siguiente dato",
      "platformName": "Nombre de la plataforma",
      "value": "Contenido",
      "fileType": "Tipo de archivo",
      "preData": "Datos anteriores"
    },
    "bankList": {
      "cancel": "Cancelar",
      "proceedName": "Nombre del beneficiario",
      "country": "Zona",
      "bankFullName": "Nombre completo del banco",
      "bankCreate": "Crear una tarjeta bancaria",
      "swiftCode": "Código Swift",
      "proceedAccount": "Cuenta del beneficiario",
      "title": "Gestión de cuentas bancarias",
      "bankAdd": "Agregar cuenta",
      "confirm": "Determinar",
      "delConf": "¿Estás seguro de que deseas eliminar esta cuenta bancaria?",
      "detailedAddress": "Dirección detallada del banco",
      "supportCurrency": "Moneda de apoyo"
    },
    "bonusLists": {
      "all": "Todo",
      "originalMoneyTr": "Principal dividendo",
      "annualIncomeTr": "Rendimiento de dividendos",
      "serialNumberTr": "Numero de agua corriente",
      "createTimeTr": "Fecha",
      "lastInterestDateTr": "Fecha de liquidación del dividendo",
      "bonusListsTitle": "Gestión de dividendos",
      "statusTr": "Estado",
      "detailTr": "Detalles",
      "bonusListsApplyBtn": "Solicitar dividendos",
      "typeTr": "Resumen",
      "dividend": "Dividendo",
      "turnToLive": "Gire a vivir",
      "issued": "Emitido"
    },
    "extractCrashLists": {
      "all": "Todo",
      "hasBeenTransferredOut": "Ha sido transferido",
      "flowNumberTr": "Numero de agua corriente",
      "createTimeTr": "Fecha",
      "extractCrashListsTitle": "Detalles de retiro de efectivo",
      "statusTr": "Estado",
      "detailTr": "Detalles",
      "withdrawalBankTr": "Banco de retiros de efectivo",
      "serviceChargeTr": "Tarifa de manejo",
      "application": "Solicitud",
      "amountExtractionTr": "Importe de retirada",
      "turnOutAmountTr": "Importe de transferencia",
      "remarkTr": "Resumen"
    },
    "financing": {
      "all": "Todo",
      "andTranscationg": "Transacción con partes relacionadas",
      "financing_completed": "Financiamiento completado",
      "financingaplicationAmount": "Importe de la solicitud de financiación",
      "aplicationTime": "Tiempo de aplicacion",
      "application_status_repayment": "Reembolso",
      "view": "Consulta",
      "pleaseWrite": "Por favor ingrese",
      "financingandOrderNum": "Financiación del número de pedido asociado.",
      "draft": "Borrador",
      "function": "Funcion",
      "financingaplicationNum": "Número de solicitud de financiación",
      "financing": "Mi financiacion",
      "startTime": "Hora de inicio",
      "noData": "Aún no hay datos",
      "financingStatus": "Estado de financiación",
      "details": "Detalles",
      "endTime": "Fecha límite",
      "reimbursement": "Reembolso",
      "still_hospitality_confirmation": "Aún confirmación de hospitalidad",
      "financingNumber": "Número de serie de financiación",
      "status": "Estado",
      "coin": "Moneda"
    },
    "flowListsType": {
      "1": "Traslado fuera",
      "2": "Pago de la financiación",
      "3": "Transferencia de dividendos",
      "4": "Transferencia de dividendos",
      "5": "Transferencia de financiación"
    },
    "resetpassword": {
      "newPasswordCannotSame": "La nueva contrase?a no puede ser la misma que la contrase?a original",
      "PasswordFormatIncorrect": "El formato de contrase?a es incorrecto, por favor cambie",
      "newPasswordNotFormatted": "La nueva longitud de la contrase?a no está formateada correctamente, por favor cambie",
      "originalPasswordIncorrectly": "La contrase?a original fue ingresada incorrectamente.",
      "passwordIsInconsistent": "La contrase?a es inconsistente con la contrase?a de confirmación"
    },
    "moneyChangeLog": {
      "100010": "La fecha de inicio no puede estar vacía",
      "100011": "La fecha de finalización no puede estar vacía",
      "100009": "Los datos han cambiado, por favor actualice la página.",
      "100001": "El ID de usuario no está vacío",
      "100012": "La información del personal está vacía",
      "100002": "El ID de clave principal de la tabla donde se encuentra el tipo de resumen no está vacío.",
      "100013": "Parámetro anormal",
      "100003": "El tipo de resumen no está vacío",
      "100014": "Datos anormales",
      "100004": "El tipo de cantidad no está vacío",
      "100005": "La cantidad no esta vacia",
      "100006": "Por favor inicie sesión",
      "100007": "Error al obtener la identificación del usuario",
      "100008": "No hay datos de flujo de exportación"
    },
    "bonusDetail": {
      "fh": "Dividendo",
      "tqzq": "Extracción de extracción",
      "expectIncome": "Retorno esperado",
      "bj": "Principal",
      "type": "Tipo de dividendo",
      "tips": "Advertencia: Si el desbloqueo no caduca por adelantado, el interés se calculará de acuerdo con el tiempo financiero.",
      "200004": "Datos anormales",
      "principal": "Desbloquear el principal",
      "bonusRegularDetailTime": "Tiempo",
      "unlockSuccess": "Desbloqueado exitosamente",
      "tqSuccess": "Extracción exitosa",
      "bonusRegularDetailStatus": "Tipo de interes",
      "startAndEndTime": "Fecha de inicio y finalización del plan de dividendos.",
      "lastInterestDate": "Fecha de pago del dividendo",
      "interest": "Ingreso real",
      "ljsy": "Ingreso acumulado",
      "bonusRegularDetailOriginalMoney": "Principal",
      "jshzce": "Transferencia de importe después de desbloquear",
      "serialNumber": "Numero de agua corriente",
      "bonusRegularDetailInterest": "Dividendo",
      "jxr": "Dia de interes",
      "bonusDetailTitle": "Lista de dividendos",
      "tqTitle": "Extracción",
      "mrfhjsb": "Declaración de dividendos diarios",
      "100009": "Los datos han cambiado, por favor actualice la página.",
      "bonusWay": "Esquema de dividendos",
      "dqjbe": "Cantidad básica actual",
      "tqjsTitle": "Desbloquear por adelantado",
      "jsb": "Declaración de liquidación",
      "originalMoney": "Dividendo basico"
    },
    "nav": {
      "index": "Mi cuenta"
    },
    "accountcenter": {
      "emailNotExist": "Por favor, establezca el buzón primero",
      "sendCodeMail": "Enviar código de verificación al buzón actual",
      "safeMail": "Buzón seguro",
      "chainData": "Datos de liquidación",
      "bankCard": "Tarjeta bancaria",
      "sendMailFrequently": "No enviar correo con frecuencia, toma 10 minutos.",
      "missCode": "Falta el código de verificación",
      "emailFormatError": "Formato de buzón incorrecto",
      "back": "Regreso",
      "lastMailTime": "Hora del último correo electrónico",
      "sendEmailError": "Error al enviar el correo",
      "lastMailType": "Ultimo enviado",
      "theEmailHasBeenUsed": "El buzón ha sido utilizado.",
      "manageBankCard": "Administrar tarjeta bancaria",
      "cofirm": "Por favor verifique el nuevo buzón",
      "accCenter": "Centro de cuenta",
      "getWeb": "Ver sitio web",
      "myBankCard": "Mi tarjeta bancaria",
      "emailLengthError": "Error de formato de longitud del buzón",
      "sendSuc": "Enviado exitosamente",
      "safePhone": "Teléfono seguro",
      "editEmailError": "Falló la actualización del buzón",
      "errorCodeTypeParam": "Error de parámetro de tipo de código verificador",
      "missEmail": "Buzón perdido",
      "sendCOde": "Enviar código de verificación",
      "missEmailParam": "Faltan parámetros del buzón",
      "accSafe": "seguridad de la cuenta",
      "codeInvalid": "El código de verificación ha caducado.",
      "blockChain": "Blockchain",
      "resetSuc": "Modificado exitosamente",
      "trade": "Transacción",
      "myTradeAcc": "Mi cuenta de trading",
      "pleaseNewMail": "Por favor ingrese una nueva dirección de correo electrónico",
      "pleaseCode": "Por favor ingrese el código de verificación",
      "codeError": "Error de código de verificación",
      "safe": "Seguridad",
      "youHaveBoundTheEmail": "El buzón que has enlazado",
      "nextStep": "Siguiente paso",
      "verifyMail": "Enviar",
      "resetMail": "Modificar buzón",
      "cic": "Centro global de negocio inteligente de mercancía",
      "myWebAcc": "Mi cuenta digital",
      "rongzi": "Financiacion"
    },
    "financingDetails": {
      "seller": "Vendedor",
      "repaymentAmountLimit": "Ingrese un número mayor que 0 y menor que 1000000000 para el monto de reembolso.",
      "reason": "Razón",
      "amountLessThanAvailable": "El importe del reembolso no puede ser mayor que el saldo disponible.",
      "getFinancingDetailFail": "Error al consultar los detalles de financiamiento",
      "pleaseSelectAcountCard": "Por favor seleccione una cuenta de reembolso",
      "lookrepaymentAmount": "Cantidad de reembolso",
      "hasComfimed": "Confirmado",
      "financingContractInfor": "Información del contrato de financiación.",
      "legalMoney": "Moneda legal",
      "dueInfo": "Informacion de pago",
      "regCode": "Código de registro",
      "flowNumber": "Solicitud de financiación número de serie",
      "wrongAccount": "No tienes permiso para ver estos datos.",
      "financingMethod": "Metodo de financiacion",
      "expectedRepaymentPeriod": "Período de amortización esperado",
      "isLocked": "Si bloquear después de la liberación",
      "doNotInsertRepaymentByState": "El historial de reembolso de los datos financieros actuales se confirmará o modificará, no se permitirá agregar",
      "acountMustInput": "Importe de reembolso es requerido",
      "details": "Detalles",
      "applicationAccount": "Cuenta del solicitante",
      "reimbursement": "Reembolso",
      "comfirm": "Determinar",
      "repaymentAccountIdNotNull": "La cuenta de remesas no puede estar vacía",
      "systemComfim": "Confirmación del sistema",
      "companyCode": "Por favor ingrese el código de registro de la empresa",
      "overdueAmount": "Cantidad de reembolso adicional",
      "upLoadenclosureCode": "Subir adjunto",
      "viewLook": "Ver",
      "repaymentTypeNotNull": "El método de reembolso no puede estar vacío",
      "authCodeStr": "Tipo de autentificación",
      "dueTime": "Tiempo de amortización",
      "salesOrder": "Orden de venta de transacción",
      "buyer": "Comprador",
      "newdue": "Nuevo reembolso",
      "pleaseChoseBill": "Por favor seleccione una moneda",
      "pleaseSelectPaymethod": "Por favor, elija el método de reembolso",
      "financingStartTime": "Fecha de inicio de financiación",
      "orderAcount": "Cantidad de la orden",
      "guaranteeType": "Tipo de garantía",
      "financingUse": "Uso de financiación",
      "uploadAttachmentsNotEmpty": "El archivo adjunto no puede estar vacío",
      "payeeAccountCanuseNow": "Cantidad de reembolso disponible actual",
      "repaymentAccount": "Cuenta de pago de financiación",
      "countryName": "País",
      "payeeAccount": "Cuenta de remesas",
      "coin": "Moneda",
      "addoverdueAmount": "Cantidad adicional",
      "repaymentMethod": "Método de reembolso",
      "no": "No",
      "financingaplayBook": "Solicitud de financiación",
      "currencyTypeNotNull": "La moneda no puede estar vacía",
      "pleaseSelectremittanceA": "Por favor seleccione una cuenta de remesa",
      "currentAccountDoNotInsert": "El solicitante actual no puede reembolsar",
      "enclosureCode": "Adjunto",
      "repaymentAmountNotNull": "El importe del reembolso no puede estar vacío",
      "orderNum": "Número de pedido",
      "dorla": "Dólar",
      "doNotInsertRepayment": "La orden de financiamiento se ha completado y la orden de reembolso no se puede agregar.",
      "grantAccount": "Cuenta emisora ​​de financiación",
      "financingEndTime": "Fecha de vencimiento del financiamiento",
      "repaymentSource": "Fuente de reembolso",
      "newBusinessLicense": "Nueva licencia de negocios",
      "additionalPaymentInfo": "Información adicional de pago",
      "aplicationFee": "Intereses",
      "applicationMoney": "Importe de la solicitud",
      "close": "Cerrar",
      "LockAcountNow": "Moneda z actualmente bloqueada",
      "certificateImage": "Foto del certificado",
      "oldBusinessLicense": "Vieja licencia de negocios",
      "dueMethods": "Método de reembolso",
      "financingApplicationInfor": "Información de solicitud de contrato de financiación",
      "yes": "Si",
      "repaymentIdNotNull": "ID de flujo de pago no puede estar vacío",
      "waitToModify": "modificarse",
      "additionalPayments": "Cantidad de reembolso adicional",
      "waitToComfim": "Sin confirmar",
      "billChoose": "Selección de moneda",
      "modify": "Modificar",
      "pleaseInputAmonut": "Por favor ingrese la cantidad",
      "financingMoney": "Importe de financiación",
      "createTime": "Tiempo de grabación",
      "dueAmount": "Cantidad de reembolso",
      "purchaseOrder": "Orden de compra de transacción",
      "pleaseUploadFile": "Por favor sube un archivo",
      "10001": "La entrada de cantidad es ilegal",
      "zCoin": "z moneda",
      "addremark": "Causa adicional",
      "tradingContract": "Contrato de transacción",
      "repaymentTime": "Tiempo de amortización",
      "fileUploadMaximumOf5": "Sube hasta 5 archivos",
      "return": "Regreso",
      "account": "Cuenta"
    },
    "home": {
      "accountTotalMoney": "Cuenta total",
      "safeMail": "Buzón de verificación de seguridad",
      "getDicDataFailed": "Error al obtener datos de la tabla de diccionarios",
      "bonusShenqing": "Aplicacion de dividendos",
      "accFlowLists": "Flujo de cuenta",
      "cashRecord": "Registro de retirada",
      "bankAcc": "Cuenta bancaria",
      "accInfo": "Informacion de cuenta",
      "cashApply": "Solicitud de retiro",
      "accountcenter": "Centro de cuenta",
      "availableBalance": "Saldo disponible",
      "manage": "Gestión",
      "lastLoginTime": "última hora de inicio de sesión",
      "bonusSuoding": "Bloqueo de dividendos",
      "addAcc": "Agregar cuenta",
      "contactNumber": "Numero de contacto",
      "bonusShouyi": "Ingresos por dividendos",
      "languageCannotNull": "El idioma no puede estar vacío",
      "lastRevenue": "La ultima agua",
      "fax": "Fax",
      "freezingQuota": "Congelar cuota",
      "contacts": "Contacto",
      "bonusGuanli": "Gestión de dividendos"
    },
    "extractCrashStatus": {
      "0": "Todo",
      "1": "Solicitud",
      "2": "Ha sido transferido"
    },
    "withdrawCash": {
      "400002": "Por favor seleccione la moneda de retiro de efectivo",
      "400013": "Saldo de cuenta insuficiente",
      "400003": "Por favor, rellene la cantidad de efectivo",
      "400014": "Anulación de código de verificación",
      "400011": "No tiene derechos de retiro de efectivo.",
      "400001": "Por favor, rellene el código de verificación",
      "400012": "Error de parámetro",
      "400010": "No ha configurado un buzón, configure un buzón seguro",
      "400008": "Exito de retiro de efectivo",
      "400009": "La identificación de los detalles no puede estar vacía",
      "400017": "Los datos han cambiado, por favor actualice la página.",
      "400006": "El correo se envía con demasiada frecuencia, inténtalo de nuevo más tarde.",
      "400007": "Error de entrada del código de verificación",
      "400015": "Falta de retiro de efectivo",
      "400004": "Por favor elija la tarjeta de efectivo",
      "400016": "Retiro ilegal de efectivo",
      "400005": "Aún no hay exportación de datos"
    },
    "btns": {
      "cancel": "Cancelar",
      "tqjs": "Desbloquear por adelantado",
      "ensureUnlock": "Confirmar desbloqueo",
      "query": "Consulta",
      "detail": "Detalles",
      "downLoadData": "Descargar datos",
      "ensureExtract": "Confirmar extracción",
      "tq": "Extracción"
    },
    "depositStatus": {
      "0": "Todo",
      "1": "Dividendo",
      "2": "Emitido",
      "3": "Gire a vivir"
    },
    "extractCrashDetail": {
      "proceedName": "Nombre del beneficiario",
      "remittanceDate": "Tiempo de remesas",
      "turnOutAmount": "Importe de la remesa",
      "swiftCode": "Retirar el código SWIFT",
      "bankName": "Nombre completo del banco",
      "proceedAccount": "Cuenta del beneficiario",
      "transferBankAccount": "Cuenta de remesas",
      "tips": "* Si el banco no ha llegado, póngase en contacto con el servicio de atención al cliente de su cuenta bancaria. Si tiene más preguntas, llame al [+65 6379 1324]",
      "amountExtraction": "Solicitar la retirada",
      "flowNumber": "Número de flujo de efectivo",
      "serviceCharge": "Tarifa de manejo",
      "detailedAddress": "Dirección detallada del banco",
      "moneyLable": "Moneda de retiro de efectivo",
      "transferBankName": "Banco de remesas",
      "fileList": "Certificado de transferencia",
      "extractCrashDetailTitle": "Detalles de retiro de efectivo"
    },
    "extractType": {
      "1": "Retiro bancario"
    },
    "depositType": {
      "1": "Periodo actual",
      "2": "Regularmente"
    },
    "chaincount": {
      "all": "Todo",
      "myHome": "Mi cuenta",
      "serialNumber": "Número de flujo de negocios",
      "chainCount": "Estadísticas de blockchain",
      "financingApply": "Solicitud de financiación",
      "bonusApply": "Aplicacion de dividendos",
      "profitBonus": "Dividendo de ingresos",
      "handle": "Procesamiento",
      "fail": "Fracaso",
      "appendRepayment": "Financiamiento pago adicional",
      "transferActivity": "Actividad de transmisión",
      "success": "El exito",
      "chainSum": "Número total de devanados",
      "details": "Detalles",
      "state": "Estado",
      "day": "El dia",
      "cash": "Retirada",
      "chainTime": "Tiempo sinuoso",
      "financingLoan": "Financiamiento de préstamos",
      "repayment": "Pago de la financiación"
    }
  },
  fr: {
    "flowLists": {
      "flowNumber": "Numéro d&#39eau courante",
      "incomeTr": "Le revenu",
      "flowListsTitle": "Détail du flux",
      "createTime": "Date",
      "ebalanceAmount": "Solde",
      "detailTr": "Les détails",
      "remarkType": "Résumé",
      "expenditureTr": "Les dépenses"
    },
    "frontPage": {
      "Error404": "L'itinéraire n'existe pas, veuillez contr?ler si l'itinéraire est correct",
      "annualIncome": "Revenu annualisé",
      "z_currency": "z pièce",
      "missSendEmailType": "Type d&#39envoi manquant",
      "back": "Retour",
      "UploadFailure": "échec du téléchargement",
      "CurrencyDollar": "dollar",
      "updateEmailSendCode": "Modifier le code de vérification de la bo?te aux lettres",
      "missEmailTemplate": "Modèle de courrier manquant",
      "CurrencyHongKong": "dollar de Hong Kong",
      "missSubject": "En-tête de message manquant",
      "noTime": "Non",
      "missUserId": "Identifiant d&#39utilisateur de destination d&#39envoi manquant",
      "missFile": "Fichier manquant",
      "startTime": "Heure de début",
      "accountTypeMiss": "Le type d&#39utilisateur ne peut pas être vide",
      "NotFile": "Le format du fichier est incorrect, merci de re-télécharger!",
      "login_timeout": "La connexion est hors -délai",
      "Error500": "Le système est anormal, veuillez contacter le gestionnaire",
      "moneyArrivaNotice": "Avis d&#39arrivée",
      "CurrencyJPY": "JPY",
      "missUserType": "Type d&#39utilisateur manquant",
      "selectTime": "S&#39il vous plaît sélectionner le temps",
      "miss_field_version": "Manque du numéro de version",
      "fileCodeCannotEmpty": "L&#39identifiant unique du fichier ne peut pas être vide",
      "uploadPersonNotNull": "Le téléchargeur ne peut pas être vide",
      "missEmail": "Bo?te aux lettres manquante",
      "l_currency": "Monnaie légale",
      "missEmailParam": "Paramètres de messagerie manquants",
      "miss_token": "Manque token",
      "notPicType": "Pas de type d&#39image",
      "youHaveNoPermission": "Vous n&#39êtes pas autorisé à télécharger le fichier",
      "fileIsNullOrDeleted": "Le fichier n&#39existe pas ou a été supprimé",
      "drawSendCode": "Code de vérification de l&#39encaissement",
      "businessTypeCannotEmpty": "La source du fichier ne peut pas être vide",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "Echec de la vérification de sécurité de l&#39image actuellement téléchargée",
      "businessCodeCannotEmpty": "L&#39identifiant unique de la source de fichier ne peut pas être vide",
      "noData": "Pas encore de données",
      "endTime": "Date limite",
      "time": "Le temps",
      "pleaseChoose": "S&#39il vous plaît choisir",
      "notEmpty": "Ne peut pas être vide",
      "CurrencySingapore": "Singapour",
      "status": "Etat"
    },
    "bonusApply": {
      "200007": "Les données de base du dividende sont anormales.",
      "bonusApplyInputPlaceHolder": "Solde redistribuable actuel",
      "200006": "Le montant de la demande est supérieur au solde du dividende disponible",
      "200009": "Échec du financement d&#39un compte d&#39utilisateur par lots",
      "200008": "Les dividendes périodiques de la mise à jour par lot ont échoué",
      "200003": "Les données ont changé, veuillez actualiser la page",
      "200002": "Vous avez interdit les dividendes, veuillez contacter l&#39administrateur",
      "200005": "Le montant du transfert n&#39est pas vide!",
      "200004": "Les données sont anormales, veuillez contacter l&#39administrateur du système.",
      "200010": "Les dividendes en direct des utilisateurs du lot ont échoué",
      "200012": "La date de début ne peut pas être vide",
      "200011": "Les données de la table du compte d&#39utilisateur utilisateur sont anormales",
      "bonusApplyInputLabel": "Demander des dividendes",
      "bonusApplyType1": "Période actuelle",
      "100013": "Paramètre anormal",
      "bonusApplyType2": "Régulièrement",
      "btn": "Commencez à recevoir des dividendes",
      "bonusApplyTitle": "Demande de dividende",
      "bonusApplyInputErr2": "Le nombre d&#39entrée supérieur à 0 est inférieur au dividende actuellement disponible et à 2 décimales.",
      "bonusApplyTip1": "* Vous avez toujours un paiement de financement sera",
      "200013": "La date de fin ne peut pas être vide",
      "bonusApplyInputErr1": "S&#39il vous plaît entrer le montant",
      "bonusApplyTip2": "Remboursement requis",
      "200001": "Non connecté",
      "bonusApplySuccess": "Demande réussie de dividendes"
    },
    "login": {
      "VerificationCodeMissing": "S&#39il vous pla?t entrer le code de vérification",
      "rongziwei": "Application de financement est une grande fonction de financement b2b fast trade basée sur la technologie de monnaie virtuelle blockchain fournie par cic à des groupes d’utilisateurs spécifiques.",
      "nameOrPwdError": "Le nom d'utilisateur ou le mot de passe est incorrect",
      "jiesheng": "Économiser le coût des lettres de crédit traditionnelles",
      "InvalidCaptchaKey": "Clé de vérification défaillante",
      "pleasePassword": "Veuillez entrer votre mot de passe",
      "bushouxianzhi": "Transferts non soumis à des contraintes de temps et géographiques",
      "login": "Connexion",
      "title": "Lisser la transaction à Jane",
      "myAcc": "Mon compte",
      "pleaseUsername": "S&#39il vous pla?t entrer un numéro de compte",
      "logout": "Déconnexion",
      "myFinancing": "Mon financement",
      "xinyong": "Crédit détachable",
      "pleaseKaptcha": "S&#39il vous pla?t entrer le code de vérification",
      "nianlilv": "Taux de financement annualisé aussi bas que 3,1%",
      "validCodeError": "Erreur de code de vérification",
      "validCodeExpired": "Le code de vérification a expiré",
      "userNotExit": "L&#39utilisateur n&#39existe pas",
      "loginDisabled": "Le compte a été désactivé",
      "fuwu": "Si vous souhaitez utiliser ce service, veuillez appeler le service d&#39assistance téléphonique.",
      "coin": "Pièce de monnaie"
    },
    "cashApply": {
      "exMoney": "Demander le retrait",
      "availableCredit": "Solde disponible",
      "select": "S&#39il vous plaît choisir",
      "bankCard": "Retrait de carte bancaire",
      "sendCode": "Envoyer le code de vérification",
      "available": "Veuillez saisir le montant du retrait actuellement",
      "title": "demande de retrait z pièce",
      "emCode": "Veuillez entrer le code de vérification de sécurité de l&#39email reçu",
      "cashApply": "Demander le retrait",
      "confCash": "Confirmer le retrait",
      "tips": "* La plateforme ne facturera aucun frais et les frais bancaires liés au retrait seront collectés par la banque et déduits du compte réel.",
      "newBank": "+ Ajouter une carte bancaire",
      "cashConf": "Confirmation de retrait en espèces",
      "usable": "Disponible",
      "sentSuccess": "L&#39envoi du code de vérification a réussi. Veuillez vous rendre dans la boîte aux lettres pour afficher.",
      "moneyValue": "La monnaie",
      "sumCredit": "Mon montant total de monnaies c",
      "useAmount": "Montant du retrait en monnaie Z",
      "coin": "Pièce Z"
    },
    "bank": {
      "300005": "La zone n&#39est pas vide",
      "300016": "Nom du bénéficiaire longueur maximale 100",
      "300017": "Longueur maximale du compte bénéficiaire 100",
      "300006": "Le nom complet de la banque n&#39est pas vide",
      "300003": "Le numéro de carte est répété, veuillez ré-entrer",
      "300014": "Longueur maximale du code Swift 100",
      "300015": "Nom du bénéficiaire longueur maximale 200",
      "300004": "Les informations de connexion ne sont pas vides",
      "300009": "Le nom du bénéficiaire n&#39est pas vide",
      "300007": "Le code rapide n&#39est pas vide",
      "300018": "Devise longueur maximum 100",
      "300019": "Identifiant personnel n&#39est pas vide",
      "300008": "Adresse bancaire détaillée n&#39est pas vide",
      "300020": "L&#39identifiant de la clé primaire n&#39est pas vide",
      "300023": "L&#39identifiant de l&#39utilisateur n&#39est pas vide",
      "300012": "Longueur maximale du code de pays 200",
      "300001": "Veuillez vous connecter",
      "300024": "Les données ont changé, veuillez actualiser la page",
      "300002": "Impossible d&#39obtenir l&#39ID utilisateur",
      "300013": "Nom complet de la banque longueur maximale 200",
      "300010": "Le compte du bénéficiaire n&#39est pas vide",
      "300011": "La monnaie n&#39est pas vide",
      "300022": "Le numéro de carte n&#39est pas vide"
    },
    "chainDetails": {
      "add": "Ajouter",
      "fileName": "Nom du fichier",
      "dataType": "Type de données",
      "clickToDownload": "Cliquez pour télécharger",
      "fileInfo": "Informations sur le fichier",
      "update": "Mise à jour",
      "remark": "Remarques",
      "title": "Titre",
      "completeInfo": "Information complète",
      "chainDetails": "Blockchain details",
      "downloadLink": "Adresse de téléchargement",
      "summaryInfo": "Informations sommaires",
      "dataOverview": "Aperçu des données",
      "report": "Rapport",
      "reportDescription": "Description du rapport",
      "lastData": "Données suivantes",
      "platformName": "Nom de la plateforme",
      "value": "Le contenu",
      "fileType": "Type de fichier",
      "preData": "Données précédentes"
    },
    "bankList": {
      "cancel": "Annuler",
      "proceedName": "Nom du bénéficiaire",
      "country": "Zone",
      "bankFullName": "Nom complet de la banque",
      "bankCreate": "Créer une carte bancaire",
      "swiftCode": "Code rapide",
      "proceedAccount": "Compte du bénéficiaire",
      "title": "Gestion de compte bancaire",
      "bankAdd": "Ajouter un compte",
      "confirm": "Déterminer",
      "delConf": "Êtes-vous sûr de vouloir supprimer ce compte bancaire?",
      "detailedAddress": "Adresse bancaire détaillée",
      "supportCurrency": "Devise de soutien"
    },
    "bonusLists": {
      "all": "Tous",
      "originalMoneyTr": "Dividende principal",
      "annualIncomeTr": "Rendement dividende",
      "serialNumberTr": "Numéro d&#39eau courante",
      "createTimeTr": "Date",
      "lastInterestDateTr": "Date de règlement du dividende",
      "bonusListsTitle": "Gestion des dividendes",
      "statusTr": "Etat",
      "detailTr": "Les détails",
      "bonusListsApplyBtn": "Demander des dividendes",
      "typeTr": "Résumé",
      "dividend": "Dividende",
      "turnToLive": "Tourner à vivre",
      "issued": "Délivré"
    },
    "extractCrashLists": {
      "all": "Tous",
      "hasBeenTransferredOut": "A été transféré",
      "flowNumberTr": "Numéro d&#39eau courante",
      "createTimeTr": "Date",
      "extractCrashListsTitle": "Détails du retrait en espèces",
      "statusTr": "Etat",
      "detailTr": "Les détails",
      "withdrawalBankTr": "Banque de retrait d&#39argent",
      "serviceChargeTr": "Frais de traitement",
      "application": "Application",
      "amountExtractionTr": "Montant du retrait",
      "turnOutAmountTr": "Montant du transfert",
      "remarkTr": "Résumé"
    },
    "financing": {
      "all": "Tous",
      "andTranscationg": "Transaction entre parties liées",
      "financing_completed": "Financement complété",
      "financingaplicationAmount": "Montant de la demande de financement",
      "aplicationTime": "Temps de application",
      "application_status_repayment": "Remboursement",
      "view": "Requête",
      "pleaseWrite": "S&#39il vous plaît entrer",
      "financingandOrderNum": "Numéro de commande associé au financement",
      "draft": "Brouillon",
      "function": "Fonction",
      "financingaplicationNum": "Numéro de demande de financement",
      "financing": "Mon financement",
      "startTime": "Heure de début",
      "noData": "Pas encore de données",
      "financingStatus": "Statut de financement",
      "details": "Les détails",
      "endTime": "Date limite",
      "reimbursement": "Remboursement",
      "still_hospitality_confirmation": "Encore confirmation de l&#39accueil",
      "financingNumber": "Numéro de série du financement",
      "status": "Etat",
      "coin": "Pièce de monnaie"
    },
    "flowListsType": {
      "1": "Transférer",
      "2": "Remboursement de financement",
      "3": "Transfert de dividende",
      "4": "Transfert de dividende",
      "5": "Transfert de financement"
    },
    "resetpassword": {
      "newPasswordCannotSame": "Le nouveau mot de passe ne peut pas être identique au mot de passe d&#39origine",
      "PasswordFormatIncorrect": "Le format du mot de passe est incorrect, veuillez changer",
      "newPasswordNotFormatted": "La nouvelle longueur du mot de passe n&#39est pas formatée correctement, veuillez changer",
      "originalPasswordIncorrectly": "Le mot de passe d&#39origine n&#39a pas été entré correctement.",
      "passwordIsInconsistent": "Le mot de passe est incompatible avec le mot de passe de confirmation"
    },
    "moneyChangeLog": {
      "100010": "La date de début ne peut pas être vide",
      "100011": "La date de fin ne peut pas être vide",
      "100009": "Les données ont changé, veuillez actualiser la page",
      "100001": "L&#39identifiant de l&#39utilisateur n&#39est pas vide",
      "100012": "Les informations sur le personnel sont vides",
      "100002": "L&#39identifiant de clé primaire de la table où se trouve le type de résumé n&#39est pas vide.",
      "100013": "Paramètre anormal",
      "100003": "Le type de résumé n&#39est pas vide",
      "100014": "Données anormales",
      "100004": "Le type de montant n&#39est pas vide",
      "100005": "Le montant n&#39est pas vide",
      "100006": "Veuillez vous connecter",
      "100007": "Impossible d&#39obtenir l&#39ID utilisateur",
      "100008": "Aucune exportation de données de flux"
    },
    "bonusDetail": {
      "fh": "Dividende",
      "tqzq": "Retrait d&#39extraction",
      "expectIncome": "Retour attendu",
      "bj": "Directeur",
      "type": "Type de dividende",
      "tips": "Attention: Si le déblocage n’est pas expiré à l’avance, les intérêts seront calculés en fonction du temps financier!",
      "200004": "Données anormales",
      "principal": "Débloquer le principal",
      "bonusRegularDetailTime": "Le temps",
      "unlockSuccess": "Débloqué avec succès",
      "tqSuccess": "Extraction réussie",
      "bonusRegularDetailStatus": "Type d&#39intérêt",
      "startAndEndTime": "Date de début et de fin du plan de dividende",
      "lastInterestDate": "Date de versement du dividende",
      "interest": "Revenu réel",
      "ljsy": "Revenu cumulatif",
      "bonusRegularDetailOriginalMoney": "Directeur",
      "jshzce": "Virement montant après déblocage",
      "serialNumber": "Numéro d&#39eau courante",
      "bonusRegularDetailInterest": "Dividende",
      "jxr": "Jour portant intérêt",
      "bonusDetailTitle": "Liste de dividende",
      "tqTitle": "Extraction",
      "mrfhjsb": "Déclaration de dividende quotidien",
      "100009": "Les données ont changé, veuillez actualiser la page",
      "bonusWay": "Schéma de dividende",
      "dqjbe": "Montant de base actuel",
      "tqjsTitle": "Débloquer à l&#39avance",
      "jsb": "Déclaration de règlement",
      "originalMoney": "Dividende de base"
    },
    "nav": {
      "index": "Mon compte"
    },
    "accountcenter": {
      "emailNotExist": "S&#39il vous pla?t définir la bo?te aux lettres d&#39abord",
      "sendCodeMail": "Envoyer le code de vérification à la bo?te aux lettres actuelle",
      "safeMail": "Bo?te aux lettres sécurisée",
      "chainData": "Données d&#39enroulement",
      "bankCard": "Carte bancaire",
      "sendMailFrequently": "Ne pas envoyer de courrier fréquemment, cela prend 10 minutes",
      "missCode": "Code de vérification manquant",
      "emailFormatError": "Format de bo?te aux lettres incorrect",
      "back": "Retour",
      "lastMailTime": "Dernier email",
      "sendEmailError": "échec d&#39envoi du courrier",
      "lastMailType": "Dernier envoyé",
      "theEmailHasBeenUsed": "La bo?te aux lettres a été utilisée",
      "manageBankCard": "Gérer la carte bancaire",
      "cofirm": "Veuillez vérifier la nouvelle bo?te aux lettres",
      "accCenter": "Centre de compte",
      "getWeb": "Voir le site web",
      "myBankCard": "Ma carte bancaire",
      "emailLengthError": "Erreur de format de longueur de bo?te aux lettres",
      "sendSuc": "Envoyé avec succès",
      "safePhone": "Téléphone sécurisé",
      "editEmailError": "Mise à jour de la bo?te aux lettres a échoué",
      "errorCodeTypeParam": "Erreur de paramètre de type de code du vérificateur",
      "missEmail": "Bo?te aux lettres manquante",
      "sendCOde": "Envoyer le code de vérification",
      "missEmailParam": "Paramètres de bo?te aux lettres manquants",
      "accSafe": "Sécurité du compte",
      "codeInvalid": "Le code de vérification a expiré",
      "blockChain": "Blockchain",
      "resetSuc": "Modifié avec succès",
      "trade": "Transaction",
      "myTradeAcc": "Mon compte de trading",
      "pleaseNewMail": "Veuillez entrer une nouvelle adresse email",
      "pleaseCode": "S&#39il vous pla?t entrer le code de vérification",
      "codeError": "Erreur du code de vérification",
      "safe": "La sécurité",
      "youHaveBoundTheEmail": "La bo?te aux lettres que vous avez liée",
      "nextStep": "Prochaine étape",
      "verifyMail": "Soumettre",
      "resetMail": "Modifier la bo?te aux lettres",
      "cic": "Centre de Transaction intelligente des produits mondial",
      "myWebAcc": "Mon compte numérique",
      "rongzi": "Le financement"
    },
    "financingDetails": {
      "seller": "Le vendeur",
      "repaymentAmountLimit": "Veuillez entrer un nombre supérieur à 0 et inférieur à 1000000000 pour le montant du remboursement.",
      "reason": "Raison",
      "amountLessThanAvailable": "Le montant du remboursement ne peut être supérieur au solde disponible",
      "getFinancingDetailFail": "Impossible d&#39interroger les détails du financement",
      "pleaseSelectAcountCard": "Veuillez sélectionner un compte de remboursement",
      "lookrepaymentAmount": "Montant du remboursement",
      "hasComfimed": "Confirmé",
      "financingContractInfor": "Informations sur le contrat de financement",
      "legalMoney": "Monnaie légale",
      "dueInfo": "Informations de remboursement",
      "regCode": "Code d&#39enregistrement",
      "flowNumber": "Numéro de série de la demande de financement",
      "wrongAccount": "Vous n&#39avez pas la permission de voir ces données",
      "financingMethod": "Mode de financement",
      "expectedRepaymentPeriod": "Délai de remboursement prévu",
      "isLocked": "Si verrouiller après la libération",
      "doNotInsertRepaymentByState": "Historique de remboursement des données de financement actuelles à confirmer ou à modifier, il n&#39est pas autorisé à l&#39ajouter.",
      "acountMustInput": "Le montant du remboursement est requis",
      "details": "Les détails",
      "applicationAccount": "Compte du demandeur",
      "reimbursement": "Remboursement",
      "comfirm": "Déterminer",
      "repaymentAccountIdNotNull": "Le compte de remise ne peut être vide",
      "systemComfim": "Confirmation du système",
      "companyCode": "Veuillez entrer le code d&#39enregistrement de l&#39entreprise",
      "overdueAmount": "Montant de remboursement supplémentaire",
      "upLoadenclosureCode": "Télécharger une pièce jointe",
      "viewLook": "Voir",
      "repaymentTypeNotNull": "La méthode de remboursement ne peut pas être vide",
      "authCodeStr": "Type d&#39authentification",
      "dueTime": "Temps de remboursement",
      "salesOrder": "Commande client transactionnelle",
      "buyer": "Acheteur",
      "newdue": "Nouveau remboursement",
      "pleaseChoseBill": "Veuillez choisir une devise",
      "pleaseSelectPaymethod": "Veuillez choisir le mode de remboursement",
      "financingStartTime": "Date de début du financement",
      "orderAcount": "Montant de la commande",
      "guaranteeType": "Type de garantie",
      "financingUse": "Utilisation de financement",
      "uploadAttachmentsNotEmpty": "La pièce jointe ne peut pas être vide",
      "payeeAccountCanuseNow": "Montant de remboursement disponible actuel",
      "repaymentAccount": "Compte de remboursement de financement",
      "countryName": "Pays",
      "payeeAccount": "Compte de versement",
      "coin": "Pièce de monnaie",
      "addoverdueAmount": "Montant supplémentaire",
      "repaymentMethod": "Mode de remboursement",
      "no": "Non",
      "financingaplayBook": "Demande de financement",
      "currencyTypeNotNull": "La monnaie ne peut pas être vide",
      "pleaseSelectremittanceA": "Veuillez sélectionner un compte de versement",
      "currentAccountDoNotInsert": "Le titulaire actuel ne peut pas rembourser",
      "enclosureCode": "Pièce jointe",
      "repaymentAmountNotNull": "Le montant du remboursement ne peut être vide",
      "orderNum": "Numéro de commande",
      "dorla": "Dollar",
      "doNotInsertRepayment": "L&#39ordre de financement est terminé et l&#39ordre de remboursement ne peut pas être ajouté.",
      "grantAccount": "Compte d&#39émission de financement",
      "financingEndTime": "Date d&#39échéance du financement",
      "repaymentSource": "Source de remboursement",
      "newBusinessLicense": "Nouvelle licence d&#39entreprise",
      "additionalPaymentInfo": "Informations de remboursement supplémentaires",
      "aplicationFee": "Les intérêts",
      "applicationMoney": "Montant de la demande",
      "close": "Fermer",
      "LockAcountNow": "Monnaie z actuellement verrouillée",
      "certificateImage": "Photo du certificat",
      "oldBusinessLicense": "Ancien permis de commerce",
      "dueMethods": "Mode de remboursement",
      "financingApplicationInfor": "Informations sur la demande de contrat de financement",
      "yes": "Oui",
      "repaymentIdNotNull": "L&#39identifiant du flux de remboursement ne peut pas être vide",
      "waitToModify": "Être modifié",
      "additionalPayments": "Montant de remboursement supplémentaire",
      "waitToComfim": "Non confirmé",
      "billChoose": "Sélection de la monnaie",
      "modify": "Modifier",
      "pleaseInputAmonut": "S&#39il vous plaît entrer le montant",
      "financingMoney": "Montant du financement",
      "createTime": "Temps d&#39enregistrement",
      "dueAmount": "Montant du remboursement",
      "purchaseOrder": "Commande d&#39achat de transaction",
      "pleaseUploadFile": "S&#39il vous plaît télécharger un fichier",
      "10001": "Le montant entré est illégal",
      "zCoin": "z pièce",
      "addremark": "Cause supplémentaire",
      "tradingContract": "Contrat de transaction",
      "repaymentTime": "Temps de remboursement",
      "fileUploadMaximumOf5": "Télécharger jusqu&#39à 5 fichiers",
      "return": "Retour",
      "account": "Compte"
    },
    "home": {
      "accountTotalMoney": "Compte total",
      "safeMail": "Bo?te aux lettres de vérification de sécurité",
      "getDicDataFailed": "échec d&#39obtention des données de la table de dictionnaire",
      "bonusShenqing": "Demande de dividende",
      "accFlowLists": "Compte courant",
      "cashRecord": "Enregistrement de retrait",
      "bankAcc": "Compte bancaire",
      "accInfo": "Informations sur le compte",
      "cashApply": "Demande de retrait",
      "accountcenter": "Centre de compte",
      "availableBalance": "Solde disponible",
      "manage": "La gestion",
      "lastLoginTime": "Dernière heure de connexion",
      "bonusSuoding": "Serrure de dividende",
      "addAcc": "Ajouter un compte",
      "contactNumber": "Numéro de contact",
      "bonusShouyi": "Revenu de dividende",
      "languageCannotNull": "La langue ne peut pas être vide",
      "lastRevenue": "La dernière eau",
      "fax": "Fax",
      "freezingQuota": "Gel du quota",
      "contacts": "Contact",
      "bonusGuanli": "Gestion des dividendes"
    },
    "extractCrashStatus": {
      "0": "Tous",
      "1": "Application",
      "2": "A été transféré"
    },
    "withdrawCash": {
      "400002": "Veuillez sélectionner la devise de retrait en espèces",
      "400013": "Solde de compte insuffisant",
      "400003": "S&#39il vous plaît remplir le montant de l&#39argent",
      "400014": "Invalidation du code de vérification",
      "400011": "N&#39a pas les droits de retrait en espèces",
      "400001": "S&#39il vous plaît remplir le code de vérification",
      "400012": "Erreur de paramètre",
      "400010": "Si vous n&#39avez pas configuré de boîte aux lettres, veuillez configurer une boîte aux lettres sécurisée",
      "400008": "Succès des retraits d&#39espèces",
      "400009": "Les détails ne peuvent pas être vides",
      "400017": "Les données ont changé, veuillez actualiser la page",
      "400006": "Le courrier est envoyé trop souvent, veuillez réessayer plus tard.",
      "400007": "Erreur de saisie du code de vérification",
      "400015": "Échec du retrait en espèces",
      "400004": "Veuillez choisir une carte de paiement",
      "400016": "Retrait d&#39argent illégal",
      "400005": "Pas encore d&#39export de données"
    },
    "btns": {
      "cancel": "Annuler",
      "tqjs": "Débloquer à l&#39avance",
      "ensureUnlock": "Confirmer le déverrouillage",
      "query": "Requête",
      "detail": "Les détails",
      "downLoadData": "Télécharger les données",
      "ensureExtract": "Confirmer l&#39extraction",
      "tq": "Extraction"
    },
    "depositStatus": {
      "0": "Tous",
      "1": "Dividende",
      "2": "Délivré",
      "3": "Tourner à vivre"
    },
    "extractCrashDetail": {
      "proceedName": "Nom du bénéficiaire",
      "remittanceDate": "Temps de versement",
      "turnOutAmount": "Montant du versement",
      "swiftCode": "Encaisser le code SWIFT",
      "bankName": "Nom complet de la banque",
      "proceedAccount": "Compte du bénéficiaire",
      "transferBankAccount": "Compte de versement",
      "tips": "* Si la banque n’est pas encore arrivée, veuillez contacter le service clientèle de votre compte bancaire pour obtenir des renseignements.",
      "amountExtraction": "Demander le retrait",
      "flowNumber": "Numéro de flux de trésorerie",
      "serviceCharge": "Frais de traitement",
      "detailedAddress": "Adresse bancaire détaillée",
      "moneyLable": "Devise de retrait en espèces",
      "transferBankName": "Banque de remise",
      "fileList": "Certificat de transfert",
      "extractCrashDetailTitle": "Détails du retrait en espèces"
    },
    "extractType": {
      "1": "Retrait bancaire"
    },
    "depositType": {
      "1": "Période actuelle",
      "2": "Régulièrement"
    },
    "chaincount": {
      "all": "Tous",
      "myHome": "Mon compte",
      "serialNumber": "Numéro de flux d&#39affaires",
      "chainCount": "Statistiques blockchain",
      "financingApply": "Demande de financement",
      "bonusApply": "Demande de dividende",
      "profitBonus": "Dividende de revenu",
      "handle": "Traitement",
      "fail": "Échec",
      "appendRepayment": "Financement du remboursement supplémentaire",
      "transferActivity": "Activité de transmission",
      "success": "Le succès",
      "chainSum": "Nombre total de spires",
      "details": "Les détails",
      "state": "Etat",
      "day": "Jour",
      "cash": "Retrait",
      "chainTime": "Temps d&#39enroulement",
      "financingLoan": "Financement de prêt",
      "repayment": "Remboursement de financement"
    }
  },
  ko: {
    "flowLists": {
      "flowNumber": "흐르는 물 번호",
      "incomeTr": "소득",
      "flowListsTitle": "흐름 세부 정보",
      "createTime": "날짜",
      "ebalanceAmount": "균형",
      "detailTr": "세부 정보",
      "remarkType": "요약",
      "expenditureTr": "지출"
    },
    "frontPage": {
      "Error404": "경로가 존재하지 않습니다. 경로가 올바른지 확인하십시오.",
      "annualIncome": "연간 소득",
      "missSendEmailType": "누락 된 메시지 유형 보내기",
      "z_currency": "z 동전",
      "back": "돌아 가기",
      "CurrencyDollar": "달러",
      "UploadFailure": "업로드하지 못했습니다.",
      "updateEmailSendCode": "사서함 유효성 검사 코드 변경",
      "missEmailTemplate": "메일 템플릿 누락",
      "CurrencyHongKong": "홍콩 달러",
      "noTime": "아니요",
      "missSubject": "메시지 머리가 누락되었습니다.",
      "missUserId": "송신 대상의 사용자 ID 누락",
      "missFile": "누락 된 파일",
      "startTime": "시작 시간",
      "NotFile": "파일 형식이 잘못되었습니다. 다시 업로드하십시오!",
      "accountTypeMiss": "사용자 유형은 비워 둘 수 없습니다.",
      "login_timeout": "등록 시간이 초과 됨",
      "Error500": "시스템 예외, 관리자에게 문의하십시오!",
      "moneyArrivaNotice": "도착 발표",
      "CurrencyJPY": "엔화",
      "selectTime": "시간을 선택하십시오.",
      "missUserType": "누락 된 사용자 유형",
      "miss_field_version": "버전 번호가 없다.",
      "fileCodeCannotEmpty": "고유 한 파일 식별자는 비워 둘 수 없습니다.",
      "missEmail": "사서함이 누락되었습니다.",
      "uploadPersonNotNull": "업 로더는 비워 둘 수 없습니다.",
      "missEmailParam": "누락 된 전자 메일 매개 변수",
      "l_currency": "합법적 인 통화",
      "miss_token": "토큰이 없다.",
      "notPicType": "그림 유형 없음",
      "youHaveNoPermission": "파일을 다운로드 할 수 없습니다.",
      "businessTypeCannotEmpty": "파일 소스는 비워 둘 수 없습니다.",
      "drawSendCode": "지불금을 확인하는 코드",
      "fileIsNullOrDeleted": "파일이 없거나 삭제되었습니다.",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "현재 업로드 된 이미지의 보안 검사가 실패했습니다.",
      "businessCodeCannotEmpty": "파일 소스의 고유 식별자는 비워 둘 수 없습니다.",
      "noData": "데이터가 없습니다.",
      "endTime": "마감일",
      "time": "시간",
      "pleaseChoose": "선택해주세요.",
      "notEmpty": "비워 둘 수 없습니다.",
      "CurrencySingapore": "싱가포르",
      "status": "주"
    },
    "bonusApply": {
      "200007": "배당 기본 데이터가 비정상입니다.",
      "bonusApplyInputPlaceHolder": "현재 재배포 가능 잔액",
      "200006": "신청 금액이 사용 가능한 배당 잔액보다 큽니다.",
      "200009": "일괄 사용자 계정에 자금을 제공하지 못했습니다.",
      "200008": "정기적 인 배당을 일괄 업데이트하지 못했습니다.",
      "200003": "데이터가 변경되었습니다. 페이지를 새로 고침하십시오.",
      "200002": "배당을 금하셨습니다. 관리자에게 문의하십시오.",
      "200005": "이체 금액이 비어 있지 않습니다!",
      "200004": "데이터가 비정상 인 경우 시스템 관리자에게 문의하십시오.",
      "200010": "배치 사용자 생방송 실패",
      "200012": "시작일은 비워 둘 수 없습니다.",
      "200011": "사용자 자금 계정 테이블 데이터가 비정상입니다.",
      "bonusApplyInputLabel": "배당 신청",
      "bonusApplyType1": "현재 기간",
      "100013": "비정상적인 매개 변수",
      "bonusApplyType2": "정기적",
      "btn": "배당 시작하기",
      "bonusApplyTitle": "배당 신청서",
      "bonusApplyInputErr2": "0보다 큰 입력 숫자는 현재 사용 가능한 배당금보다 적고 소수점 이하 2 자리까지",
      "bonusApplyTip1": "* 당신은 여전히 ​​융자 지불이있을 것입니다.",
      "200013": "종료일은 비워 둘 수 없습니다.",
      "bonusApplyInputErr1": "금액을 입력하십시오.",
      "bonusApplyTip2": "상환 필요",
      "200001": "로그인하지 않았습니다.",
      "bonusApplySuccess": "배당에 대한 성공적인 신청"
    },
    "login": {
      "rongziwei": "파이낸싱 어플리케이션은 특정 사용자 그룹에게 제공되는 블록 체인 가상 화폐 기술을 기반으로하는 대규모 B2B 고속 무역 파이낸싱 기능입니다.",
      "VerificationCodeMissing": "확인 코드를 입력하십시오.",
      "nameOrPwdError": "사용자 이름 또는 비밀번호가 잘못되었습니다.",
      "jiesheng": "전통적인 무역 신용장 비용 절감",
      "pleasePassword": "비밀번호를 입력하십시오.",
      "bushouxianzhi": "시간 및 지리적 제한을받지 않는 이전",
      "InvalidCaptchaKey": "만료 된 확인 코드 키",
      "title": "Jane에게 트랜잭션을 원활하게하십시오.",
      "login": "로그인",
      "myAcc": "내 계정",
      "pleaseUsername": "계좌 번호를 입력하십시오.",
      "logout": "로그 아웃",
      "myFinancing": "내 자금 조달",
      "xinyong": "신용 분리 가능",
      "nianlilv": "연간 결산율 3.1 %",
      "pleaseKaptcha": "확인 코드를 입력하십시오.",
      "validCodeError": "확인 코드가 잘못되었습니다.",
      "validCodeExpired": "확인 코드가 만료되었습니다.",
      "userNotExit": "사용자가 존재하지 않음",
      "loginDisabled": "계정이 비활성화되었습니다.",
      "fuwu": "이 서비스 사용에 관심이 있으시면 서비스 핫라인에 전화하십시오.",
      "coin": "동전"
    },
    "cashApply": {
      "exMoney": "철회 신청",
      "availableCredit": "사용 가능한 잔액",
      "select": "선택해주세요.",
      "bankCard": "은행 카드 인출",
      "sendCode": "인증 코드 전송",
      "available": "현재 출금 금액을 입력하십시오.",
      "title": "z 동전 인출 신청",
      "emCode": "수신 된 이메일 보안 인증 코드를 입력하십시오.",
      "cashApply": "철회 신청",
      "confCash": "철회 확인",
      "tips": "* 플랫폼은 수수료를 내지 않으며, 인출에 관련된 은행 수수료는 은행에서 징수하고 실제 계좌에서 공제됩니다.",
      "newBank": "+ 은행 카드 추가",
      "cashConf": "현금 인출 확인",
      "usable": "사용 가능",
      "sentSuccess": "확인 코드를 보내면 확인하려면 사서함으로 이동하십시오.",
      "moneyValue": "통화",
      "sumCredit": "내 동전의 총 금액",
      "useAmount": "Z 통화 인출 금액",
      "coin": "Z 동전"
    },
    "bank": {
      "300005": "영역이 비어 있지 않습니다.",
      "300016": "수취인 이름 최대 길이 100",
      "300017": "수취인 계정 최대 길이 100",
      "300006": "은행의 전체 이름은 비어 있지 않습니다.",
      "300003": "카드 번호가 반복됩니다. 다시 입력하십시오.",
      "300014": "신속한 코드 최대 길이 100",
      "300015": "수취인 이름 최대 길이 200",
      "300004": "로그인 정보가 비어 있지 않습니다.",
      "300009": "수취인 이름이 비어 있지 않습니다.",
      "300007": "신속한 코드가 비어 있지 않습니다.",
      "300018": "통화 최대 길이 100",
      "300019": "로그인 사용자 ID가 비어 있지 않습니다.",
      "300008": "은행 세부 주소가 비어 있지 않습니다.",
      "300020": "기본 키 ID가 비어 있지 않습니다.",
      "300023": "사용자 ID가 비어 있지 않습니다.",
      "300012": "국가 코드 최대 길이 200",
      "300001": "로그인하십시오",
      "300024": "데이터가 변경되었습니다. 페이지를 새로 고침하십시오.",
      "300002": "사용자 ID를 가져 오는 데 실패했습니다.",
      "300013": "은행 전체 이름 최대 길이 200",
      "300010": "수취인 계정이 비어 있지 않습니다.",
      "300011": "통화가 비어 있지 않습니다.",
      "300022": "카드 번호가 비어 있지 않습니다."
    },
    "chainDetails": {
      "add": "추가",
      "fileName": "파일 이름",
      "dataType": "데이터 유형",
      "clickToDownload": "다운로드하려면 클릭하십시오.",
      "fileInfo": "파일 정보",
      "update": "업데이트",
      "remark": "비고",
      "title": "제목",
      "completeInfo": "완전한 정보",
      "chainDetails": "블록 체인 세부 정보",
      "downloadLink": "주소 다운로드",
      "summaryInfo": "요약 정보",
      "dataOverview": "데이터 개요",
      "report": "보고서",
      "reportDescription": "보고서 설명",
      "lastData": "다음 데이터",
      "platformName": "플랫폼 이름",
      "value": "콘텐츠",
      "fileType": "파일 형식",
      "preData": "이전 데이터"
    },
    "bankList": {
      "cancel": "취소",
      "proceedName": "수취인 이름",
      "country": "지역",
      "bankFullName": "은행 이름",
      "bankCreate": "은행 카드 만들기",
      "swiftCode": "신속한 코드",
      "proceedAccount": "수취인 계정",
      "title": "은행 계좌 관리",
      "bankAdd": "계정 추가",
      "confirm": "결정",
      "delConf": "이 은행 계좌를 삭제 하시겠습니까?",
      "detailedAddress": "은행 세부 주소",
      "supportCurrency": "지원 통화"
    },
    "bonusLists": {
      "all": "모두",
      "originalMoneyTr": "배당 원금",
      "annualIncomeTr": "배당 수익률",
      "serialNumberTr": "흐르는 물 번호",
      "createTimeTr": "날짜",
      "lastInterestDateTr": "배당 결산일",
      "bonusListsTitle": "배당금 관리",
      "statusTr": "주",
      "detailTr": "세부 정보",
      "bonusListsApplyBtn": "배당 신청",
      "typeTr": "요약",
      "dividend": "배당금",
      "turnToLive": "돌아 서서 살기",
      "issued": "발급 된"
    },
    "extractCrashLists": {
      "all": "모두",
      "hasBeenTransferredOut": "전송 된",
      "flowNumberTr": "흐르는 물 번호",
      "createTimeTr": "날짜",
      "extractCrashListsTitle": "현금 인출 세부 정보",
      "statusTr": "주",
      "detailTr": "세부 정보",
      "withdrawalBankTr": "현금 인출 은행",
      "serviceChargeTr": "수수료",
      "application": "신청서",
      "amountExtractionTr": "출금 금액",
      "turnOutAmountTr": "양도 금액",
      "remarkTr": "요약"
    },
    "financing": {
      "all": "모두",
      "andTranscationg": "관련 거래",
      "financing_completed": "파이낸싱 완료",
      "financingaplicationAmount": "파이낸싱 신청 금액",
      "aplicationTime": "신청 시간",
      "application_status_repayment": "상환",
      "view": "검색어",
      "pleaseWrite": "입력하십시오.",
      "financingandOrderNum": "관련 주문 번호 파이낸싱",
      "draft": "초안",
      "function": "기능",
      "financingaplicationNum": "파이낸싱 신청 번호",
      "financing": "내 자금 조달",
      "startTime": "시작 시간",
      "noData": "데이터가 없습니다.",
      "financingStatus": "금융 상태",
      "details": "세부 정보",
      "endTime": "마감일",
      "reimbursement": "상환",
      "still_hospitality_confirmation": "아직도 환대 확인",
      "financingNumber": "일련 번호 파이낸싱",
      "status": "주",
      "coin": "동전"
    },
    "flowListsType": {
      "1": "전송",
      "2": "상환 자금 조달",
      "3": "배당금 전보",
      "4": "배당금 전보",
      "5": "파이낸싱 양도"
    },
    "resetpassword": {
      "newPasswordCannotSame": "새 암호가 원래 암호와 일치해서는 안됩니다.",
      "PasswordFormatIncorrect": "비밀번호 형식이 잘못되었습니다. 변경하십시오.",
      "newPasswordNotFormatted": "새 암호 길이의 형식이 잘못되었습니다. 변경하십시오.",
      "originalPasswordIncorrectly": "원래 암호가 잘못 입력되었습니다.",
      "passwordIsInconsistent": "암호가 확인 암호와 일치하지 않습니다."
    },
    "moneyChangeLog": {
      "100010": "시작일은 비워 둘 수 없습니다.",
      "100011": "종료일은 비워 둘 수 없습니다.",
      "100009": "데이터가 변경되었습니다. 페이지를 새로 고침하십시오.",
      "100001": "사용자 ID가 비어 있지 않습니다.",
      "100012": "인력 정보가 ​​비어 있습니다.",
      "100002": "요약 유형이있는 테이블의 1 차 키 ID가 비어 있지 않습니다.",
      "100013": "비정상적인 매개 변수",
      "100003": "요약 유형이 비어 있지 않습니다.",
      "100014": "비정상적인 데이터",
      "100004": "금액 유형이 비어 있지 않습니다.",
      "100005": "금액이 비어 있지 않습니다.",
      "100006": "로그인하십시오",
      "100007": "사용자 ID를 가져 오는 데 실패했습니다.",
      "100008": "흐름 데이터 내보내기 없음"
    },
    "bonusDetail": {
      "fh": "배당금",
      "tqzq": "추출 철수",
      "expectIncome": "예상 수익",
      "bj": "교장",
      "type": "배당 유형",
      "tips": "경고 : 잠금 해제가 미리 만료되지 않은 경우, 금전적 시간에 따라이자가 계산됩니다!",
      "200004": "비정상적인 데이터",
      "principal": "보안 주체 잠금 해제",
      "bonusRegularDetailTime": "시간",
      "unlockSuccess": "잠금 해제 됨",
      "tqSuccess": "성공적인 추출",
      "bonusRegularDetailStatus": "관심 분야 유형",
      "startAndEndTime": "배당 계획 시작 및 종료일",
      "lastInterestDate": "배당금 지급일",
      "interest": "실제 소득",
      "ljsy": "누적 소득",
      "bonusRegularDetailOriginalMoney": "교장",
      "jshzce": "잠금 해제 후 양도",
      "serialNumber": "흐르는 물 번호",
      "bonusRegularDetailInterest": "배당금",
      "jxr": "이자부 지원 일",
      "bonusDetailTitle": "배당금 명단",
      "tqTitle": "추출",
      "mrfhjsb": "일일 배당 명세서",
      "100009": "데이터가 변경되었습니다. 페이지를 새로 고침하십시오.",
      "bonusWay": "배당 계획",
      "dqjbe": "현재 기본 금액",
      "tqjsTitle": "미리 잠금 해제",
      "jsb": "결산 명세서",
      "originalMoney": "기본 배당금"
    },
    "nav": {
      "index": "내 계정"
    },
    "accountcenter": {
      "sendCodeMail": "현재 사서함에 확인 코드를 보냅니다.",
      "emailNotExist": "먼저 사서함을 설정하십시오.",
      "safeMail": "메일 박스 보안",
      "chainData": "개발 데이터",
      "bankCard": "은행 카드",
      "sendMailFrequently": "전자 메일을 자주 보내지 마십시오. 10 분이 소요됩니다.",
      "back": "반환",
      "missCode": "누락 된 확인 코드",
      "emailFormatError": "잘못된 사서함 형식",
      "lastMailTime": "마지막 전자 메일 시간",
      "sendEmailError": "전자 메일을 보낼 수 없습니다.",
      "lastMailType": "마지막으로 보냈습니다.",
      "manageBankCard": "은행 카드를 관리하다",
      "cofirm": "새 사서함을 확인하십시오.",
      "theEmailHasBeenUsed": "사서함이 사용되었습니다.",
      "accCenter": "kundencenter",
      "getWeb": "웹 사이트보기",
      "myBankCard": "내 은행 카드",
      "sendSuc": "성공적으로 보냈습니다.",
      "emailLengthError": "postfachl? ngenformatfehler",
      "safePhone": "보안 전화",
      "editEmailError": "사서함 업데이트 실패",
      "errorCodeTypeParam": "검사 코드 유형 매개 변수의 오류",
      "sendCOde": "확인 코드 전송",
      "missEmail": "사서함이 누락되었습니다.",
      "accSafe": "계정 보안",
      "missEmailParam": "사서함 매개 변수가 누락되었습니다.",
      "codeInvalid": "확인 코드가 만료되었습니다.",
      "blockChain": "블록 체인",
      "resetSuc": "성공적으로 수정 됨",
      "trade": "거래",
      "myTradeAcc": "나의 거래 계좌",
      "pleaseNewMail": "새 전자 메일 주소를 입력하십시오.",
      "pleaseCode": "확인 코드를 입력하십시오.",
      "safe": "보안",
      "codeError": "확인 코드 오류",
      "nextStep": "다음 단계",
      "youHaveBoundTheEmail": "그들이 묶은 사서함",
      "verifyMail": "보내",
      "resetMail": "사서함을 변경하십시오.",
      "cic": "세계상품스마트거래중심",
      "rongzi": "파이낸싱",
      "myWebAcc": "내 디지털 계정"
    },
    "financingDetails": {
      "seller": "판매자",
      "repaymentAmountLimit": "반제 금액으로 0보다 크고 1000000000보다 작은 숫자를 입력하십시오.",
      "reason": "이유",
      "amountLessThanAvailable": "상환 금액은 사용 가능한 잔액보다 클 수 없습니다.",
      "getFinancingDetailFail": "재무 세부 정보를 쿼리하지 못했습니다.",
      "pleaseSelectAcountCard": "상환 계정을 선택하십시오.",
      "lookrepaymentAmount": "상환 금액",
      "hasComfimed": "확인 됨",
      "financingContractInfor": "파이낸싱 계약 정보",
      "legalMoney": "법률 통화",
      "dueInfo": "상환 정보",
      "regCode": "등록 코드",
      "flowNumber": "파이낸싱 신청 일련 번호",
      "wrongAccount": "이 데이터를 볼 수있는 권한이 없습니다.",
      "financingMethod": "파이낸싱 방법",
      "expectedRepaymentPeriod": "예상 상환 기간",
      "isLocked": "릴리스 후 잠글지 여부",
      "doNotInsertRepaymentByState": "현재 금융 데이터의 상환 이력이 확인되거나 수정 될 수 있으며 추가가 허용되지 않습니다.",
      "acountMustInput": "상환 금액이 필요합니다.",
      "details": "세부 정보",
      "applicationAccount": "신청자 계정",
      "reimbursement": "상환",
      "comfirm": "결정",
      "repaymentAccountIdNotNull": "송금 계정은 비워 둘 수 없습니다.",
      "systemComfim": "시스템 확인",
      "companyCode": "회사 등록 코드를 입력하십시오.",
      "overdueAmount": "추가 상환 금액",
      "upLoadenclosureCode": "첨부 파일 업로드",
      "viewLook": "보기",
      "repaymentTypeNotNull": "상환 방법은 비워 둘 수 없습니다.",
      "authCodeStr": "인증 유형",
      "dueTime": "상환 시간",
      "salesOrder": "거래 판매 주문",
      "buyer": "구매자",
      "newdue": "신규 상환",
      "pleaseChoseBill": "통화를 선택하십시오.",
      "pleaseSelectPaymethod": "상환 방법을 선택하십시오.",
      "financingStartTime": "파이낸싱 시작일",
      "orderAcount": "주문 금액",
      "guaranteeType": "보증 유형",
      "financingUse": "파이낸싱 사용",
      "uploadAttachmentsNotEmpty": "첨부 파일은 비워 둘 수 없습니다.",
      "payeeAccountCanuseNow": "현재 사용 가능한 상환 금액",
      "repaymentAccount": "상환 계좌 자금 조달",
      "countryName": "국가",
      "payeeAccount": "송금 계좌",
      "coin": "동전",
      "addoverdueAmount": "추가 금액",
      "repaymentMethod": "상환 방법",
      "no": "아니요",
      "financingaplayBook": "파이낸싱 신청서",
      "currencyTypeNotNull": "통화는 비워 둘 수 없습니다.",
      "pleaseSelectremittanceA": "송금 계좌를 선택하십시오.",
      "currentAccountDoNotInsert": "현재 등록자는 상환 할 수 없습니다.",
      "enclosureCode": "첨부 파일",
      "repaymentAmountNotNull": "상환 금액은 비워 둘 수 없습니다.",
      "orderNum": "주문 번호",
      "dorla": "달러",
      "doNotInsertRepayment": "파이낸싱 주문이 완료되고 상환 주문을 추가 할 수 없습니다.",
      "grantAccount": "파이낸싱 발행 계좌",
      "financingEndTime": "파이낸싱 기한",
      "repaymentSource": "상환 출처",
      "newBusinessLicense": "새로운 비즈니스 라이센스",
      "additionalPaymentInfo": "추가 상환 정보",
      "aplicationFee": "이자",
      "applicationMoney": "신청 금액",
      "close": "닫기",
      "LockAcountNow": "현재 잠긴 z 통화",
      "certificateImage": "인증서 사진",
      "oldBusinessLicense": "구 사업 허가증",
      "dueMethods": "상환 방법",
      "financingApplicationInfor": "계약 신청 정보 파이낸싱",
      "yes": "예",
      "repaymentIdNotNull": "상환 흐름 ID는 비워 둘 수 없습니다.",
      "waitToModify": "수정 예정",
      "additionalPayments": "추가 상환 금액",
      "waitToComfim": "확인되지 않은",
      "billChoose": "통화 선택",
      "modify": "수정",
      "pleaseInputAmonut": "금액을 입력하십시오.",
      "financingMoney": "금융 금액",
      "createTime": "녹음 시간",
      "dueAmount": "상환 금액",
      "purchaseOrder": "거래 구매 주문",
      "pleaseUploadFile": "파일을 업로드하십시오.",
      "10001": "금액 입력이 잘못되었습니다.",
      "zCoin": "z 동전",
      "addremark": "추가 원인",
      "tradingContract": "거래 계약",
      "repaymentTime": "상환 시간",
      "fileUploadMaximumOf5": "최대 5 개의 파일 업로드",
      "return": "돌아 가기",
      "account": "계정"
    },
    "home": {
      "accountTotalMoney": "총 계정",
      "safeMail": "보안 확인 용 사서함",
      "getDicDataFailed": "사전 표의 데이터를 검색 할 수 없습니다.",
      "bonusShenqing": "배당금",
      "accFlowLists": "계정 흐름",
      "cashRecord": "구속 프로토콜",
      "accountcenter": "kundencenter",
      "accInfo": "계정 정보",
      "cashApply": "지불 요청",
      "bankAcc": "bankverbindung",
      "availableBalance": "사용 가능한 계정 잔액",
      "manage": "조치",
      "lastLoginTime": "마지막 로그인 시간",
      "bonusSuoding": "dividendensperre",
      "addAcc": "계정 추가",
      "bonusShouyi": "배당 개요",
      "contactNumber": "연락 번호",
      "languageCannotNull": "언어는 비워 둘 수 없다.",
      "lastRevenue": "최신 물",
      "fax": "팩스",
      "freezingQuota": "동결 견적",
      "contacts": "접촉",
      "bonusGuanli": "배당 관리"
    },
    "extractCrashStatus": {
      "0": "모두",
      "1": "신청서",
      "2": "전송 된"
    },
    "withdrawCash": {
      "400002": "현금 인출 통화를 선택하십시오.",
      "400013": "불충분 한 계정 잔액",
      "400003": "금액을 기입하십시오",
      "400014": "인증 코드 무효화",
      "400011": "현금 인출 권을 가지고 있지 않습니다.",
      "400001": "인증 코드를 입력하십시오.",
      "400012": "매개 변수 오류",
      "400010": "사서함을 설정하지 않았습니다. 보안 사서함을 설정하십시오.",
      "400008": "현금 인출 성공",
      "400009": "세부 정보 ID는 비워 둘 수 없습니다.",
      "400017": "데이터가 변경되었습니다. 페이지를 새로 고침하십시오.",
      "400006": "메일이 너무 자주 전송되었습니다. 나중에 다시 시도하십시오.",
      "400007": "인증 코드 입력 오류",
      "400015": "현금 인출 실패",
      "400004": "현금 카드를 선택하십시오.",
      "400016": "불법 현금 인출",
      "400005": "아직 데이터 내보내기가 없습니다."
    },
    "btns": {
      "cancel": "취소",
      "tqjs": "미리 잠금 해제",
      "ensureUnlock": "잠금 해제 확인",
      "query": "검색어",
      "detail": "세부 정보",
      "downLoadData": "데이터 다운로드",
      "ensureExtract": "추출 확인",
      "tq": "추출"
    },
    "depositStatus": {
      "0": "모두",
      "1": "배당금",
      "2": "발급 된",
      "3": "돌아 서서 살기"
    },
    "extractCrashDetail": {
      "proceedName": "수취인 이름",
      "remittanceDate": "송금 시간",
      "turnOutAmount": "송금액",
      "swiftCode": "SWIFT 코드를 현금화하십시오.",
      "bankName": "은행 이름",
      "proceedAccount": "수취인 계정",
      "transferBankAccount": "송금 계좌",
      "tips": "* 은행이 도착하지 않은 경우 은행 계좌 고객 서비스에 문의하십시오. 추가 문의 사항이 있으면 [+65 6379 1324]로 전화하십시오.",
      "amountExtraction": "철회 신청",
      "flowNumber": "현금 흐름 번호",
      "serviceCharge": "수수료",
      "detailedAddress": "은행 세부 주소",
      "moneyLable": "현금 인출 통화",
      "transferBankName": "송금 은행",
      "fileList": "이관 증명서",
      "extractCrashDetailTitle": "현금 인출 세부 정보"
    },
    "extractType": {
      "1": "은행 철수"
    },
    "depositType": {
      "1": "현재 기간",
      "2": "정기적"
    },
    "chaincount": {
      "all": "모두",
      "myHome": "내 계정",
      "serialNumber": "비즈니스 흐름 번호",
      "chainCount": "블록 체인 통계",
      "financingApply": "파이낸싱 신청서",
      "bonusApply": "배당 신청서",
      "profitBonus": "소득 배당",
      "handle": "가공",
      "fail": "실패",
      "appendRepayment": "추가 상환 자금 조달",
      "transferActivity": "전송 활동",
      "success": "성공",
      "chainSum": "총 권선 수",
      "details": "세부 정보",
      "state": "주",
      "day": "주간",
      "cash": "탈퇴",
      "chainTime": "권선 시간",
      "financingLoan": "파이낸싱 대출",
      "repayment": "상환 자금 조달"
    }
  },
  de: {
    "flowLists": {
      "flowNumber": "Nummer des fließenden Wassers",
      "incomeTr": "Einkommen",
      "flowListsTitle": "Flussdetail",
      "createTime": "Datum",
      "ebalanceAmount": "Balance",
      "detailTr": "Details",
      "remarkType": "Zusammenfassung",
      "expenditureTr": "Ausgaben"
    },
    "frontPage": {
      "Error404": "Der Pfad existiert nicht. Bitte überprüfen Sie, ob der Pfad korrekt ist.",
      "annualIncome": "Annualisiertes Einkommen",
      "z_currency": "z Münze",
      "missSendEmailType": "Fehlender Sende-Nachrichtentyp",
      "back": "Rückkehr",
      "UploadFailure": "Upload fehlgeschlagen",
      "CurrencyDollar": "Dollar",
      "updateEmailSendCode": "?ndern Sie den Postfachbest?tigungscode",
      "missEmailTemplate": "Fehlende Mail-Vorlage",
      "CurrencyHongKong": "Hongkong Dollar",
      "missSubject": "Fehlender Nachrichtenkopf",
      "noTime": "Nein",
      "missUserId": "Fehlende Benutzer-ID des Sendeziels",
      "missFile": "Fehlende Datei",
      "startTime": "Startzeit",
      "accountTypeMiss": "Benutzertyp darf nicht leer sein",
      "NotFile": "Das Dateiformat ist falsch, bitte erneut hochladen!",
      "login_timeout": "Die Anmeldezeit überschreitet",
      "Error500": "Die Systemausnahme, bitte wenden Sie sich an den Administrator!",
      "moneyArrivaNotice": "Ankündigung der Ankunft",
      "CurrencyJPY": "JPY",
      "missUserType": "Fehlender Benutzertyp",
      "selectTime": "Bitte wählen Sie die Uhrzeit aus",
      "miss_field_version": "Es fehlt die Versionsnummer",
      "fileCodeCannotEmpty": "Die eindeutige Dateikennung darf nicht leer sein",
      "uploadPersonNotNull": "Der Uploader darf nicht leer sein",
      "missEmail": "Fehlendes Postfach",
      "l_currency": "Rechtliche W?hrung",
      "missEmailParam": "Fehlende E-Mail-Parameter",
      "miss_token": "Es fehlt Token",
      "notPicType": "Kein Bildtyp",
      "youHaveNoPermission": "Sie sind nicht berechtigt, die Datei herunterzuladen",
      "fileIsNullOrDeleted": "Die Datei existiert nicht oder wurde gel?scht",
      "drawSendCode": "Code zur überprüfung der Auszahlung",
      "businessTypeCannotEmpty": "Die Dateiquelle darf nicht leer sein",
      "CurrencyRMB": "RMB",
      "checkFrontFileSafe": "Die Sicherheitsprüfung für das aktuell hochgeladene Bild ist fehlgeschlagen",
      "businessCodeCannotEmpty": "Die eindeutige Kennung der Dateiquelle darf nicht leer sein",
      "noData": "Noch keine Daten",
      "endTime": "Deadline",
      "time": "Zeit",
      "pleaseChoose": "Bitte wählen",
      "notEmpty": "Kann nicht leer sein",
      "CurrencySingapore": "Singapur",
      "status": "Zustand"
    },
    "bonusApply": {
      "200007": "Die Dividendengrunddaten sind anormal.",
      "bonusApplyInputPlaceHolder": "Aktueller umverteilbarer Saldo",
      "200006": "Der Antragsbetrag liegt über dem verfügbaren Dividendensaldo",
      "200009": "Fehler beim Funding eines Batch-Benutzerkontos",
      "200008": "Periodische Dividendenaktualisierung der Charge fehlgeschlagen",
      "200003": "Die Daten haben sich geändert, bitte aktualisieren Sie die Seite",
      "200002": "Sie haben Dividenden verboten. Bitte wenden Sie sich an den Administrator",
      "200005": "Der Überweisungsbetrag ist nicht leer!",
      "200004": "Die Daten sind nicht normal. Wenden Sie sich an den Systemadministrator",
      "200010": "Live-Dividenden für Batch-Benutzer sind fehlgeschlagen",
      "200012": "Das Startdatum darf nicht leer sein",
      "200011": "Die Daten der Benutzerkonten sind nicht normal",
      "bonusApplyInputLabel": "Dividende beantragen",
      "bonusApplyType1": "Aktueller Zeitraum",
      "100013": "Abnormaler Parameter",
      "bonusApplyType2": "Regelmäßig",
      "btn": "Fange an, Dividenden zu bekommen",
      "bonusApplyTitle": "Dividendenantrag",
      "bonusApplyInputErr2": "Eine Eingangsnummer größer als 0 ist kleiner als der aktuell verfügbare Dividend und bis zu 2 Dezimalstellen",
      "bonusApplyTip1": "* Sie haben noch eine Finanzierungszahlung",
      "200013": "Enddatum darf nicht leer sein",
      "bonusApplyInputErr1": "Bitte geben Sie den Betrag ein",
      "bonusApplyTip2": "Rückzahlung erforderlich",
      "200001": "Nicht angemeldet",
      "bonusApplySuccess": "Erfolgreiche Beantragung von Dividenden"
    },
    "login": {
      "VerificationCodeMissing": "Bitte geben Sie den Best?tigungscode ein",
      "rongziwei": "Die Finanzierungsanwendung ist eine umfangreiche b2b-Fast-Trade-Finanzierungsfunktion, die auf der virtuellen Währungstechnologie Blockchain basiert, die von cic für bestimmte Benutzergruppen bereitgestellt wird.",
      "nameOrPwdError": "Der Benutzername oder das Passwort ist falsch",
      "jiesheng": "Sparen Sie die Kosten herkömmlicher Handelskreditbriefe",
      "InvalidCaptchaKey": "Abgelaufener Best?tigungscode key",
      "pleasePassword": "Bitte geben Sie Ihr Passwort ein",
      "bushouxianzhi": "Übertragungen, die keinen zeitlichen und geographischen Beschränkungen unterliegen",
      "login": "Einloggen",
      "title": "Glätten Sie die Transaktion an Jane",
      "myAcc": "Mein konto",
      "pleaseUsername": "Bitte geben Sie eine Kontonummer ein",
      "logout": "Abmelden",
      "myFinancing": "Meine Finanzierung",
      "xinyong": "Guthaben abnehmbar",
      "pleaseKaptcha": "Bitte geben Sie den Best?tigungscode ein",
      "nianlilv": "Jährliche Finanzierungsrate von 3,1%",
      "validCodeError": "Der Best?tigungscode ist falsch",
      "validCodeExpired": "Der Best?tigungscode ist abgelaufen",
      "userNotExit": "Benutzer existiert nicht",
      "loginDisabled": "Konto wurde deaktiviert",
      "fuwu": "Wenn Sie diesen Service nutzen möchten, rufen Sie die Service-Hotline an.",
      "coin": "Münze"
    },
    "cashApply": {
      "exMoney": "Rücknahme beantragen",
      "availableCredit": "Verfügbarer Kontostand",
      "select": "Bitte wählen",
      "bankCard": "Auszahlung der Bankkarte",
      "sendCode": "Bestätigungscode senden",
      "available": "Bitte geben Sie den Auszahlungsbetrag aktuell ein",
      "title": "z Münzauszahlungsantrag",
      "emCode": "Bitte geben Sie den erhaltenen Sicherheitscode für die E-Mail ein",
      "cashApply": "Rücknahme beantragen",
      "confCash": "Rücknahme bestätigen",
      "tips": "* Die Plattform erhebt keine Gebühren. Die mit der Auszahlung verbundenen Bankgebühren werden von der Bank eingezogen und vom tatsächlichen Konto abgebucht.",
      "newBank": "+ Fügen Sie eine Bankkarte hinzu",
      "cashConf": "Barabhebungsbestätigung",
      "usable": "Verfügbar",
      "sentSuccess": "Das Senden des Bestätigungscodes ist erfolgreich. Bitte rufen Sie das Postfach auf",
      "moneyValue": "Währung",
      "sumCredit": "Meine Gesamtmenge an c-Münzen",
      "useAmount": "Z Währungsauszahlungsbetrag",
      "coin": "Z-Münze"
    },
    "bank": {
      "300005": "Der Bereich ist nicht leer",
      "300016": "Maximale Länge des Zahlungsempfängers 100",
      "300017": "Maximale Länge des Zahlungsempfängers 100",
      "300006": "Der vollständige Name der Bank ist nicht leer",
      "300003": "Die Kartennummer wird wiederholt, bitte erneut eingeben",
      "300014": "Maximale Länge des schnellen Codes 100",
      "300015": "Maximale Länge des Empfängers 200",
      "300004": "Anmeldeinformationen sind nicht leer",
      "300009": "Der Name des Zahlungsempfängers ist nicht leer",
      "300007": "Der Schnellcode ist nicht leer",
      "300018": "Maximale Länge der Währung 100",
      "300019": "Anmelde-ID ist nicht leer",
      "300008": "Bank Adresse ist nicht leer",
      "300020": "Primärschlüssel-ID ist nicht leer",
      "300023": "Benutzer-ID ist nicht leer",
      "300012": "Ländercode maximale Länge 200",
      "300001": "Bitte einloggen",
      "300024": "Die Daten haben sich geändert, bitte aktualisieren Sie die Seite",
      "300002": "Benutzer-ID konnte nicht abgerufen werden",
      "300013": "Bank voller Name maximale Länge 200",
      "300010": "Das Konto des Zahlungsempfängers ist nicht leer",
      "300011": "Währung ist nicht leer",
      "300022": "Die Kartennummer ist nicht leer"
    },
    "chainDetails": {
      "add": "Hinzufügen",
      "fileName": "Dateiname",
      "dataType": "Datentyp",
      "clickToDownload": "Klicken Sie zum Herunterladen",
      "fileInfo": "Dateiinformationen",
      "update": "Aktualisieren",
      "remark": "Bemerkungen",
      "title": "Titel",
      "completeInfo": "Vollständige Informationen",
      "chainDetails": "Blockchain-Details",
      "downloadLink": "Adresse herunterladen",
      "summaryInfo": "Zusammenfassende Informationen",
      "dataOverview": "Datenübersicht",
      "report": "Bericht",
      "reportDescription": "Beschreibung des Berichts",
      "lastData": "Nächste Daten",
      "platformName": "Plattformname",
      "value": "Inhalt",
      "fileType": "Dateityp",
      "preData": "Vorherige Daten"
    },
    "bankList": {
      "cancel": "Abbrechen",
      "proceedName": "Name des Zahlungsempfängers",
      "country": "Bereich",
      "bankFullName": "Bank voller Name",
      "bankCreate": "Erstellen Sie eine Bankkarte",
      "swiftCode": "Schneller Code",
      "proceedAccount": "Zahlungsempfänger",
      "title": "Bankkontenverwaltung",
      "bankAdd": "Konto hinzufügen",
      "confirm": "Bestimmen Sie",
      "delConf": "Möchten Sie dieses Bankkonto wirklich löschen?",
      "detailedAddress": "Bank detaillierte Adresse",
      "supportCurrency": "Stützwährung"
    },
    "bonusLists": {
      "all": "Alle",
      "originalMoneyTr": "Dividendenkapital",
      "annualIncomeTr": "Dividendenrendite",
      "serialNumberTr": "Nummer des fließenden Wassers",
      "createTimeTr": "Datum",
      "lastInterestDateTr": "Datum der Dividendenabrechnung",
      "bonusListsTitle": "Dividendenmanagement",
      "statusTr": "Zustand",
      "detailTr": "Details",
      "bonusListsApplyBtn": "Dividende beantragen",
      "typeTr": "Zusammenfassung",
      "dividend": "Dividende",
      "turnToLive": "Wende dich zu leben",
      "issued": "Ausgestellt"
    },
    "extractCrashLists": {
      "all": "Alle",
      "hasBeenTransferredOut": "Wurde übertragen",
      "flowNumberTr": "Nummer des fließenden Wassers",
      "createTimeTr": "Datum",
      "extractCrashListsTitle": "Angaben zur Bargeldabhebung",
      "statusTr": "Zustand",
      "detailTr": "Details",
      "withdrawalBankTr": "Bargeldabhebung Bank",
      "serviceChargeTr": "Bearbeitungsgebühr",
      "application": "Anwendung",
      "amountExtractionTr": "Auszahlungsbetrag",
      "turnOutAmountTr": "Überweisungsbetrag",
      "remarkTr": "Zusammenfassung"
    },
    "financing": {
      "all": "Alle",
      "andTranscationg": "Transaktion mit verbundenen Parteien",
      "financing_completed": "Finanzierung abgeschlossen",
      "financingaplicationAmount": "Betrag des Finanzierungsantrags",
      "aplicationTime": "Bewerbungszeit",
      "application_status_repayment": "Rückzahlung",
      "view": "Abfrage",
      "pleaseWrite": "Bitte eingeben",
      "financingandOrderNum": "Finanzierung zugehörige Bestellnummer",
      "draft": "Entwurf",
      "function": "Funktion",
      "financingaplicationNum": "Nummer der Finanzierungsanträge",
      "financing": "Meine Finanzierung",
      "startTime": "Startzeit",
      "noData": "Noch keine Daten",
      "financingStatus": "Finanzierungsstatus",
      "details": "Details",
      "endTime": "Deadline",
      "reimbursement": "Rückzahlung",
      "still_hospitality_confirmation": "Immer noch Bestätigung der Gastfreundschaft",
      "financingNumber": "Seriennummer der Finanzierung",
      "status": "Zustand",
      "coin": "Münze"
    },
    "flowListsType": {
      "1": "Übertragen",
      "2": "Finanzierung Rückzahlung",
      "3": "Dividendenübertragung",
      "4": "Dividendenübertragung",
      "5": "Finanzierungstransfer"
    },
    "resetpassword": {
      "newPasswordCannotSame": "Das neue Passwort darf nicht mit dem ursprünglichen Passwort übereinstimmen",
      "PasswordFormatIncorrect": "Das Passwortformat ist falsch, bitte ?ndern Sie es",
      "newPasswordNotFormatted": "Die neue Passwortl?nge ist nicht korrekt formatiert, bitte ?ndern",
      "originalPasswordIncorrectly": "Das ursprüngliche Passwort wurde falsch eingegeben.",
      "passwordIsInconsistent": "Das Passwort stimmt nicht mit dem Best?tigungspasswort überein"
    },
    "moneyChangeLog": {
      "100010": "Das Startdatum darf nicht leer sein",
      "100011": "Enddatum darf nicht leer sein",
      "100009": "Die Daten haben sich geändert, bitte aktualisieren Sie die Seite",
      "100001": "Benutzer-ID ist nicht leer",
      "100012": "Personalinformationen sind leer",
      "100002": "Die Primärschlüssel-ID der Tabelle, in der sich der Zusammenfassungstyp befindet, ist nicht leer.",
      "100013": "Abnormaler Parameter",
      "100003": "Zusammenfassungstyp ist nicht leer",
      "100014": "Anormale Daten",
      "100004": "Der Betragstyp ist nicht leer",
      "100005": "Der Betrag ist nicht leer",
      "100006": "Bitte einloggen",
      "100007": "Benutzer-ID konnte nicht abgerufen werden",
      "100008": "Kein Fließdatenexport"
    },
    "bonusDetail": {
      "fh": "Dividende",
      "tqzq": "Extraktionsentnahme",
      "expectIncome": "Erwartete Rückkehr",
      "bj": "Auftraggeber",
      "type": "Art der Dividende",
      "tips": "Achtung: Wenn die Entsperrung nicht im Voraus abgelaufen ist, werden die Zinsen entsprechend der finanziellen Zeit berechnet!",
      "200004": "Anormale Daten",
      "principal": "Schalte den Prinzipal frei",
      "bonusRegularDetailTime": "Zeit",
      "unlockSuccess": "Erfolgreich freigeschaltet",
      "tqSuccess": "Erfolgreiche Extraktion",
      "bonusRegularDetailStatus": "Art des Interesses",
      "startAndEndTime": "Start- und Enddatum des Dividendenplans",
      "lastInterestDate": "Datum der Dividendenzahlung",
      "interest": "Tatsächliches Einkommen",
      "ljsy": "Kumuliertes Einkommen",
      "bonusRegularDetailOriginalMoney": "Auftraggeber",
      "jshzce": "Überweisungsbetrag nach dem Entsperren",
      "serialNumber": "Nummer des fließenden Wassers",
      "bonusRegularDetailInterest": "Dividende",
      "jxr": "Verzinslicher Tag",
      "bonusDetailTitle": "Dividendenliste",
      "tqTitle": "Extraktion",
      "mrfhjsb": "Tägliche Dividendenaussage",
      "100009": "Die Daten haben sich geändert, bitte aktualisieren Sie die Seite",
      "bonusWay": "Dividendenplan",
      "dqjbe": "Aktueller Grundbetrag",
      "tqjsTitle": "Entsperren Sie im Voraus",
      "jsb": "Abrechnungsaussage",
      "originalMoney": "Grunddividende"
    },
    "nav": {
      "index": "Mein konto"
    },
    "accountcenter": {
      "emailNotExist": "Bitte stellen Sie zuerst die Mailbox ein",
      "sendCodeMail": "Best?tigungscode an das aktuelle Postfach senden",
      "safeMail": "Sicheres Postfach",
      "chainData": "Wicklungsdaten",
      "bankCard": "Bankkarte",
      "sendMailFrequently": "Senden Sie keine E-Mails h?ufig, es dauert 10 Minuten",
      "missCode": "Fehlender Best?tigungscode",
      "emailFormatError": "Falsches Postfachformat",
      "back": "Rückkehr",
      "lastMailTime": "Letzte E-Mail-Zeit",
      "sendEmailError": "E-Mail konnte nicht gesendet werden",
      "lastMailType": "Zuletzt verschickt",
      "theEmailHasBeenUsed": "Die Mailbox wurde verwendet",
      "manageBankCard": "Bankkarte verwalten",
      "cofirm": "Bitte überprüfen Sie die neue Mailbox",
      "accCenter": "Kundencenter",
      "getWeb": "Website anzeigen",
      "myBankCard": "Meine Bankkarte",
      "emailLengthError": "Postfachl?ngenformatfehler",
      "sendSuc": "Erfolgreich gesendet",
      "safePhone": "Sicheres Telefon",
      "editEmailError": "Update-Postfach fehlgeschlagen",
      "errorCodeTypeParam": "Fehler des überprüfungscodetypparameters",
      "missEmail": "Fehlendes Postfach",
      "sendCOde": "Best?tigungscode senden",
      "missEmailParam": "Fehlende Postfachparameter",
      "accSafe": "Kontosicherheit",
      "codeInvalid": "Der Best?tigungscode ist abgelaufen",
      "blockChain": "Blockchain",
      "resetSuc": "Erfolgreich geändert",
      "trade": "Transaktion",
      "myTradeAcc": "Mein Handelskonto",
      "pleaseNewMail": "Bitte geben Sie eine neue E-Mail-Adresse ein",
      "pleaseCode": "Bitte geben Sie den Best?tigungscode ein",
      "codeError": "Fehler beim Best?tigungscode",
      "safe": "Sicherheit",
      "youHaveBoundTheEmail": "Die Mailbox, die Sie gebunden haben",
      "nextStep": "N?chster Schritt",
      "verifyMail": "Senden",
      "resetMail": "Postfach ?ndern",
      "cic": "World Commodity Intelligence Trading Center",
      "myWebAcc": "Mein digitales Konto",
      "rongzi": "Finanzierung"
    },
    "financingDetails": {
      "seller": "Verkäufer",
      "repaymentAmountLimit": "Bitte geben Sie eine Zahl größer als 0 und weniger als 1000000000 für den Rückzahlungsbetrag ein.",
      "reason": "Grund",
      "amountLessThanAvailable": "Der Rückzahlungsbetrag kann nicht höher sein als der verfügbare Restbetrag",
      "getFinancingDetailFail": "Fehler beim Abfragen der Finanzierungsdetails",
      "pleaseSelectAcountCard": "Bitte wählen Sie ein Rückzahlungskonto",
      "lookrepaymentAmount": "Rückzahlungsbetrag",
      "hasComfimed": "Bestätigt",
      "financingContractInfor": "Informationen zum Finanzierungsvertrag",
      "legalMoney": "Rechtliche Währung",
      "dueInfo": "Rückzahlungsinformationen",
      "regCode": "Registrierungscode",
      "flowNumber": "Seriennummer des Finanzierungsantrags",
      "wrongAccount": "Sie haben keine Berechtigung, diese Daten anzuzeigen",
      "financingMethod": "Finanzierungsmethode",
      "expectedRepaymentPeriod": "Voraussichtliche Rückzahlungsfrist",
      "isLocked": "Ob nach Freigabe gesperrt werden",
      "doNotInsertRepaymentByState": "Rückzahlungsverlauf der aktuellen Finanzierungsdaten, die bestätigt oder geändert werden müssen, darf nicht hinzugefügt werden",
      "acountMustInput": "Rückzahlungsbetrag ist erforderlich",
      "details": "Details",
      "applicationAccount": "Konto des Antragstellers",
      "reimbursement": "Rückzahlung",
      "comfirm": "Bestimmen Sie",
      "repaymentAccountIdNotNull": "Überweisungskonto kann nicht leer sein",
      "systemComfim": "Systembestätigung",
      "companyCode": "Bitte geben Sie den Firmenregistrierungscode ein",
      "overdueAmount": "Zusätzlicher Rückzahlungsbetrag",
      "upLoadenclosureCode": "Anhang hochladen",
      "viewLook": "Ansicht",
      "repaymentTypeNotNull": "Die Rückzahlungsmethode darf nicht leer sein",
      "authCodeStr": "Authentifizierungstyp",
      "dueTime": "Rückzahlungszeit",
      "salesOrder": "Transaktionsauftrag",
      "buyer": "Käufer",
      "newdue": "Neue Rückzahlung",
      "pleaseChoseBill": "Bitte wähle eine Währung aus",
      "pleaseSelectPaymethod": "Bitte wählen Sie die Rückzahlungsmethode",
      "financingStartTime": "Startdatum der Finanzierung",
      "orderAcount": "Bestellmenge",
      "guaranteeType": "Art der Garantie",
      "financingUse": "Finanzierung verwenden",
      "uploadAttachmentsNotEmpty": "Anlage darf nicht leer sein",
      "payeeAccountCanuseNow": "Derzeitiger Rückzahlungsbetrag",
      "repaymentAccount": "Rückzahlung Konto finanzieren",
      "countryName": "Land",
      "payeeAccount": "Überweisungskonto",
      "coin": "Münze",
      "addoverdueAmount": "Zusätzlicher Betrag",
      "repaymentMethod": "Rückzahlungsmethode",
      "no": "Nein",
      "financingaplayBook": "Finanzierungsantrag",
      "currencyTypeNotNull": "Die Währung darf nicht leer sein",
      "pleaseSelectremittanceA": "Bitte wählen Sie ein Überweisungskonto",
      "currentAccountDoNotInsert": "Der aktuelle Registrant kann nicht zurückzahlen",
      "enclosureCode": "Anlage",
      "repaymentAmountNotNull": "Rückzahlungsbetrag kann nicht leer sein",
      "orderNum": "Bestellnummer",
      "dorla": "Dollar",
      "doNotInsertRepayment": "Der Finanzierungsauftrag wurde abgeschlossen und der Rückzahlungsauftrag kann nicht hinzugefügt werden.",
      "grantAccount": "Konto zur Finanzierung der Finanzierung",
      "financingEndTime": "Finanzierung Fälligkeitsdatum",
      "repaymentSource": "Rückzahlungsquelle",
      "newBusinessLicense": "Neue Geschäftslizenz",
      "additionalPaymentInfo": "Zusätzliche Rückzahlungsinformationen",
      "aplicationFee": "Interesse",
      "applicationMoney": "Auftragsmenge",
      "close": "Schliessen",
      "LockAcountNow": "Derzeit gesperrte Z-Währung",
      "certificateImage": "Zertifikat Bild",
      "oldBusinessLicense": "Alte Gewerbeschein",
      "dueMethods": "Rückzahlungsmethode",
      "financingApplicationInfor": "Informationen zu Finanzierungsanträgen",
      "yes": "Ja",
      "repaymentIdNotNull": "Rückzahlungs-ID darf nicht leer sein",
      "waitToModify": "Geändert werden",
      "additionalPayments": "Zusätzlicher Rückzahlungsbetrag",
      "waitToComfim": "Nicht bestätigt",
      "billChoose": "Währungsauswahl",
      "modify": "Ändern",
      "pleaseInputAmonut": "Bitte geben Sie den Betrag ein",
      "financingMoney": "Finanzierungsbetrag",
      "createTime": "Aufnahmezeit",
      "dueAmount": "Rückzahlungsbetrag",
      "purchaseOrder": "Transaktionsbestellung",
      "pleaseUploadFile": "Bitte laden Sie eine Datei hoch",
      "10001": "Der eingegebene Betrag ist illegal",
      "zCoin": "z Münze",
      "addremark": "Zusätzlicher Grund",
      "tradingContract": "Transaktionsvertrag",
      "repaymentTime": "Rückzahlungszeit",
      "fileUploadMaximumOf5": "Laden Sie bis zu 5 Dateien hoch",
      "return": "Rückkehr",
      "account": "Konto"
    },
    "home": {
      "accountTotalMoney": "Gesamtkonto",
      "safeMail": "Postfach für die Sicherheitsüberprüfung",
      "getDicDataFailed": "Daten aus der Dictionary-Tabelle konnten nicht abgerufen werden",
      "bonusShenqing": "Dividendenantrag",
      "accFlowLists": "Kontofluss",
      "cashRecord": "Rücknahmeprotokoll",
      "bankAcc": "Bankverbindung",
      "accInfo": "Kontoinformationen",
      "cashApply": "Antrag auf Auszahlung",
      "accountcenter": "Kundencenter",
      "availableBalance": "Verfügbarer Kontostand",
      "manage": "Management",
      "lastLoginTime": "Letzte Login-Zeit",
      "bonusSuoding": "Dividendensperre",
      "addAcc": "Konto hinzufügen",
      "contactNumber": "Kontaktnummer",
      "bonusShouyi": "Dividendeneinkommen",
      "languageCannotNull": "Sprache darf nicht leer sein",
      "lastRevenue": "Das neueste Wasser",
      "fax": "Fax",
      "freezingQuota": "Quote einfrieren",
      "contacts": "Kontakt",
      "bonusGuanli": "Dividendenmanagement"
    },
    "extractCrashStatus": {
      "0": "Alle",
      "1": "Anwendung",
      "2": "Wurde übertragen"
    },
    "withdrawCash": {
      "400002": "Bitte wählen Sie die Bargeldauszahlungswährung",
      "400013": "Unzureichender Kontostand",
      "400003": "Bitte geben Sie den Geldbetrag ein",
      "400014": "Ungültigerklärung des Bestätigungscodes",
      "400011": "Hat kein Bargeldabhebungsrecht",
      "400001": "Bitte geben Sie den Bestätigungscode ein",
      "400012": "Parameterfehler",
      "400010": "Haben Sie keine Mailbox eingerichtet, richten Sie bitte eine sichere Mailbox ein",
      "400008": "Bargeldabhebungserfolg",
      "400009": "Die Details-ID darf nicht leer sein",
      "400017": "Die Daten haben sich geändert, bitte aktualisieren Sie die Seite",
      "400006": "E-Mail wird zu häufig gesendet. Bitte versuchen Sie es später erneut",
      "400007": "Fehler bei der Eingabe des Bestätigungscodes",
      "400015": "Ausfall der Bargeldabhebung",
      "400004": "Bitte wählen Sie eine EC-Karte",
      "400016": "Illegale Bargeldabhebung",
      "400005": "Noch kein Datenexport"
    },
    "btns": {
      "cancel": "Abbrechen",
      "tqjs": "Entsperren Sie im Voraus",
      "ensureUnlock": "Entsperren bestätigen",
      "query": "Abfrage",
      "detail": "Details",
      "downLoadData": "Daten herunterladen",
      "ensureExtract": "Extraktion bestätigen",
      "tq": "Extraktion"
    },
    "depositStatus": {
      "0": "Alle",
      "1": "Dividende",
      "2": "Ausgestellt",
      "3": "Wende dich zu leben"
    },
    "extractCrashDetail": {
      "proceedName": "Name des Zahlungsempfängers",
      "remittanceDate": "Überweisungszeit",
      "turnOutAmount": "Betrag der Überweisung",
      "swiftCode": "SWIFT-Code ausbezahlen",
      "bankName": "Bank voller Name",
      "proceedAccount": "Zahlungsempfänger",
      "transferBankAccount": "Überweisungskonto",
      "tips": "* Wenn die Bank noch nicht eingetroffen ist, wenden Sie sich bitte an Ihren Bankkundendienst, wenn Sie weitere Fragen haben, rufen Sie bitte an:",
      "amountExtraction": "Rücknahme beantragen",
      "flowNumber": "Cashflow-Nummer",
      "serviceCharge": "Bearbeitungsgebühr",
      "detailedAddress": "Bank detaillierte Adresse",
      "moneyLable": "Bargeldabhebungswährung",
      "transferBankName": "Überweisungsbank",
      "fileList": "Zertifikat übergeben",
      "extractCrashDetailTitle": "Angaben zur Bargeldabhebung"
    },
    "extractType": {
      "1": "Bankabhebung"
    },
    "depositType": {
      "1": "Aktueller Zeitraum",
      "2": "Regelmäßig"
    },
    "chaincount": {
      "all": "Alle",
      "myHome": "Mein konto",
      "serialNumber": "Nummer des Geschäftsablaufs",
      "chainCount": "Blockchain-Statistiken",
      "financingApply": "Finanzierungsantrag",
      "bonusApply": "Dividendenantrag",
      "profitBonus": "Einkommensdividende",
      "handle": "Verarbeitung",
      "fail": "Fehler",
      "appendRepayment": "Finanzierung zusätzliche Rückzahlung",
      "transferActivity": "Übertragungsaktivität",
      "success": "Erfolg",
      "chainSum": "Gesamtzahl der Wicklungen",
      "details": "Details",
      "state": "Zustand",
      "day": "Tag",
      "cash": "Rücktritt",
      "chainTime": "Wickelzeit",
      "financingLoan": "Finanzierungskredit",
      "repayment": "Finanzierung Rückzahlung"
    }
  }
}

export default new VueI18n({
  locale: lang, // set locale
  messages,
  silentTranslationWarn: true
})
